export const fr = {
  app_name: 'Guestadom',
  welcome: 'Bienvenue !',
  'welcome-title':
    'Enregistrez dès maintenant votre mot de passe pour découvrir votre portail hôte et l’estimation de vos revenus locatifs.',
  500: 'Une erreur imprévue est survenue',
  404: 'La ressource demandée est introuvable',
  403: 'Ressource interdite',
  home: 'Dashboard',
  home_owner: 'Accueil',
  paginator_template_1: 'Affichage de',
  paginator_template_2: 'résultats sur',
  back: 'Retour',
  cancel: 'Annuler',
  apply: 'Appliquer',
  cancel_confirm_title: 'Annuler les modifications',
  cancel_confirm_message: "Êtes-vous sur de vouloir annuler ? Vous perdrez l'ensemble de vos modifications.",
  elements: '{0} élements',
  status_plural: '{0} statuts',
  send: 'Envoyer',
  modify: 'Modifier',
  filesNbr: 'Nombre de fichiers',
  yes: 'Oui',
  yes_delete: 'Oui, supprimer',
  confirm: 'Confirmer',
  no: 'Non',
  at: 'à',
  export: 'Exporter',
  export_done: 'Export terminé',
  exporting: "En cours d'export",
  export_in_progress: 'Export en cours.. Merci de patienter.',
  currently_loading: 'En cours de chargement',
  comments: 'Aucun commentaire | 1 commentaire | {count} commentaires',
  addComment: 'Ajouter un commentaire',
  commentAdded: 'Commentaire ajouté',
  filesNb: 'Aucun fichier | 1 fichier | {count} fichiers',
  prev: 'Précédent',
  next: 'Suivant',
  enabled_only: 'Uniquement les actifs',
  disabled_only: 'Uniquement les inactifs',
  all: 'Tous',
  my_notification: 'Mes notifications',
  notification: 'Notifications',
  waiting_since: 'En attente depuis',
  done_since: 'Réalisé le',
  download: 'Télécharger',
  next_save: 'Enregistrer et continuer',
  continue: 'Continuer',
  created_at: 'Créé le',
  online_at: 'Mis en ligne le',
  date_created: 'Création',
  created_by: 'Créé par',
  validate: 'Valider',
  submit: 'Soumettre',
  start: 'Démarrer',
  reply: 'Répondre',
  synchronize: 'Synchroniser',
  synchronized: 'Synchronisation effectuée',
  synchronized_smily: 'Données synchronisées sur Smily',
  synchronized_airbnb: 'Données synchronisées sur Airbnb',
  synchronized_ota: 'Données synchronisées sur les OTA',
  synchronizing: 'Synchronisation en cours...',
  dissociate_platform: 'Dissocier',
  dissociating: 'Dissociation en cours...',
  dissociated: 'Logement dissocié',
  confirm_dissociate:
    'Êtes-vous sûr de vouloir dissocier ce logement de cette plateforme ? Il pourra être resynchronisé ensuite.',
  generating: 'Génération en cours',
  associate: 'Associer',
  dissociate: 'Dissocier',
  enable: 'Activer',
  disable: 'Désactiver',
  enabled: 'Activé',
  disabled: 'Désactivé',
  hide: 'Masquer',
  filter_all: 'Tous les filtres',
  updated: 'Sauvegarde effectuée',
  confirm_dialog: 'Confirmation',
  delete_dialog: 'Confirmation de suppression',
  deactivate_dialog: 'Confirmation de désactivation',
  dissociate_dialog: 'Confirmation de dissociation',
  submit_dialog: 'Confirmation de soumission',
  validate_dialog: 'Confirmation de validation',
  refuse_dialog: 'Confirmation de refus',
  delete_confirm: 'Êtes-vous sûr de vouloir supprimer {item} ?',
  list_template: '{first}-{last} sur {totalRecords} items',
  field_required: 'Le champ {0} est requis',
  same_as_failed: 'Merci de vérifier les deux mots de passe',
  error_min_date: 'Le champ {0} dépasse la date minimale autorisée',
  error_max_date: 'Le champ {0} dépasse la date maximale autorisée',
  bad_format: "Le format du champ {0} n'est pas correct",
  char_forbidden: "Le caractère {0} n'est pas autorisé",
  check_phone_number:
    'Le format du numéro de téléphone est invalide. Veuillez entrer un numéro au format valide (ex. : +33 6 12 34 56 78)',
  check_iban_number: "Merci de vérifier le format du numéro d'iban",
  check_bic_number: 'Merci de vérifier le format du numéro de bic',
  bad_text_format:
    'Le champ ne doit ni commencer, ni finir par un espace et ne doit pas contenir de caractères spéciaux',
  check_url: "Merci de vérifier le format de l'adresse URL",
  key_already_used: 'Ce champ est déjà utilisé',
  max_length_no_bound: 'Le champ {0} dépasse la limite autorisée',
  max_length: 'Le champ {0} doit faire au maximum {1} caractères',
  min_length: 'Le champ {0} doit faire au minimum {1} caractères',
  min_length_elements: 'Le champ {0} doit contenir au minimum {1} éléments',
  min_max_length: 'Le champ {0} doit faire entre {1} et {2} caractères',
  resolution_value: 'La résolution doit être supérieure à {0} par {1} pixels',
  min_max_value: 'Le champ {0} doit être compris entre {1} et {2}',
  min_value: 'Le champ {0} doit être supérieur ou égal à {1}',
  max_value: 'Le champ {0} doit être inférieur ou égal à {1}',
  bad_type: 'Le champ {0} doit être {1}',
  type_integer: 'un nombre entier',
  login_not_found: 'Utilisateur inconnu, merci de vérifier vos identifiants',
  bad_pwd: 'Merci de vérifier votre mot de passe',
  reset_pwd_err: 'Les deux mots de passe doivent être identiques',
  jwt_expire: 'Délai dépassé, merci de retourner sur la page de connexion et faire mot de passe oublié',
  jwt_expire_info:
    'Le délai pour modifier votre mot de passe est dépassé. Merci de retourner sur la page de connexion, et de cliquer sur mot de passe oublié.',
  otp_expired_resend: 'Code expiré, un nouveau code vous a été envoyé',
  otp_bad_code: 'Code incorrect, veuillez réessayer',
  not_enabled: 'Votre compte est desactivé, merci de contacter le service client pour plus de renseignements',
  two_factor_title: 'Vérification en deux étapes',
  two_factor_subtitle: "Saisissez le code à 6 chiffres généré par votre application d'authentification.",
  unauthorized_cleaner: "Profil 'Cleaner' non autorisé",
  unauthorized_prestataire: "Profil 'Prestataire' non autorisé",
  physical_arivee: 'Arrivée physique',
  owner_reservation: 'Réservation hôte seulement',
  include_tentative: "Ajouter les demandes d'informations",
  unknow_error: 'Une erreur est survenue',
  date_error: 'Veuillez vérifier les dates de début et de fin',
  pwd_current: 'Mot de passe actuel',
  pwd_new1: 'Création du mot de passe',
  pwd_new2: 'Confirmation du mot de passe',
  email_new1: 'Nouvelle adresse mail',
  email_new2: 'Répéter la nouvelle adresse mail',
  sign_in: 'Se connecter',
  pwd_forget: 'Mot de passe oublié ?',
  pwd_forget_enter_mail: 'Saisissez votre adresse mail',
  add: 'Ajouter',
  create: 'Créer',
  update: 'Modifier',
  delete: 'Supprimer',
  save: 'Sauvegarder',
  sign_ok: "J'ai signé",
  sign_gav_ok: 'Mandat de gestion signé',
  refuse: 'Refuser',
  update_dialog: 'Mise à jour',
  undefined: 'Non défini',
  choose_file: 'Choisir',
  add_file: 'Ajouter',
  add_picture_onboarding: 'Ajouter une photo du logement',
  import_file: 'Importer',
  cancel_file: 'Annuler',
  details: 'Détails',
  files: 'Pièces jointes',
  my_files: 'Mes pièces jointes',

  contracts: 'Contrats/Avenants',
  restrictions: 'Restrictions',
  epi: 'EPI',
  absences: 'Absences',
  activities: 'Communication',
  unavailabilities: 'Indisponibilités fixes',
  support: 'Support',
  purchase: 'Factures',
  status: 'Statut',
  drag_files: 'Déposez des fichiers ici',
  attached_files_title: 'Fichiers attachés',
  reset_pwd_err_empty: 'Vous devez saisir un mot de passe',
  reset_pwd_err_confirm: 'Vous devez saisir deux fois le même mot de passe',
  reset_pwd_err_invalid: 'Votre mot de passe est invalide',
  reset_email_err_empty: 'Vous devez saisir une adresse mail',
  reset_email_err_confirm: 'Vous devez saisir deux fois la même adresse mail',
  reset_email_err_invalid: 'Votre  est invalide',
  reset_pwd_perform: 'Changer le mot de passe',
  return_login: 'Retour',
  reset_email_perform: "Changer l'adresse mail",
  changepwd_title: 'Changement de mot de passe',
  changepwd_success:
    'Changement de mot de passe effectué avec succès. Vous pouvez désormais vous connecter avec ce nouveau mot de passe.',
  changeemail_success: "Changement d'adresse mail effectué avec succès",
  changeemail_reconnect_title: 'Votre adresse e-mail a bien été modifiée.',
  changeemail_reconnect_message:
    'Pour des raisons de sécurité, vous allez être déconnecté.\nMerci de vous reconnecter avec votre nouvelle adresse e-mail.',
  changepwd_reconnect_title: 'Votre mot de passe a bien été modifié.',
  changepwd_reconnect_message:
    'Pour des raisons de sécurité, vous allez être déconnecté de tous vos appareils.\nMerci de vous reconnecter avec votre nouveau mot de passe.',
  reconnect_logout: 'Me déconnecter',
  file_confirm_delete: 'Êtes-vous sûr de vouloir supprimer le fichier {item} ?',
  badpwd_previous: 'Vérifiez votre mot de passe précédent',
  badpwd_empty: "Le mot de passe n'est pas renseigné",
  bademail_empty: "L'email n'est pas renseigné",
  accommodation_title: 'Logement',
  date_start: 'Date de début',
  date_end: 'Date de fin',
  date_from: 'A partir du',
  date_to: "Jusqu'au",
  select_all: 'Tout sélectionner',
  unselect_all: 'Tout désélectionner',
  filter: 'Filtrer',
  added: 'Ajouté',
  actives: 'Actifs',
  inactives: 'Inactifs',
  team: 'Équipe',
  confirm_enable: 'Êtes-vous sûr de vouloir activer {0} ?',
  confirm_disable: 'Êtes-vous sûr de vouloir désactiver {0} ?',
  confirm_enable_title: 'Activation de {0}',
  confirm_disable_title: 'Désactivation de {0}',
  nb_days: 'Nombre de jours',
  pictures: 'Photos',
  contacts: 'Contacts',
  communication: 'Communication',
  equipments: 'Equipements',
  date_updated: 'Date de modification',
  updated_by: 'Personne qui a modifié',
  photo_confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette photo ?',
  today: "Aujourd'hui",
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
  other: 'Autre',
  others: 'Autres',
  type: 'Type',
  quantity: 'Quantité',
  models: 'Modèles',
  identifier: 'Identifiant',
  user: {
    list: 'Utilisateurs',
    details: 'Fiche utilisateur',
    one: 'Utilisateur',
    empty: 'Aucun utilisateur',
    name: 'Nom',
    firstname: 'Prénom',
    lastname: 'Nom',
    maidenName: 'Nom de jeune fille',
    password: 'Mot de passe',
    password_new: 'Nouveau mot de passe',
    password_previous: 'Mot de passe précédent',
    password_repeat: 'Confirmation du mot de passe',
    password_change: 'Modifier le mot de passe',
    email: 'E-mail',
    role: 'Rôle',
    roleKey: 'Rôle',
    enabled: 'Actif',
    access: 'Accès hôte',
    add: 'Ajouter un utilisateur',
    update: 'Modifier un utilisateur',
    my_profile: 'Mon profil',
    account_manager: 'Mon chargé de compte | Mes chargés de compte',
    housekeeping_referent: 'Mon référent concierge | Mes référents concierge',
    partner_housekeeper: 'Mon concierge partenaire | Mes concierges partenaires',
    enabled_success: "Le compte de l'utilisateur a bien été activé",
    disabled_success: "Le compte de l'utilisateur a bien été désactivé",
    configure_sso: 'Configurer la connexion avec',
    configure_sso_title: 'Configuration de la connexion',
    configure_sso_message:
      'Êtes-vous sûr de vouloir configurer la connexion ? Vous serez déconnecté de votre session actuelle.',
    configure_sso_canceled: 'La configuration de la connexion a été annulée',
  },
  address: {
    address: 'Adresse',
    complement: "Complément d'adresse",
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    state: 'Département',
    cannotEditSynced:
      "Ce logement est déjà synchronisé sur une plateforme. Toute demande de changement d'adresse doit être effectuée via un ticket auprès de l'équipe Produit.",
  },
  company: {
    company: 'Agence',
    list: 'Agences',
    details: 'Fiche agence',
    one: 'Agence',
    empty: 'Aucune agence',
    name: 'Raison sociale',
    type: 'Type',
    email: 'E-mail',
    calendar_url: 'Lien du calendrier',
    address1: 'Adresse',
    address2: 'Complément',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    enabled: 'Active',
    siret: 'Siret',
    rcs: 'RCS',
    rcsCity: 'Ville RCS',
    ape: 'Code APE',
    urssaf: 'URSSAF',
    urssafZone: 'Région URSSAF',
    juridique: 'Forme juridique',
    capital: 'Capital',
    numTva: 'N° TVA Intracommunautaire',
    numAgrement: 'N° Agrément',
    dateAgrement: "Date d'agrément",
    numDeclaration: 'N° de déclaration',
    dateDeclaration: 'Date de déclaration',
    civility: 'Civilité',
    stock: 'Stock',
    ownerLastName: 'Nom',
    ownerFirstName: 'Prénom',
    phone1: 'Téléphone',
    phone2: 'Fax',
    add: 'Ajouter une agence',
    update: 'Modifier une agence',
    updateThis: 'Modifier',
    accommodation_types: 'Types de logement',
    companyType_filiale: 'Filiale',
    companyType_partenaire: 'Partenaire',
    companyType_franchise: 'Franchise',
    denominationCommerciale: 'Dénomination commerciale',
  },
  error: {
    USER_MAIL_ALREADY_EXISTS: 'Cette adresse mail est déjà utilisée',
    RESERVATION_ALREADY_EXISTS: 'Une réservation existe déjà pour ce créneau',
    MANDAT_TYPE_ALREADY_EXISTS: 'Il existe déjà un mandat de gestion avec le même type pour ce logement',
    MANDAT_NUM_ALREADY_EXISTS: 'Il existe déjà un mandat de gestion avec le même numéro',
    ACCOUNT_NUM_ALREADY_EXISTS: 'Il existe déjà un compte avec le même numéro',
    AVANTIO_ID_ALREADY_EXISTS: 'Il existe déjà un logement avec le même identifiant Avantio',
    SIGN: 'Merci de vérifier votre signature YouSign avant de cliquer sur le bouton',
    NOT_BALANCED: "Le montant de la transaction n'est pas correct, le débit et le crédit doivent se valoir",
    CANT_RENDER_TEMPLATE: 'Un problème est survenue pour générer le template',
    SMILY_TIME_OUT:
      'Une erreur est survenue pour la synchronisation vers Smily, merci de réessayer pour synchroniser correctement le logement',
    SMILY_RATE_LIMIT: 'Vous avez atteint le quota maximal de requêtes pour Smily',
    PRICE_RULES_ALWAYS_APPLIED_PERIOD_CONFLICT:
      'Conflit de règles : une règle « Toujours appliquée » et une règle « par période » du même type ne peuvent pas coexister.',
    OWNER_CHARGE_ALREADY_VALIDATED: 'Cette charge hôte est déjà validée',
    INVALID_SIGN_DATE: 'Date de signature invalide',
    DATE_ALREADY_USED: 'Cette date est déjà utilisée',
    DATE_NOT_FOUND: 'Une date est manquante',
    ERROR_CANCEL_SIGNATURE_REQUEST: "Impossible d'annuler la demande de signature",
    RESA_HOTE_OVERLAP:
      'Vous ne pouvez pas effectuer de réservation hôte sur une réservation voyageur déjà existante. Vous pouvez donc contacter votre contact privilégié chez Guestadom afin de voir les démarches à suivre. Vous remerciant de votre compréhension.',
    RESA_HOTE_OVERLAP_ONBOARDING:
      "Une ou plusieurs réservation(s) hôte sont en conflit, une période ne peut débuter qu'après la fin d'une période précédente. Veuillez vérifier chaque réservation et corriger si nécessaire.",
    RESA_HOTE_CHECKIN_PASSED:
      "Le check-in de cette réservation hôte est passé : seule l'équipe produit peut la supprimer.",
    RESA_HOTE_CHECKIN_LOCKED:
      "Le check-in de cette réservation hôte est passé : seule l'équipe produit peut modifier la date de début.",
    RESA_HOTE_CHECKOUT_PASSED: 'La date de fin ne peut pas être antérieure à la date du jour.',
    RESA_HOTE_ENDED: 'Cette réservation hôte est terminée : elle ne peut plus être modifiée ni supprimée.',
    NO_PARTENAIRE_FOUND: 'Aucun partenaire trouvé sur ce litige',
    NO_LITIGE_ID: "Le litige n'a pas d'id",
    NO_RESERVATION_ID: 'Le litige ne contient pas de reservationId',
    NO_PARTENAIRE_ID: 'Le litige ne contient pas de partenaireId',
    NO_PARTENAIRE_PARTENAIRE_ID: "Le partenaire ne contient pas d'id",
    NO_PARTENAIRE_CONTACT: 'Le partenaire ne contient pas de contact',
    NO_PARTENAIRE_COMPANY: 'Le partenaire ne contient pas de companie',
    NO_PARTENAIRE_ACCOMMODATION: "Le partenaire n'a pas de logement",
    ERROR_CANCEL_RESERVATION: "Une erreur est survenue lors de l'annulation de réservation",
    FLOOR_GREATER_THAN_NOMBRE_ETAGE: "Le numéro d'étage ne peut pas être supérieur au nombre d'étages",
    ERROR_DATE_RESILIATION_3_MONTH: 'La date de fin doit être au moins 3 mois après la date de résiliation',
    ALREADY_RESILIATED: 'Le mandat de gestion est déjà résilié',
    SMILY_OVERLAPS: 'Les périodes de blocage sont déjà utilisées',
    SMILY_NOT_FOUND: "Le logement n'a pas pas été correctement synchronisé (introuvable)",
    SMILY_OWNER_NOT_FOUND: "Les périodes de blocage n'ont pas pu être synchronisées",
    SMILY_RESPONSE_EMPTY: 'Aucune réponse provenant de Smily',
    SMILY_RESPONSE_EMPTY_BOOKING: 'Aucune réservation correspondante sur Smily',
    SMILY_RESPONSE_EMPTY_RATES_RULES: 'Aucune règle de prix correspondante sur Smily',
    SMILY_RESPONSE_EMPTY_NIGHTLY_RATE_MAPS: 'Aucune règle de prix sur les nuits correspondante sur Smily',
    NO_MANDAT_ID: 'Aucun mandat id trouvé',
    MAINTENANCE_STATUS: 'Cette maintenance a déjà été résolue',
    FILE_IS_MANDATORY: 'La pièce-jointe est obligatoire',
    FILE_UPLOAD_ERROR: 'Erreur lors du téléchargement du fichier',
    FILE_TYPE_NOT_ALLOWED: "Ce type de fichier n'est pas autorisé",
    FILE_EXTENSION_MISMATCH: "L'extension du fichier ne correspond pas à son contenu",
    FILE_IMAGE_INVALID: "L'image est illisible ou corrompue",
    FILE_IMAGE_TOO_SMALL: "La résolution de l'image est insuffisante. Minimum requis : 2048x1536",
    FILE_IMAGE_TOO_LARGE: "Les dimensions de l'image sont trop grandes",
    FILE_UPLOAD_ALREADY_EXISTS_ERROR:
      'Erreur lors du téléchargement du fichier, un fichier existe déjà. Veuillez recharger la page.',
    ERROR_AMOUNT_PAID_OTA: 'Le montant déjà payé de la commission OTA est supérieur au montant saisie',
    unbalanced_transaction: "Une erreur est survenue: la transaction n'est pas équilibrée",
    companyaccommodationtype_used: 'Le type de logement ne peut pas être supprimé',
    CDC_NOT_FOUND: "Le cahier des charges n'a pas pu être récupéré",
    undefined: 'Une erreur est survenue',
    badpwd_previous: 'Vérifiez votre mot de passe précédent',
    MANDAT_SIGNED_UNKNOWN: 'Le mandat de gestion signé est manquant',
    missing_fields: 'Un ou plusieurs champs obligatoires ne sont pas renseignés',
    bad_token: 'Inscription interdite',
    bad_code: 'Le code entré est incorrect. Merci de vérifier et de réessayer.',
    otp_expired: 'Le code entré est expiré. Merci de demander un nouveau code et de réessayer.',
    error: 'Une erreur est survenue',
    ficType_missing_onboarding: 'Un de vos documents personnels est manquant',
    AVENANT_NOT_FOUND: "L'avenant n'existe pas",
    ONBOARDING_DOCUMENTS_NOT_VALID: 'La validation des documents ne peut avoir lieu, une incohérence a été détectée.',
    ONBOARDING_DOCUMENTS_MISSING:
      'La validation des documents ne peut avoir lieu, des documents obligatoires sont manquants',
    check_fields: 'Merci de vérifier les champs à renseigner',
    USER_HAS_PROVIDER: "Le compte de l'utilisateur est lié à un fournisseur d'authentification unique",
    USER_NOT_FOUND: "Le compte de l'utilisateur n'existe pas",
    NO_HOUSEKEEPER_CONTACT: 'Informations de contact manquantes',
    NO_HOUSEKEEPER_COMPANY: 'Agence non sélectionnée',
    MAIL_TEMPLATE_ALREADY_ASSIGNED: 'Le modèle de mail est déjà utilisé',
    EXPORT_GENERATION_FAILED: "Une erreur est survenue lors de l'export",
  },
  role: {
    //SUPPORT
    technical_division: 'Pôle Tech',
    digital_project_manager: 'Product Manager',
    product_assistant: 'Assistant(e) Product Manager',
    owner: 'Hôte',
    owner_relation_manager: 'Chargé(e) de Clientèle Propriétaire',
    traveller: 'Voyageur',
    relation_manager: 'Chargé(e) de Clientèle Voyageur',
    mandant_accounting: 'Comptabilité Mandante',
    accountant_mandant_manager: 'Responsable Comptable Mandant',
    accountant_mandant: 'Comptable Mandant',
    accountant_assistant_mandant: 'Assistant(e) Comptable Mandant',
    general_administration_and_accounting: 'Admin / Compta Générale',
    executive_assistant: 'Assistant(e) de direction',
    rh_assistant: 'Assistant(e) RH',
    sales: 'Sales',
    head_of_sales: 'Responsable commercial',
    sales_development_representative: 'Commercial(e)',
    income_management: 'Distribution',
    income_manager: 'Revenue Manager',
    distribution_manager: 'Chargé(e) de Distribution',
    marketing_and_communication: 'Communication',
    marketing_and_communication_manager: 'Responsable Communication',
    communication_manager: 'Chargé(e) de Communication',
    housekeeping: 'Conciergerie',
    housekeeping_network_manager: 'Responsable Réseau Concierge',
    housekeeping_referent: 'Référent(e) Concierge',
    top_management: 'Top Management',
    ceo: 'CEO',
    coo: 'COO',
    country_manager: 'Country Manager',
    project_manager: 'Chef de Projet',

    //VILLE
    poste: 'Poste',
    city_manager: 'City Manager',
    assistant_city_manager: 'Assistant(e) city manager',
    business_developer: 'Business Developer',
    cleaner: 'Agent polyvalent',
    welcomer: 'Welcomer',
    household_assistant: 'Assistant(e) ménage',
    administrative_and_accounting_manager: 'Responsable Administratif et Comptable',
    administrative_assistant: 'Assistant(e) administratif',

    other: 'Autre',
    prestataire: 'Prestataire',
    gas: 'Guestadom Support',
    gav: 'Guestadom Ville',
    photographer: 'Photographe',
    administrator: 'Administrateur',
    custom_relation_manager: 'Gestionnaire de Relations Personalisées',
    onboarding_manager: 'Onboarding Manager',

    partenaire: 'Prestataire',
    housekeeper: 'Concierge partenaire',
    developer: 'Développeur',
    commercial: 'Agent commercial',
  },
  management_type: {
    professional: 'Professionnel',
    non_professional: 'Non-professionnel',
  },
  owner: {
    list: 'Hôtes',
    details: 'Fiche hôte',
    activity: 'Communication',
    trace: 'Activité',
    ticket: 'Tickets',
    accommodations: 'Logements',
    empty: 'Aucun hôte',
    add: 'Ajouter un hôte',
    update: 'Modifier un hôte',
    updateThis: 'Modifier',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet hôte ?',
    deleted: "L'hôte a bien été supprimé",
    updated: "L'hôte a bien été modifié",
    added: "L'hôte a bien été ajouté",
    enabled: "L'hôte a bien été activé",
    disabled: "L'hôte a bien été désactivé",
    ownerType: 'Type',
    userEnabled: 'Actif',
    ownerType_individu: 'Personne physique',
    ownerType_indivision: 'Indivision',
    ownerType_personneMorale: 'Personne morale',
    ownerName: 'Nom',
    ownerDisplay: 'Hôte',
    address: 'Adresse',
    create_access: 'Créer accès hôte',
    create_access_confirmation: "Êtes-vous sur de vouloir créer l'accès hôte ?",
    resend_access: "Renvoyer l'accès hôte",
    resend_access_confirmation: "Êtes-vous sur de vouloir renvoyer l'accès hôte ?",
    lost: 'Marquer comme perdu',
    lost_confirmation: 'Êtes-vous sur de vouloir marquer ce prospect comme perdu ?',
    lost_ok: 'Prospect perdu',
    access_sent: 'Les accès ont été envoyés',
    mes_contacts: 'Mes contacts',
    relation_managers: 'Relation managers',
    all: 'Tous les hôtes',
    enabled_only: 'Uniquement les hôtes actifs',
    disabled_only: 'Uniquement les hôtes inactifs',
    reservation: {
      title: 'Définir une réservation hôte',
      one: 'Réservation hôte',
      the_one: 'la réservation hôte',
      label: 'Date bloquée',
      add: 'Ajouter une réservation hôte',
      dateStart: 'Date de début',
      dateEnd: 'Date de fin',
      error:
        "La date de début de votre nouvelle réservation hôte commence dans une période déjà existante {0}. Il n'est pas possible de créer cette nouvelle période avant la fin de la période actuelle. Veuillez d'abord modifier la période précédente puis en créer une nouvelle.",
    },
    your_status: 'Votre statut',
    source: 'Comment avez-vous connu Guestadom ?',
  },
  crm: {
    list: 'CRM',
    formule_all_inclusive: 'Formule Premium',
    formule_online: 'Formule Essentielle',
    formule_confort: 'Formule Confort',
  },
  prospect: {
    list: 'Prospects',
    details: 'Fiche prospect',
    activity: 'Communication',
    trace: 'Activité',
    empty: 'Aucun prospect',
    add: 'Ajouter un prospect',
    update: 'Modifier un prospect',
    updateThis: 'Modifier',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce prospect ?',
    force_delete:
      'Une erreur est survenue car des onboardings sont liés à ce prospect. Êtes-vous sûr de vouloir supprimer ce prospect ainsi que ses onboardings ?',
    deleted: 'Le prospect a bien été supprimé',
    updated: 'Le prospect a bien été modifié',
    added: 'Le prospect a bien été ajouté',
    enabled: 'Le prospect a bien été activé',
    disabled: 'Le prospect a bien été désactivé',
    errorNoId: "Ce prospect n'a pas de compte utilisateur",
    ownerType: 'Type',
    userEnabled: 'Actif',
    ownerType_individu: 'Personne physique',
    ownerType_indivision: 'Indivision',
    ownerType_personneMorale: 'Personne morale',
    ownerName: 'Nom',
    company: 'Agence',
    comment: 'Commentaire',
    leadStatus: 'Status du lead',
    offer: 'Formule',
    status: 'Statut',
    priority: 'Priorité',
    source: 'Source de connaissances',
    tylsSubscription: 'Souscription à Tyls',
    area: 'Superficie',
    residenceType: 'Type de résidence',
    habitatType: "Type d'habitat",
    regimeJuridique: 'Régime juridique',
    accommodationType: 'Type de logement',
    accommodationType2: 'Typologie',
    valeur: 'Valeur',
    leadStatus_OPEN_DEAL: 'Deal ouvert',
    leadStatus_NEW: 'Nouveau',
    leadStatus_OPEN: 'Ouvert',
    leadStatus_PERDU: 'perdu',
    leadStatus_GAGNE: 'gagné',
    leadStatus_IN_PROGRESS: 'En cours',
    identiteContact: 'Identité du contact',
    receptionType: 'Gestion des accueils',
    receptionCheckoutType: 'Gestion des départs',
    checkin_person: 'Personne en charge des accueils',
    checkout_person: 'Personne en charge des départs',
    housework_person: 'Personne en charge du ménage',
    prestataire_name: 'Nom du prestataire',
    nbBathroom: 'Nombre de salle de bain',
    nbBedroom: 'Nombre de chambre',
    disponibilite: 'Disponibilité',
    capacity: "Capacité d'accueil",
    all: 'Tous les prospects',
    enabled_only: 'Uniquement les prospects actifs',
    disabled_only: 'Uniquement les prospects inactifs',
    formule: 'Formule',
    formuleChoice: 'Choix de la Formule',
    signup: 'Inscription',
    lastActivity: 'Dernière activité',
    stepReached: 'Étape atteinte',
  },
  onboarding: {
    shootingDate: 'Date de shooting',
    comment: 'Commentaire',
    newComment: 'Nouveau commentaire',
    list: 'Onboardings',
    details: 'Fiche onboarding',
    empty: 'Aucun onboarding',
    add: 'Ajouter un onboarding',
    update: 'Modifier un onboarding',
    updateThis: 'Modifier',
    complete: "Reprendre l'onboarding",
    completed: "L'onboarding a été terminé avec succès",
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet onboarding ?',
    deleted: "L'onboarding a bien été supprimé",
    updated: "L'nboarding a bien été modifié",
    added: "L'onboarding a bien été ajouté",
    add_estimation: "Ajouter l'estimation locative",
    the_step: "l'étape",
    step: 'Étape',
    step_updated: 'Étape mise à jour',
    step_validated: 'Étape validée',
    step_refused: 'Étape refusée',
    add_step: 'Ajouter une étape',
    add_mandat: 'Ajouter le mandat de gestion',
    nbBedroom: 'Nombre de chambre',
    nbBathroom: 'Nombre de salle de bain',
    nbWc: 'Nombre de WC',
    nbKitchen: 'Nombre de cuisines',
    nbDiningroom: 'Nombre de salles à manger',
    nbLaundryroom: 'Nombre de buanderies',
    nbSalon: 'Nombre de salons',
    step1: 'Vos informations personnelles',
    step2: 'Votre logement',
    step3: 'Intendance de votre logement',
    step4: 'Consigne de votre logement',
    step5: 'Agencement intérieur du logement',
    step6: 'Agencement extérannieur du logement',
    step8: 'Contacts utiles',
    step7: 'Liste des équipements supplémentaires',
    step9: 'Calendrier',
    silentMode: 'Mode silencieux',
    commercialId: 'Agent commercial en charge',
    mandat_creation_in_progress: 'Mandat de gestion en cours de création',
    document_upload_in_progress: "Document en cours d'upload",
    contacts: 'Contacts utiles',
    step2_missing_fic: "Des documents requis sont en attente d'upload",
    send_estimation: "Envoyer l'estimation",
    add_picture: 'Ajouter une photo',
    description_step_checkin:
      "Précisez l'accès au logement, les étapes à suivre (codes, portes, escaliers, ascenseur…) pour faciliter l'arrivée des voyageurs.",
    description_step_checkout:
      'Précisez les étapes à suivre pour quitter le logement (codes, portes, escaliers, ascenseur…) pour faciliter la sortie des voyageurs.',
    title_step_checkin: 'Décrivez au moins une étape',
    title_step_checkout: 'Décrivez au moins une étape',
    duplicate: 'Dupliquer',
    duplicate_label: 'Souhaitez-vous dupliquer cet onboarding ?',
    duplicate_nb: 'Combien de fois souhaitez-vous dupliquer cet onboarding ?',

    v3: {
      step_1_0: 'Inscription',
      step_1_1: 'Votre logement',
      step_1_2: 'Votre formule',
      step_1_3: 'Vos réglages',
      step_1_4: 'Informations personnelles',
      step_1_5: 'Mandat de gestion',
    },

    step1_1: {
      address: 'Adresse',
    },
    step1_2: {
      eauChaudeType: "Type d'eau chaude",
      autresParties: 'Autres parties',
      surfaceExterieur: 'Surface extérieur',
      chauffageType: 'Type de chauffage',
    },
    step1_3: {
      offer: 'Formule',
      companyId: 'Agence',
      documentModelId: 'Modèle de document',
      amountThresholdId: 'Minimum de facturation',
      amountThresholdPartenaireId: 'Minimum de facturation concierge partenaire',
      feeStart: 'Frais de lancement',
      feeStartPartner: 'Frais de lancement concierge partenaire',
      feeHousework: 'Frais de ménage',
      feeLaundry: 'Frais de blanchisserie',
      feeAssurance: "Frais d'assurance",
      feeHouseworkInterlocatifTotal: 'Frais de ménage interlocatifs total',
      feeHouseworkInterHote: 'Frais de ménage interlocatifs hôte',
      prixMinimumNuit: 'Prix minimum à la nuit',
      dureeSejourMinimum: 'Durée de séjour minimum',
      cancelRuleId: "Règle d'annulation",
      depotGarantie: 'Caution',
      iban: 'IBAN',
      bic: 'BIC',
    },
    step4_1: {
      parking: 'Parking',
      parkingType: 'Type de parking',
      parkingPlace: 'Nombre de places à disposition',
      parkingEmplacement: 'Emplacement du parking',
      parkingInstructionsAcces: "Instructions d'accès du parking",
      pictureParking: 'Photo du parking',
    },
    step4_2: {
      fic: "Photo d'étape de Check-in",
      description: 'Commentaire de Check-in',
      alarm: 'Alarme',
      alarmCode: "Code de l'alarme",
      alarmPlace: "Emplacement de l'alarme",
      alarmFonctionnement: "Fonctionnement de l'alarme",
      checkinType: 'Type de Check-in',
      systemeAutonome: 'Système autonome',
      systemeAutonomeLocalisation: 'Emplacement du système autonome',
      systemeAutonomeCode: 'Code du système autonome',
      elevator: 'Ascenseur',
      nombreEtage: "Nombre d'étage",
    },
    step4_3: {
      wifi: 'Wi-fi',
      nomDuReseauWifi: 'Nom du réseau',
      motDePasseWifi: 'Mot de passe',
      localisationDeLaBox: 'Emplacement de la box',
      pictureWifi: 'Photo du wi-fi',
      accessiblePmr: 'Photo du wi-fi',
    },
    step4_4: {
      zoneId: 'Zone (Composition intérieure)',
    },
    step4_5: {
      portailType: 'Type de portail',
      portailOuverture: "Type d'ouverture du portail",

      garden: {
        surface: 'Surface de jardin',
        type: 'Type de jardin',
      },
      pool: {
        type: 'Type de piscine',
        dateOuverture: "Date d'ouverture de la piscine",
        dateFermeture: 'Date de fermeture de la piscine',
        longueur: 'Longueur de la piscine',
        largeur: 'Largeur de la piscine',
      },
      jacuzzi: {
        dateOuverture: "Date d'ouverture du jacuzzi",
        dateFermeture: 'Date de fermeture du jacuzzi',
        fonctionnement: 'Fonctionnement du jacuzzi',
      },
    },
    step4_6: {
      tableauElectriqueEmplacement: 'Emplacement du tableau électrique',
      tableauElectriqueFonctionnement: 'Fonctionnement du tableau électrique',
      tableauElectriqueConsignes: 'Consignes pour le tableau électrique',
      pictureTableau: 'Photo du tableau électrique',
      eauChaudeEmplacement: "Emplacement de l'arrivée d'eau",
      eauChaudeType: "Type d'eau chaude",
      eauChaudeFonctionnement: "Fonctionnement de l'eau chaude",
      pictureWater: "Photo du l'eau chaude",
      chauffageType: 'Type de chauffage',
      chauffageEmplacement: 'Emplacement du chauffage',
      chauffageFonctionnement: 'Fonctionnement du chauffage',
      ballonEauChaudeEmplacement: "Emplacement du ballon d'eau chaude",
      ballonEauChaudeFonctionnement: "Fonctionnement du ballon d'eau chaude",
      ballonEauChaudeMarque: "Marque du ballon d'eau chaude",
      bouteilleGazEmplacement: 'Emplacement de la bouteille de gaz',
      bouteilleGazCommentaire: 'Commentaire pour la bouteille de gaz',
      toutVenantLocalisation: 'Emplacement du tout venant',
      toutVenantJour: 'Jours du tout venant',
      recyclageLocalisation: 'Emplacement du recyclage',
      recyclageJour: 'Jours du recyclage',
      verreLocalisation: 'Emplacement du verre',
      verreJour: 'Jours du verre',
      moyenAcces: "Moyen d'accès",
      moyenAccesCode: "Code du moyen d'accès",
    },
    step4_7: {
      houseworkPerson: 'Personne en charge du ménage',
      houseworkPrestataireName: 'Nom du prestataire en charge du ménage',
      checkinPerson: 'Personne en charge du checkin',
      checkinPrestataireName: 'Nom du prestataire en charge du checkin',
      checkoutPerson: 'Personne en charge du checkout',
      checkoutPrestataireName: 'Nom du prestataire en charge du checkout',
      receptionCheckinType: 'Type de reception checkin',
      receptionCheckoutType: 'Type de reception checkout',
      gestionLinge: 'Gestion du linge',
    },
    step4_8: {
      consigneMenage: 'Consignes de ménage',
      consigneWelcome: "Consignes d'accueil",
      consigneRetourHote: 'Consignes retour hôte',
      smokinForbidden: 'Interdiction de fumer',
      petsConsidered: 'Animaux acceptés',
      onlyDog: 'Chiens',
      onlyCat: 'Chats',
      onlySmallPets: 'Animaux de petite taille ?',
      partyAllowed: 'Soirées / fêtes acceptées',
      forbiddenRoom: 'Pièces non accessibles aux voyageurs',
      forbiddenEquipments: 'Équipements non accessibles aux voyageurs',
    },
    step4_10: {
      type2: 'Type de contact',
    },
    step4_11: {
      fic: "Photo d'étape de Check-out",
      description: 'Commentaire de Check-out',
    },
    step4_13: {
      title: "Titre de l'annonce",
      headline: 'Résumé du logement',
      description: 'Description du logement',
    },
  },

  crg_annuel: {
    list: 'Rapport de gestion',
  },

  accommodation: {
    short: 'Logement',
    disponibilite: 'Disponibilité',
    intendance: {
      tableauElectriqueEmplacement: 'Emplacement du tableau électrique',
      tableauElectriqueFonctionnement: 'Fonctionnement',
      tableauElectriqueConsignes: 'Consignes',
      tableauElectriqueCommentaire:
        'Précisez le fonctionnement du tableau électrique, les informations importantes à savoir, etc...',
      eauChaudeType: "Type d'eau chaude",
      eauChaudeEmplacement: "Emplacement de l'arrivée d'eau",
      eauChaudeCommentaire:
        " Précisez le fonctionnement de l'arrivée d'eau, les informations importantes à savoir, etc...",
      eauChaudeFonctionnement: 'Fonctionnement',
      eauChaudeExterieureEmplacement: "Emplacement de l'arrivée d'eau chaude extérieure",
      eauChaudeExterieureFonctionnement: 'Fonctionnement',
      disjoncteurEmplacement: 'Emplacement du disjoncteur électrique',
      disjoncteurFonctionnement: 'Fonctionnement',
      disjoncteurConsignes: 'Consignes',
      ballonEauChaudeEmplacement: "Emplacement du ballon d'eau chaude",
      ballonEauChaudeFonctionnement: 'Fonctionnement',
      ballonEauChaudeMarque: 'Marque',
      bouteilleGazEmplacement: 'Emplacement du stockage des bouteilles de gaz',
      bouteilleGazCommentaire: 'Précisez le fonctionnement du chauffage, les informations importantes à savoir, etc...',
      chauffageType: 'Type de chauffage',
      chauffageOther: 'Précisez le type de chauffage',
      chauffageEmplacement: 'Emplacement',
      chauffageFonctionnement: 'Fonctionnement',
      thermostatFonctionnement: 'Fonctionnement',
      thermostatMarque: 'Marque',
      vmcEmplacement: 'Emplacement',
      vmcFonctionnement: 'Fonctionnement',
      climatisationFonctionnement: 'Fonctionnement',
      coffreFort: "Présence d'un coffre fort",
      coffreFortCode: 'Code',
      coffreFortEmplacement: 'Emplacement',
      coffreFortFonctionnement: 'Fonctionnement',
      detecteurFumee: 'Détecteur de fumée',
      detecteurFumeeLocalisation: 'Localisation',
      moyenAcces: "Moyen d'accès",
      moyenAccesCode: "Code d'accès",
      toutVenantLocalisation: 'Localisation du tout-venant',
      toutVenantJour: 'Jour de passage du tout-venant',
      recyclageLocalisation: 'Localisation du recyclage',
      recyclageJour: 'Jour de passage du recyclage',
      verreLocalisation: 'Localisation du verre',
      verreJour: 'Jour de passage du verre',
      moyenAccesPoubelles: "Moyen d'accès au local poubelles",
      moyenAccesPoubelles_placeholder: 'Indiquez comment accéder au local poubelles.',
    },
    consigne: {
      checkinTime: "Heure d'arrivée",
      checkinEndTime: 'Heure d’arrivée au plus tard',
      checkoutTime: 'Heure de départ',
      consigneMenage: 'Consignes pour le ménage',
      consigneWelcome: "Consignes pour l'accueil",
      consigneRetourHote: 'Consignes en cas de retour chez vous',
      smokeInside: 'Autorisation de fumer à l’intérieur ',
      allPets: 'Tous les animaux ?',
      petsConsidered: 'Animaux acceptés',
      onlyDog: 'Chiens',
      onlyCat: 'Chats',
      onlySmallPets: 'Animaux de petite taille ?',
      partyAllowed: 'Soirées et fêtes acceptées',
      forbiddenRoom: 'Pièces non accessibles aux voyageurs',
      forbiddenRoom_placeholder: 'Précisez quelles pièces ne sont pas à disposition des voyageurs.',
      forbiddenEquipments: 'Équipements non accessibles aux voyageurs',
      forbiddenEquipments_placeholder: 'Précisez quels équipements ne sont pas à disposition des voyageurs.',
      espaceHote: 'Souhaitez-vous définir un espace hôte dans votre logement ?',
      espaceHoteEmplacement: 'Emplacement',
      espaceHoteCommentaire: 'Commentaires',
      houseworkPerson: 'Personne en charge du ménage',
    },
    garden: {
      garden: 'Espace extérieur',
      surface: "Surface de l'espace extérieur",
      type: "Type de l'espace extérieur",
      cloture: 'Clôturé',
      entretien: 'Entretien',
      arrosage: 'Arrosage automatique',
      eclairage: 'Éclairage extérieur',
      barbecue: 'Barbecue',
      eclairageFonctionnement: 'Fonctionnement',
      arrosageFonctionnement: 'Fonctionnement',
      barbecueFonctionnement: 'Fonctionnement',
      mobilierRentreHiver: 'Le mobilier est-il rentré l’hiver ?',
      commentaire: 'Commentaire',
      commentaire_placeholder: 'Précisez les spécificités, les équipements et leur fonctionnement , le mobilier etc.. ',
      add: 'Ajouter',
      none: 'Aucun espace extérieur',
    },
    pool: {
      pool: 'Piscine',
      type: 'Type de piscine',
      dateOuverture: "Date d'ouverture",
      periodOuverture: "Période d'ouverture",
      dateFermeture: 'Date de fermeture',
      temperature: 'Température',
      dimension: 'Dimension',
      ouverture: "Type d'ouverture",
      fonctionnement: 'Fonctionnement de la piscine',
      robot: 'Robot',
      robotFonctionnement: 'Fonctionnement',
      robotNettoyage: 'Nettoyage',
      doucheExterieure: 'Douche extérieure',
      deshumidificateur: 'Déshumidificateur',
      spotLumineux: 'Spot lumineux',
      commentaire: 'Commentaire',
      commentaire_placeholder: "Consignes de nettoyage et d'utilisation, informations utiles, les équipements etc...",
      largeur: 'Largeur',
      longueur: 'Longueur',
      chauffe: 'Piscine chauffée',
      period: 'Période de chauffe',
      add: 'Ajouter une piscine',
      private_pool: 'Piscine privée',
      none: 'Aucune piscine',
    },
    jacuzzi: {
      jacuzzi: 'Jacuzzi',
      dateOuverture: "Date d'ouverture",
      dateFermeture: 'Date de fermeture',
      fonctionnement: 'Fonctionnement du jacuzzi',
      fonctionnement_placeholder:
        "Consignes de nettoyage et d'utilisation, informations utiles, les équipements etc...",
      vidage: 'Fréquence pour vider le jacuzzi',
      nettoyage: 'Nettoyage spécifique',
      utilisationMaximale: "Temps maximum d'utilisation (en heure)",
      utilisationMaximalePlaceholder: "Temps maximum d'utilisation",
      commentaire: 'Commentaire',
      commentaire_placeholder: "Consignes de nettoyage et d'utilisation, informations utiles, les équipements etc...",
      add: 'Ajouter un jacuzzi',
      none: 'Aucun jacuzzi',
      type: 'Type de jacuzzi',
      private_jacuzzi: 'Jacuzzi privé',
    },
    sauna: {
      sauna: 'Sauna',
      fonctionnement: 'Fonctionnement du sauna',
      fonctionnement_placeholder: "Consignes de nettoyage et d'utilisation, informations utiles, etc...",
      nettoyage: 'Nettoyage spécifique',
      commentaire: 'Commentaire',
      commentaire_placeholder: "Consignes de nettoyage et d'utilisation, informations utiles, etc...",
      add: 'Ajouter un sauna',
      none: 'Aucun sauna',
      private_sauna: 'Sauna privé',
      type: 'Type de sauna',
    },
    advert: {
      reviews: 'Avis de votre logement',
      reviews_global_rating: 'Note globale',
      reviews_nb_total: "Nombre total d'avis déposés",
      reviews_all: 'Consulter tous les avis',
      update: 'Modifier les annonces',
      links_updated: 'Les liens des annonces ont bien été mis à jour',
      updated: "L'annonce a bien été modifiée",
    },
    nbDiningroom: 'Nombre de salle à manger',
    step1: 'Votre logement',
    step2: 'Agencement de votre logement',
    step3: 'Les règles à respecter par vos voyageurs',
    step4: 'Intendance du logement',
    step5: 'Espace hôte',
    step6: 'Contacts utiles',
    step7: 'Liste des équipements supplémentaires',
    step8: 'Votre annonce',
    step9: 'Calendrier',
    general_step: 'Informations générales',
    agencement_step: 'Agencement intérieur',
    exterieur_step: 'Agencement extérieur',
    consigne_step: 'Consigne du logement',
    intendance_step: 'Intendance du logement',
    pictures_step: 'Photos du logement',
    step5_ga: 'Espace scellé hôte',
    contact_step: 'Contacts utiles du logement',
    amenities_step: 'Liste des équipements',
    description_step: "Description de l'étape",
    step9_ga: 'Indisponibilités du logement',
    list: 'Logements',
    my_list: 'Mes logements',
    search: 'Rechercher un logement',
    add: 'Ajouter un logement',
    update: 'Modifier un logement',
    updated: 'Le logement a été modifié',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce logement ?',
    publish: 'Publier le logement',
    publish_mine: 'Publier mon logement',
    msgNoAccommodationType: 'Attention, vous n’avez pas configuré de cluster pour cette agence.',
    msg_confirm_enable: "Êtes-vous sûr de vouloir modifier l'activation de ce logement ?",
    empty: 'Aucun logement',
    name: 'Nom du logement',
    files: 'Pièces jointes',
    add_file: 'Ajouter une pièce jointe',
    file_added: 'Pièce jointe ajoutée',
    filetype: 'Type de fichier',
    title: "Titre de l'annonce",
    precision: 'Ce qui vous semble pertinent de faire apparaitre comme information clef sur votre annonce',
    informations: 'Informations pratiques',
    info_accommodation: 'Informations logement',
    info_mandat: 'Informations mandat de gestion',
    receptionType: 'Gestion des accueils',
    checkinType: "Système d'arrivée",
    picture_door: "Photo de l'entrée du logement",
    physical: 'Physique',
    smart_lock: 'Serrure connectée',
    lockbox: 'Boîte à clé',
    '24_hours_staff': 'Staff 24h/24',
    autonomous: 'Autonome',
    accommodationType: 'Type de logement',
    residenceType: 'Type de résidence',
    habitatType: "Type d'habitat",
    regimeJuridique: 'Régime juridique',
    typologie: 'Typologie du logement',
    access: "Moyen d'accès",
    itinerary: 'Itinéraire',
    wifi: 'Wifi',
    wifi_name: 'Nom du réseau',
    wifi_password: 'Mot de passe',
    wifi_place: 'Emplacement de la box',
    modele_box: 'Modèle de la box',
    emplacement: 'Emplacement',
    fonctionnement: 'Fonctionnement',
    marque: 'Marque',
    typeChauffage: 'Type de chauffage',
    typeEauChaude: "Type d'eau chaude",
    alarm: 'Alarme',
    alarm_placeholder: "Précisez l'emplacement et le fonctionnement de l'alarme...",
    alarm_code: "Code de l'alarme",
    alarm_code_placeholder: "Précisez le code de l'alarme.",
    alarm_place: "Emplacement de l'alarme",
    alarm_place_placeholder: "Précisez l'emplacement de l'alarme.",
    alarm_fonctionnement: "Fonctionnement de l'alarme",
    alarm_fonctionnement_placeholder: "Précisez le fonctionnement de l'alarme.",
    access_comment: "Informations d'accès",
    access_comment_placeholder: 'Précisez comment accéder au logement (escalier, marches...).',
    parking: 'Parking',
    parking_emplacement_placeholder: 'Indiquez où se situe la place de parking et comment y accéder.',
    parking_commentaire: 'Commentaire',
    parking_commentaire_placeholder: 'Indiquer si une place de parking extérieure se trouve à proximité du logement.',
    parkingInstructionsAcces: "Instruction d'accès",
    picture_parking: 'Photo du parking',
    picture_tableau: 'Photo du tableau électrique',
    parking_type: 'Type de parking',
    parking_place: 'Nombre de place à disposition',
    parking_place_: 'Place à disposition',
    pmr: 'Accessible PMR',
    capacity: "Capacité d'accueil",
    capacityMax: 'Couchage max',
    surfaceUnit: 'Unité de surface',
    nbRoom: 'Nombre de piéces',
    bedroom: 'Chambre',
    nbRoomBed: 'Nombre de chambre',
    nbRoomShared: 'Nombre de piéces communes',
    bathroom: 'Salle de bain',
    nbBathroom: 'Nombre de salle de bain',
    nbDoubleBed: 'Nombre de lit double',
    nbSimpleBed: 'Nombre de lit simple',
    conditions: 'Conditions de location',
    soumis_tva: 'Soumis à la TVA',
    apartment: 'Appartement',
    bastide: 'Bastide',
    boat: 'Bateau',
    bungalow: 'Bungalow',
    bed_breakfast: "Chambre d'hôtes",
    cabin: 'Refuge',
    castle: 'Château',
    cave_house: 'Caverne',
    chalet: 'Chalet',
    condominium: 'Appartement en résidence',
    troglodyte: 'Habitation troglodyte',
    cottage: 'Cottage',
    dormitory: 'Dortoir',
    'earth-house': 'Maison écologique',
    farmhouse: 'Ferme',
    gite: 'Gîte',
    'holiday-home': 'Maison de vacances',
    house: 'Maison',
    hut: 'Hutte',
    igloo: 'Igloo',
    island: 'Ile',
    lighthouse: 'Phare',
    loft: 'Loft',
    longere: 'Longère',
    manor: 'Manoir',
    mas: 'Mas',
    mill: 'Moulin',
    plane: 'Avion',
    'private-room': 'Chambre privée',
    'private-room-in-apartment': 'Chambre privée dans un appartement',
    'private-room-in-house': 'Chambre privée dans une maison',
    'recreational-vehicle': 'Camping-car / Caravane',
    studio: 'Studio',
    tent: 'Tente',
    tipi: 'Tipi',
    townhouse: 'Maison de ville',
    train: 'Train',
    treehouse: 'Cabane dans les arbres',
    villa: 'Villa',
    yurt: 'Yourte',
    thermostat: 'Thermostat',
    climatisation: 'Climatisation',
    vmc: 'VMC',
    mainResidence: 'Résidence principale',
    secondResidence: 'Résidence secondaire',
    rentalInvestment: 'Investissement locatif',
    linkAdGuestadom: "Lien de l'annonce Guestadom",
    linkYaago: "Livre d'accueil YAAGO",
    website_url: 'Annonces',
    commentAdGuestadom: "Commentaire de l'annonce Guestadom",
    unknown_address: 'Adresse inconnue',
    address: 'Adresse',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    state: 'Département',
    certifications: 'Certifications',
    certificationsBikeLabelTitle: 'Label Accueil Vélo',
    certificationsBikeLabelMessage:
      'Accueil Vélo est un label officiel de France Vélo Tourisme. Ne cochez cette case que si votre logement est effectivement labellisé et que le label est en cours de validité.',
    certificationsBikeLabelConfirm: 'Je confirme être labellisé',
    managementType: 'Type de gestion de location',
    details: 'Fiche logement',
    updateThis: 'Modifier',
    avantioId: 'Identifiant avantio',
    smilyId: 'Identifiant Smily',
    area: 'Superficie intérieure',
    exterior: "Le logement dispose-t-il d'un extérieur ?",
    estimation_exterior: 'Avez-vous un extérieur ?',
    areaExt: 'Surface extérieure',
    areaTerrasse: 'Surface de la terrasse',
    storiesCount: "Nombre d'étage",
    floor: "Numéro d'étage",
    elevator: 'Ascenseur',
    owner: 'Hôte du logement',
    company: 'Agence',
    complement: 'Complément',
    localisation: 'Localisation',
    enabled: 'Actif',
    bookableInstant: 'Réservation instantanée',
    attribution: 'Attribution',
    activity: 'Activités',
    ticket: 'Tickets',
    cdc: 'Cahiers des charges',
    tds: 'TDS',
    update_tds: 'Modifier les TDS',
    updated_tds: 'Les TDS du logement ont bien été modifiées',
    ownerName: 'Hôte',
    companyName: 'Agence',

    toutVenantLocalisation: 'Tout venant localisation',
    toutVenantJour: 'Jour de passage tout venant',
    recyclageLocalisation: 'Recyclage localisation',
    recyclageJour: 'Jour de passage recyclage',
    verreLocalisation: 'Verre localisation',
    verreJour: 'Jour de passage verre',
    code: 'Code',
    picture_wifi: 'Photo de la box',
    picture_water: "Photo de l'arrivée d'eau",
    picture_ballon: "Photo du dispositif d'eau",
    detecteurFumee: 'Détecteur de fumée',
    coffreFort: "Présence d'un coffre fort",
    systemeAutonome: "Système d'arrivée autonome",
    systemeAutonomeCode: 'Code',
    systemeAutonomeLocalisation: 'Localisation',
    systemeAutonomeLocalisation_placeholder: "Précisez où se trouve le système d'arrivée autonome.",
    systemeAutonomeCode_placeholder: "Précisez le code du système d'arrivée autonome.",
    appartmentFloor: "Numéro d'étage",
    appartmentAccess: "Instructions d'accès",
    ownerSpace: 'Souhaitez-vous définir un espace hôte dans votre logement ?',
    ownerSpaceComment: 'Commentaires',
    commentaire: 'Commentaire',
    reservation: 'Réservations',
    mandat: 'Contrats',
    my_mandat: 'Mon mandat de gestion',
    mandatNum: 'N° de mandat de gestion',
    description: 'Description du logement',
    headline: 'Résumé du logement',
    content_error_emoji: "Ce champ ne doit pas contenir d'emoji",
    content_error_uppercase: "Ce champ ne doit pas contenir plus de 5 majuscules dont 3 d'affilée",
    content_error_uppercase_consecutive: "Ce champ ne doit pas contenir plus de 5 majuscules d'affilée",
    content_error_url: 'Ce champ ne doit pas contenir de lien de site web',
    content_error_email: "Ce champ ne doit pas contenir d'adresse email",
    content_error_phone: 'Ce champ ne doit pas contenir de numéro de téléphone',
    status: 'Statut',
    available: 'Disponible',
    maintenance: 'En maintenance',
    hostReservation: 'Réservation hôte',
    rented: 'Loué',
    townStayRateId: 'Groupe de taxe de séjour pour la ville',
    regionStayRateId: 'Groupe de taxe de séjour additionnelle',
    maisonIndividuelle: 'Logement individuel',
    maisonEnCopro: 'Logement en copropriété',
    appartImmeubleCollectif: 'Appartement dans un immeuble collectif',
    accommodation_creation_in_progress: 'Fichier en cours de création',
    immeubleRegimeCopro: 'Appartement soumis au régime de la copropriété',
    maisonRegimeCopro: 'Maison soumise au régime de la copropriété',
    noRegimeCopro: 'Logement non soumis au régime de la copropriété',
    autresParties: 'Sélectionnez les autres parties du logement',
    autresParties_: 'Autres parties',
    garage: 'Garage',
    cabanon: 'Cabanon',
    cave: 'Cave',
    dependance: 'Dépendance',
    outsideDescription:
      "Votre extérieur, pouvez-vous nous préciser toutes les informations concernant l'extérieur de votre logement",
    registrationNumber: "Numéro d'enregistrement",
    registrationDate: 'Date de délivrance',
    portail: 'Portail',
    portailType: 'Type de portail',
    portailOuverture: "Type d'ouverture",
    portailCode: 'Code du portail',
    terrasse: 'Terrasse',
    velos: 'Vélos',
    nbVelo: 'Nombre de vélos',
    velosEmplacement: 'Emplacement des vélos',
    not_send_to_smily: 'Ne pas envoyer sur Smily',
    all: 'Tous les logements',
    enabled_only: 'Uniquement les logements actifs',
    disabled_only: 'Uniquement les logements inactifs',
    priceCalendar: 'Calendrier tarifaire',
    priceRules: ' Conditions et tarifs',
    synchronisation: 'Synchronisation',
    airbnb_account: 'Compte hôte',
    synchronisation_airbnb_blocked:
      "La diffusion sur Airbnb n'est pas disponible, car le propriétaire n'a pas sélectionné Airbnb parmi les plateformes de multidiffusion.",
    external_id_copied: 'Identifiant copié dans le presse-papier',
    updatePriceRules: 'Modifier les prix de base',
    addPriceRulesPeriod: 'Ajouter une régle de période',
    basePriceRules: 'Prix de base',
    priceRulesPeriode: 'Prix spécifique à la période',
    baseMinimumStay: 'Nb nuits de base',
    minimumStayPeriod: 'Nombre de nuit minimum pour la période',
    annualProfitTarget: 'Objectif de revenu annuel (net)',
    nbNights: 'Nombre de nuits',
    myOwner: 'Moi',
    history: {
      title: 'Historique',
      empty: 'Aucun historique.',
      event: 'Règle',
      detail: 'Détail',
      author: 'Qui',
      date: 'Date',
      active: 'Actif',
      markup_batch: 'Markup en masse',
      markup_specific: 'Mark-up spécifique (logement)',
      markup_general: 'Mark-up général (compte Airbnb)',
      markup_reference: 'Référence : {0}',
      date_basis_stay: 'Séjour',
      date_basis_booking: 'Réservation',
      origin_onboarding: 'onboarding',
      origin_calendar: 'calendrier tarifaire',
      field_base_price: 'Prix de base à la nuit',
      field_min_price: 'Prix minimum à la nuit',
      field_minimum_stay: 'Durée de séjour minimum',
      field_last_minute: 'Blocage des réservations de dernière minute',
      field_airbnb_discount: 'Promotion nouvelle annonce',
      price_updated: '{0} ({1})',
      accommodation_price_rule_created: 'Règle de prix ajoutée',
      accommodation_price_rule_updated: 'Règle de prix modifiée',
      accommodation_price_rule_deleted: 'Règle de prix supprimée',
      accommodation_price_period_created: 'Période ajoutée',
      accommodation_price_period_updated: 'Période modifiée',
      accommodation_price_period_deleted: 'Période supprimée',
      minimum_stays_updated: 'Durée de séjour minimum le {0}',
      cancel_rule_updated: "Politique d'annulation",
      kind_arrival_only: "Jours d'arrivée",
      kind_departure_only: 'Jours de départ',
      kind_stay_at_least: 'Séjour long',
      kind_stay_shorter_than: 'Séjour court',
      kind_additional_person_fixed_per_night: 'Personne supplémentaire',
      kind_late_booking: 'Réservation de dernière minute',
      kind_early_booking: 'Réservation anticipée',
      period_type_STAY: 'Séjour minimum sur une période',
      period_type_PRICE: 'Prix sur une période',
      always_applied: 'Toujours appliquée',
      nights: '{0} nuit(s)',
      persons: '{0} pers',
      per_night: '{0} / nuit',
    },
    price_rules: {
      rule: 'Règle',
      the_rule: 'la règle',
      title_arrival_only: "Définir les jours d'arrivées sur une période",
      title_person_rules: 'Régle : majoration par personnes supplémentaires',
      title_departure_only: 'Définir les jours de départs sur une période',
      rule_arrival_only: "Règle d'arrivée",
      rule_departure_only: 'Règle de départ',
      rule_person: 'Définir une majoration sur une période',
      add_rule_period: 'Ajouter une règle pour une période',
      error_always_applied:
        'Une règle "Toujours appliquée" existe déjà. Il n\'est pas possible d\'en créer plusieurs. Veuillez modifier la règle existante.',
      title_stay_at_least: 'Définir une augmentation ou une promotion sur une période',
      title_stay_shorter: 'Définir une augmentation ou une promotion pour les séjours de courte durée',

      percentage_plus: 'Augmentation',
      percentage_minus: 'Promotion',
      error_always_applied_same_length:
        'Une règle "Toujours appliquée" existe déjà pour ce même nombre de nuits. Il n\'est pas possible d\'en créer plusieurs. Veuillez modifier la règle existante.',
      error_always_applied_same_occupation:
        'Une règle "Toujours appliquée" existe déjà pour ce même nombre de personnes. Il n\'est pas possible d\'en créer plusieurs. Veuillez modifier la règle existante.',
      error_conflict_always_applied:
        "Conflit de règles : une règle « Toujours appliquée » est déjà active et prendra le dessus sur cette règle par période. Modifiez ou supprimez la règle permanente pour que la règle par période s'applique.",
      error_conflict_period:
        "Conflit de règles : une règle « par période » est déjà active et ne peut pas se superposer à une règle « Toujours appliquée ». Modifiez ou supprimez la règle par période pour que la règle toujours appliquée s'applique.",
      title_late_booking:
        'Définir une augmentation ou une promotion pour les réservations de dernière minute sur une période',
      title_early_booking: 'Définir une augmentation ou une promotion pour les réservations anticipées sur une période',
    },
    dialog: {
      confirm_owner:
        'Ces changements seront visibles par les voyageurs. Pensez à mettre à jour votre annonce si nécessaire.',
      confirm_update_model:
        'Êtes-vous sûr de vouloir modifier toutes les fiches logements reliées à la fiche logement {0} ?',
      airbnb_discount_title: 'Promotion nouvelle annonce',
      airbnb_discount_enable: 'Êtes-vous sûr de vouloir activer la promotion nouvelle annonce ?',
      airbnb_discount_disable: 'Êtes-vous sûr de vouloir désactiver la promotion nouvelle annonce ?',
    },
    price_calendar: {
      reminder: 'Rappel',
      base_price_reminder: 'Votre prix de base à la nuit est de {0}',
      base_price_info:
        'Prix de base par nuit (avant frais plateforme). Guestadom applique une augmentation automatique pour couvrir les frais des plateformes de réservation.',
      min_price_reminder: 'Votre prix minimum à la nuit est de {0}',
      min_price_info:
        'Prix minimum par nuit (avant frais plateforme). Guestadom applique une augmentation automatique pour couvrir les frais des plateformes de réservation.',
      minimum_stay_reminder: 'Votre durée de séjour minimum est de {0} nuit(s)',
      last_minute_reminder:
        "Vous avez bloqué les réservations de dernières minutes ayant un délai de {0} avant la date d'arrivée",
      new_listing_promotion: 'Promotion nouvelle annonce',
    },
    boarding_pass: "Livret d'accueil",
    boarding_pass_link: "Lien du livret d'accueil",
    boarding_pass_updated: "Le livret d'accueil a bien été modifié",
    rentals_tag: 'Étiquettes du logement',
    model_label: 'Fiche logement modèle',
    model_only: 'Uniquement les logements modèles',
    non_model_only: 'Uniquement les logements dupliqués',
  },
  contact: {
    role: 'Rôle',
    job: 'Métier',
    civility: 'Titre',
    civilityManager: 'Civilité du représentant',
    firstName: 'Prénom',
    firstNameManager: 'Prénom du représentant',
    lastName: 'Nom',
    lastNameManager: 'Nom du représentant',
    function: 'Qualité',
    functionManager: 'Qualité du représentant',
    email: 'E-mail',
    phone: 'Téléphone',
    phone2: 'Téléphone (2)',
    address1: 'Adresse',
    address1Manager: 'Adresse du siège social',
    address2: 'Complément',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    remarque: 'Remarque',
    request: 'Votre demande',
    companyName: 'Société',
    formeJuridique: 'Forme juridique',
    raisonSociale: 'Raison sociale',
    siret: 'SIRET',
    villeRcs: 'Ville RCS',
    member: 'Indivisaire',
    addMember: 'Ajouter un indivisaire',
    deleteMemberWarning: 'Êtes-vous sûr de vouloir supprimer cet indivisaire ?',
    internal_confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce gestionnaire ?',
    internal_confirm_title: 'Supprimer un gestionnaire',
    internal_error_message: 'Une erreur est survenue lors de la récupération des données du gestionnaire',
    internal_duplicate: 'Un utilisateur ayant ce rôle a déjà été ajouté.',
    external_confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce contact divers ?',
    external_confirm_title: 'Supprimer un contact divers',
    confirm_delete: 'Vous êtes sur le point de supprimer un contact, êtes-vous sûr ?',
    confirm_delete_member: 'Vous êtes sur le point de supprimer un indivisaire, êtes-vous sûr ?',
    confirm_title: 'Supprimer ce contact ?',
    confirm_title_member: 'Supprimer cet indivisaire ?',
    deleted: 'Le contact a bien été supprimé',
    enabled: 'Activé',
    create: 'Création du contact',
    created: 'Le contact a bien été créé',
    update: 'Modifier un contact',
    updated: 'Les informations de contact ont été mises à jour',
    error: 'Erreur durant la mise à jour des informations de contact',
    unknown: 'Contact inconnu',
    unknown_address: 'Adresse inconnue',
    unknown_type: 'Type inconnu',
    unknown_details: 'Coordonnées inconnues',
    add: 'Ajouter un contact',
    error_check: 'Merci de vérifier les informations requises sur chaque contact.',
  },
  ownerPurchase: {
    list: 'Achats hôte',
    one: 'Achat hôte',
    add: 'Ajouter un achat',
    update: 'Modifier un achat',
    delete: 'Êtes-vous sûr de vouloir supprimer cet achat ?',
    price: 'Prix',
    name: "Nom de l'achat",
    purchaseDate: "Date de l'achat",
    type: "Type d'achat",
    details: 'Achat hôte',
    updateThis: 'Modifier',
    empty: 'Aucun achat',
    tva: 'TVA',
    accommodationId: 'Logement associé',
    added: "L'achat hôte a bien été ajouté",
    updated: "L'achat hôte a bien été modifié",
  },
  reservation: {
    sendAutoReview: "Envoi automatique de l'avis",
    activity: 'Communication',
    action: 'Action',
    list: 'Réservations',
    my_list: 'Mes réservations',
    list_long: 'Liste des réservations',
    one: 'Réservation',
    add: 'Ajouter une réservation',
    update: 'Modifier une réservation',
    delete: 'Êtes-vous sûr de vouloir supprimer cette réservation ?',
    added: 'La réservation a bien été ajoutée',
    updated: 'La réservation a bien été modifiée',
    deleted: 'La réservation a bien été supprimée',
    details: 'Réservation',
    updateThis: 'Modifier',
    empty: 'Aucune réservation',
    accommodationId: 'Logement associé',
    type: 'Type',
    guest: 'Voyageur',
    statusSmily: 'Statut',
    creation_date: 'Création',
    localizer: 'Réservation',
    localizerLong: 'Numéro de réservation',
    excludePlanning: 'Exclu du planning',
    paymentType: 'Type de paiement',
    comment: 'Commentaire',
    reservationType_guest: 'Voyageur',
    reservationType_guest_cancel: 'Annulation voyageur',
    reservationType_owner: 'Hôte',
    reservationType_owner_cancel: 'Annulation Hôte',
    reservationType_blockade: 'Indisponible',
    reservationType_blockade_cancel: 'Annulation Indisponible',
    status_payment: 'Statut de paiement',
    statusRefund: 'Statut de remboursement',
    statusRefund_pending: 'En attente',
    statusRefund_accepted: 'Accepté',
    statusRefund_refused: 'Refusé',
    statusRefund_contested: 'Contesté',
    dateStart: 'Date de début de séjour',
    dateEnd: 'Date de fin de séjour',
    hourCheckin: 'Heure de check-in',
    hourCheckout: 'Heure de check-out',
    dateCheckin: 'Date de check-in',
    dateCreated: 'Date de création',
    dateCheckout: 'Date de check-out',
    periodCheckin: 'Check-in',
    periodCreated: 'Création',
    periodCheckout: 'Check-out',
    reservation_site: 'Plateforme',
    reservation_sites_select: 'Sélectionnez les plateformes souhaitées',
    guestFirstName: 'Prénom du client',
    guestLastName: 'Nom du client',
    guestPhone: 'Téléphone',
    guestContactDate: 'Coordonnées mises à jour le {0}',
    guestPhone2: 'Téléphone (2)',
    guestMail: 'Email',
    nbAdults: "Nb d'adultes",
    nbChildren: "Nb d'enfants",
    nbBabies: 'Nb de bébés',
    cautionDone: 'Caution déposée',
    paymentDone: 'Paiement effectué',
    comments: 'Commentaires',
    occupantInfo: "Information sur l'occupant",
    blockadeReason: 'Motif',
    blockade_travaux: 'Travaux',
    blockade_renov: 'Rénovation',
    contact_data_mandatory: 'Une donnée de contact est obligatoire pour le client',
    nb_people_mandatory: 'Le nombre de personnes doit être supérieur à 0',
    period: 'Séjour',
    dateCancel: 'Annulation',
    dateRefund: 'Remboursement',
    planning: 'Calendrier',
    planning_link: 'Voir le calendrier',
    accommodation: 'Logement',
    prestations: 'Prestations',
    extra: 'Extras',
    stayTax: 'Taxe de séjour',
    plateformFee: 'Frais de plateforme',
    amountStay: 'Montant de séjour',
    feeWelcome: "Frais d'accueil",
    feeService: 'Frais de service',
    feeHousework: 'Frais de ménage',
    feeHouseworkOwner: 'Frais de ménage départ hôte',
    amountThreshold: 'Seuil de montant de séjour',
    gainMinGuestadom: 'Gain minimal pour Guestatom',
    comGa: 'Pourcentage de frais de gestion pour Guestadom',
    comGas: 'Pourcentage de frais de gestion pour GAS',
    number: 'Réservation',
    state_reversed: 'Réservations payées',
    state_not_reversed: 'Réservations impayées',
    payment: 'Réglement',
    cancel: 'Annulation',
    payment_details: 'Détails de règlement de la réservation',
    cancel_details: "Détails de l'annulation de la réservation",
    agentLocalizator: 'Localisateur agent intermédiaire',
    managementStatus: 'Statut de gestion',
    pending_refund: 'Remboursement en attente',
    cancelled: 'Annulée',
    cancelled_creation_in_progress: 'Fichier en cours de création',
    payment_creation_in_progress: 'Paiement en cours de création',
    error_export: "Une erreur est survenue lors de l'export",
    error_no_cancelled: 'Aucune annulation à exporter',
    amountTotal: 'Montant total',
    amountPaid: 'Montant total encaissé',
    amountPaidNight: 'Montant encaissé pour les nuits',
    amountPaidOta: 'Montant encaissé par la plateforme',
    amountPaidHousework: 'Montant encaissé pour le ménage',
    amountPaidTds: 'Montant encaissé pour la TDS',
    litige: 'Litige',
    litigeStarted: 'Litige déclaré',
    litigeEnded: 'Litige résolu',
    litigePending: 'Litige',
    dateStartLitige: 'Date de début de litige',
    dateEndLitige: 'Date de fin de litige',
    amountLitige: 'Montant du litige',
    amountLitigeEstimated: 'Montant du litige estimé',
    amountLitigeReported: 'Montant du litige encaissé',
    amountLitigeGas: 'Part pour GAS',
    amountLitigeGav: 'Part pour GAV',
    amountLitigeOwner: "Part pour l'hôte",
    startLitige: 'Déclarer un litige',
    endLitige: 'Résoudre le litige',
    reclamation: 'Réclamation',
    reclamationStarted: 'Réclamation déclarée',
    reclamationEnded: 'Réclamation résolue',
    reclamationPending: 'Réclamation',
    dateStartReclamation: 'Début de réclamation',
    dateEndReclamation: 'Fin de réclamation',
    amountReclamation: 'Montant de la réclamation',
    amountReclamationEstimated: 'Montant de la réclamation estimé',
    amountReclamationReported: 'Montant de la réclamation reversé',
    amountReclamationGas: 'Part pour GAS',
    amountReclamationGav: 'Part pour GAV',
    amountReclamationOwner: "Part pour l'hôte",
    startReclamation: 'Déclarer une réclamation',
    endReclamation: 'Résoudre la réclamation',
    contestation: 'Contestation',
    contestationStarted: 'Contestation déclarée',
    contestationEnded: 'Contestation résolue',
    contestationPending: 'Contestation',
    dateContestation: 'Date de contestation',
    dateStartContestation: 'Début de contestation',
    dateEndContestation: 'Fin de contestation',
    amountContestation: 'Montant de contestation',
    amountContestationEstimated: 'Montant de contestation estimé',
    amountContestationReported: 'Montant de contestation reversé',
    amountContestationGas: 'Part pour GAS',
    amountContestationGav: 'Part pour GAV',
    amountContestationOwner: "Part pour l'hôte",
    startContestation: 'Déclarer une contestation',
    endContestation: 'Résoudre la contestation',
    refundAccept: 'Accepter',
    refundContest: 'Contester',
    refundRefuse: 'Refuser',
    refundAcceptTitle: 'Accepter le remboursement',
    refundContestTitle: 'Contester le remboursement',
    refundRefuseTitle: 'Refuser le remboursement',
    refundAccepted: 'Remboursement accepté',
    refundContested: 'Remboursement contesté',
    refundRefused: 'Remboursement refusé',
    defautPending: 'Défaut de paiement',
    cancelledBefore30: 'Annulée plus de 30J avant',
    cancelled30Days: 'Annulée + de 30 j',
    nbDaysCancelled: 'Jours entre annulation et check-in',
    cleaningDuration: 'Durée de cleaning prévue',
    avenantMandat: 'Rattaché à',
    ask_cancel: 'Êtes-vous sûr de vouloir annuler cette réservation ?',
    cancel_request: {
      button: "Demander l'annulation",
      title: 'Annuler la réservation de {name} ?',
      title_no_name: 'Annuler cette réservation ?',
      arrival: "Arrivée aujourd'hui | Arrivée demain | Arrivée dans {n} jours",
      cost_value: '400 €',
      cost_label: 'de coût moyen pour vous à chaque annulation',
      visibility_value: '30 %',
      visibility_label: 'de visibilité en moins pour votre annonce',
      platforms:
        'Airbnb, Booking et les autres plateformes sanctionnent sévèrement les hôtes qui annulent. Leur priorité est de protéger les voyageurs, et elles ne font aucune exception.',
      consequences_title: "En confirmant l'annulation, vous vous exposez à :",
      consequence_fees_title: 'Des frais Guestadom :',
      consequence_fees: "frais de gestion et pénalité d'annulation prévus dans votre contrat",
      consequence_platform_title: 'Des pénalités de la plateforme,',
      consequence_platform: "qui s'ajoutent à ces frais",
      consequence_ranking_title: 'Une baisse de classement :',
      consequence_ranking: 'votre annonce sera moins visible, donc moins réservée, pendant plusieurs semaines',
      consequence_review_title: 'Un avis négatif',
      consequence_review: 'visible par tous les futurs voyageurs',
      consequence_relocation_title: 'Le relogement du voyageur à vos frais',
      consequence_relocation:
        'si son arrivée est prévue dans moins de 10 jours. En dernière minute, ce relogement coûte souvent très cher',
      unexpected_title: 'Vous avez un imprévu ?',
      unexpected: "Avant d'annuler, appelez votre chargé de compte. Dans la plupart des cas, il existe une solution.",
      call: 'Appeler {name}',
      call_guestadom: 'Appeler Guestadom',
      understood:
        "Je comprends que cette annulation me sera facturée et qu'elle pénalisera la visibilité de mon annonce.",
      understood_required: "Cochez la case pour confirmer l'annulation.",
      confirm: 'Annuler quand même',
      keep: 'Conserver ma réservation',
      success: "Demande d'annulation effectuée. Guestadom traitera votre demande dès qu'elle sera réceptionnée.",
    },
  },
  maintenance: {
    list: 'Maintenances',
    my_list: 'Mes maintenances',
    details: 'Fiche maintenance',
    one: 'Maintenance',
    empty: 'Aucune maintenance',
    add: 'Nouvelle maintenance',
    added: 'La maintenance a bien été créée',
    create: 'Créer une maintenance',
    update: 'Modifier une maintenance',
    updated: 'La maintenance a bien été modifiée',
    updateThis: 'Modifier',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette maintenance ?',
    responsable: 'Responsable',
    repairer: 'Réparateur',
    repairer_artisan: 'Artisan',
    repairer_gav: 'GAV',
    cost: 'Coût',
    responsable_guest: 'Client',
    responsable_usure: 'Usure',
    responsable_salary: 'Salarié',
    accommodationId: 'Logement',
    companyName: 'Agence',
    date_maintenance: 'Découverte',
    date_resolution: 'Résolution',
    tag: 'Tag',
    status: 'Statut',
    owner: 'Hôte',
    ownerChoice: "Choix de l'hôte",
    action: 'Action',
    resolve: 'Résoudre',
    acknowledged: 'La maintenance a bien été classifiée',
    resolved: 'La maintenance a bien été résolue',
    resolve_maintenance: 'Résoudre la maintenance',
    trait: 'Traiter la maintenance',
    trait_maintenance: 'Traiter la maintenance',
    traited: 'La maintenance a bien été traitée',
    refuse_maintenance: "Gérée par l'hôte",
    accept_maintenance: 'Gérée par Guestadom',
    managed_by: 'Maintenance gérée par :',
    refus_comment: 'Raison du refus',
    refus: 'Refusée',
    refused: "La maintenance sera gérée par l'hôte",
    refuse_title: 'Refuser la maintenance',
    confirm_refuse: 'Êtes-vous sûr de vouloir gérer vous-même cette maintenance ?',
    accept: 'Acceptée',
    accepted: 'La maintenance sera gérée par Guestadom',
    accept_title: 'Accepter la maintenance',
    confirm_accept: 'Êtes-vous sûr de vouloir déléguer cette maintenance à Guestadom ?',
    start: 'Démarrer la maintenance',
    started: 'La maintenance a bien été démarrée',
    confirm_start: 'Êtes-vous sûr de vouloir démarrer cette maintenance ?',
    usure: 'Usure',
    litige: 'Litige',
    discovery_person: 'Personne qui a fait la découverte',
    problem: 'Problème',
    description: 'Description',
    photos: 'Photos',
    error_empty_photos: 'Le champ Photos est requis',
    reference: 'Marque / référence équipement',
    comment: 'Commentaire',
    comment_treatment: 'Commentaire sur le traitement',
    priority: 'Priorité',
    priority_urgent: 'Urgent',
    priority_high: 'Haut',
    priority_medium: 'Normal',
    priority_low: 'Bas',
    a_resoudre: 'À résoudre',
    a_traiter: 'À traiter',
    en_attente: 'En attente',
    decision_prise: 'Décision prise',
    en_cours: 'En cours',
    resolue: 'Résolue',
    amount_estimated: 'Montant estimé TTC',
    amount_ttc: 'Montant TTC',
    link_url: 'Lien URL',
    silent: "Mode silencieux (ne pas notifier l'hôte)",
    file: 'Pièce jointe',
    error_empty_files: 'Le champ Fichier est requis',
    description_resolution: 'Description de la résolution',
    amount_ht: 'Montant HT',
    amount_gas: 'Imputé à GAS',
    amount_gav: 'Imputé à GAV',
    amount_owner: "Imputé à l'hôte",
    error_total_amount: 'La somme des montants saisis ne correspond pas au montant total TTC renseigné',
  },
  assigned_staff: {
    type: "Type d'intervenants",
    prestataire: 'Prestataire',
    intern: 'Salarié',
    housekeeper: 'Concierge partenaire',
    partner: 'Conciergerie partenaire',
  },
  planification: {
    owner: "Nom de l'hôte",
    reservation: 'Réservation actuelle',
    next_reservation: 'Réservation suivante',
    last_reservation: 'Réservation précédente du logement',
    last_comment_prestataire: 'Commentaire intervenant',
    accommodation_address: 'Adresse du logement',
    date_created_reservation: 'Date création réservation',
    laundry_included: 'Linge inclus',
    checkin_autonome: 'Arrivée autonome',
    checkout_autonome: 'Départ autonome',
    extras: 'Extras commandés',
    extra: 'Extra',
    prestataire: 'Prestataire',
    intern: 'Interne (salariés GA)',
    housekeeper: 'Concierge',
    start_hour: 'Heure de début',
    duration: 'Durée',
    comment: 'Commentaire',
    price: 'Tarif',
    number_staff: 'Nombre de personne affecté',
  },
  mission_order: {
    title: 'Ordres de mission',
    title_create: 'Créer des ordres de mission',
    create: 'Créer',
    create_success: "L'ordre de mission a bien été créé",
    empty: 'Aucun ordre de mission',
    accommodation: 'Logement',
    reservation: 'Réservation',
    document_model: 'Modèle de contrat',
    assigned_staff: 'Personnel affecté',
    date: 'Date prévue',
    start_hour: 'Heure de début',
    duration: 'Durée prévue',
    comment: 'Commentaire',
    price: 'Tarif',
    number_staff: 'Nombre de personne(s) affectée(s)',
    offer_price: 'Tarif de la prestation n°',
    comment_on_offer: 'Commentaire de la prestation n°',
    error_missing_fields: 'Un ou plusieurs champs obligatoires ne sont pas renseignés.',
    error_no_reservation:
      'Vous devez choisir une réservation pour pouvoir créer des missions de type "Check-in" et/ou "Check-out"',
    tabs: {
      all: 'Tous les ordres',
      proposed: 'Proposée',
      accepted: 'Planifiée',
      completed: 'Terminée',
      litigation: 'Litige',
      canceled: 'Annulée',
    },
    mission_status: 'Statut de la mission',
    nb_participants: 'Intervenants',
    date_created: 'Création',
    date_start: 'Prestation',
    date_cancel: 'Annulation',
    canceller: 'Personne qui a annulé la mission',
    type: 'Type de mission',
  },
  mission_order_details: {
    planned_mission_duration: 'Durée de mission prévue',
    edit_success: 'La mission a bien été modifiée',
    cancel_success: 'La mission a bien été annulée',
    repropose_success: 'La mission a bien été remise en ligne',
  },
  mission_dashboard: {
    title: 'Dashboard des missions',
  },
  waiting_orders: {
    title: "En attente d'ordre",
    one: "Réservation en attente d'ordre",
    new: 'Nouvelle mission',
    empty: "Aucune réservation en attente d'ordre",
    company: 'Agence',
    accommodation: 'Logement',
    reservation: 'Réservation',
    client: 'Nom du voyageur',
    owner: 'Propriétaire',
    accommodation_address: 'Adresse',
    date_created: 'Date création réservation',
    date_start: 'Date de check-in',
    date_end: 'Date de check-out',
    client_infos: 'Voyageur',
    create: 'Créer des missions',
    tabs: {
      filter_12_months: '12 mois',
      filter_30_days: '30 jours',
      filter_7_days: '7 jours',
      filter_24_hours: '24 heures',
      sidebar_previous: 'Précédente',
      sidebar_current: 'Actuelle',
      sidebar_next: 'Suivante',
    },
  },
  accounting: {
    informations: 'Informations',
    mandant: 'Comptabilité mandante',
    stay_rate: 'Groupe de TDS',
    operations: 'Opérations',
    account: 'Comptes',
    balance: 'Balance',
    solde: 'Solde',
    payment: 'Règlement',
    cancel: 'Annulation',
    visitor_tax: 'Taxes de séjour',
    third_party_account: 'Compte de tiers',
    my_third_party_account: 'Mon compte de tiers',
    third_party_details: 'Détails de compte de tiers',
    bank_reconciliation: 'Rapprochement bancaire',
    bank_reconciliation_details: 'Détails du rapprochement bancaire',
    date: "Date d'opération",
    label: 'Libellé',
    debit: 'Débit',
    credit: 'Crédit',
    empty: 'La liste des comptes est vide',
    total: 'Total',
    number: 'Numéro de compte',
    amount: 'Montant',
    type: 'Type',
    consultation: 'Consultation',
    transactions: 'Écritures comptables',
    free_od: 'Saisie OD libre',
    error_not_mandat: "Le compte saisi n'est pas un compte de mandat de gestion",
    error_not_resa: "Le compte saisi n'est pas un compte de réservation",
    error_not_for_online: 'Cette transaction ne peut être facturée sur une offre Essentielle',
    owner_crg: 'Paiements',
    commission: 'Frais de gestion',
  },
  transaction: {
    update: 'Modification de transaction',
    updated: 'Transaction modifiée',
  },
  balance: {
    balance_creation_in_progress: 'Balance en cours de création',
    show_resa_account: 'Comptes des résa solde nul',
    show_mandats_terminated: 'Comptes des mandats de gestion résiliés',
    show_only_resa_accounts: 'Comptes des réservations uniquement',
    unknown_template: 'Aucun template trouvé',
  },
  operation: {
    consultation: 'Consultation',
    recurring_charges: 'OD récurrentes',
    validate_owner_charge: 'Opérations à valider',
    account_from: 'Compte débité',
    account_to: 'Compte crédité',
    date_created: 'Date créée',
    date_end: 'Date de fin',
    date_paused: 'Date de pause',
    date_updated: 'Date modification',
    date_validated: 'Date validation',
    date_transaction: 'Opération',
    mandat: 'Mandat de gestion',
    monthly: 'Mensuelle',
    none: 'Aucune',
    add: 'Ajouter une OD',
    edit: 'Modifier une OD',
    add_line: 'Ajouter une ligne',
    delete_line: 'Supprimer une ligne',
    delete_transaction: 'Êtes-vous sûr de vouloir supprimer cette écriture comptable ?',
    delete_transaction_ok: 'Ecriture comptable supprimée',
    delete_line_warning: 'Êtes-vous sûr de vouloir supprimer cette ligne ?',
    limit_size_line: 'Suppression impossible, une transaction ne peut pas faire moins de deux lignes',
    type: "Type d'OD",
    number: 'Numéro de compte',
    account: 'Compte',
    added: 'OD ajoutée',
    added_free_od: 'OD libres ajoutées',
    added_bank_reconciliation: 'Rapprochement bancaire ajouté',
    date: 'Date',
    label: 'Libellé',
    creator: 'Crée par',
    updater: 'Mis à jour par',
    company: 'Agence',
    amount: 'Montant',
    amounts: 'Montants',
    amount_total: 'Montant total',
    amount_GAS: 'Montant GAS',
    amount_GAV: 'Montant GAV',
    amount_owner: 'Montant hôte',
    amount_annulation_commission: 'Montant commission',
    amount_annulation_forfait: 'Montant forfait',
    comment: 'Commentaire',
    minutes: 'Temps de déplacement',
    minute: 'minutes',
    ota: 'OTA',
    empty: 'Aucune opération à afficher',
    empty_bank_reconciliation: 'Aucun rapprochement bancaire à afficher',
    empty_date: "La date d'opération doit être renseignée",
    empty_account_num: 'Le numéro de compte doit être renseigné',
    empty_label: 'Le libellé ne peut etre vide',
    empty_amount: 'Un montant de débit ou de crédit doit être saisi',
    double_amount: 'Un montant de débit et de crédit ne peuvent être saisi en même temps',
    total: 'Total',
    revert: 'Rejet de paiement',
    payment: 'Paiement',
    tds: 'Taxe de séjours',
    fstripe: 'Frais Stripe',
    free_od: 'OD Libre',
    rebalance: 'Rééquilibrage',
    recurrence_period: 'Récurrence',
    recurrence: 'Récurrente',
    reservation: 'Réservation',
    update: 'Modifier',
    delete: 'Supprimer',
    pause_recurring: 'Mettre en pause',
    pause_recurring_back: 'Activer',
    compta_charge_paused: 'Récurrence mise en pause',
    compta_charge_actived: 'Récurrence activée',
    compta_charge_deleted: 'Récurrence effacée',
    compta_charge_modify: 'Modifier une charge récurrente',
    compta_charge_updated: 'Charge récurrente modifiée',
    create_bank_reconciliation: 'Ajouter un rapprochement bancaire',
    transaction_free_od: ' TRANSACTION OD LIBRE',
    error_amount: 'Le montant ne peux contenir que des chiffres, virgules ou points',
    error_amount_zero: 'Le montant ne peux pas être zéro',
    error_valid_amounts: 'La somme des montants saisis ne correspond pas au montant total renseigné',
    error_transaction: "Le montant de la transaction n'est pas correct, le débit et le crédit doivent se valoir",
    error_reject_more_paid: 'Le montant du rejet ne peux dépasser le montant reglé',
    error_price_less: 'Le montant du paiement ne peux dépasser le prix total',
    error_already_payed: 'Le montant à déjà été reglé',
    error_no_minutes: 'Le temps de déplacement doit être supérieur à 0',
    error_update: 'Un problème est survenu lors de la mise à jour',
    error_delete: 'Un problème est survenu lors de la suppression',
    error_add_bank_reconciliation: "Un problème est survenu lors de l'ajout du rapprochement bancaire",
    undefined: 'Non définie',
    delete_warning_recurrence: 'Supprimer cette charge récurrente?',

    ACHAT_HOTE: 'Achat hôte',
    ACOMPTE: 'Acompte',
    ASSURANCE: "Frais d'assurance",
    AVOIR: 'Avoir',
    CAUTION_OD_ENCAISSEMENT: "Caution (OD d'encaissement)",
    COMMISSION: 'Commission',
    FRAIS_ANNULATION_HOTE: "Frais d'annulation hôte",
    COMMISSION_FRAIS_ANNULATION_VOYAGEUR: "Commission - Frais d'annulation voyageur",
    COMPTE_A_COMPTE: "D'un compte à un compte",
    CRG_CLOSED: 'Clôture de CRG',
    CRG_REPORT: 'Report de CRG',
    DEEP_CLEANING: 'Deep cleaning',
    EXTRA_VOYAGEURS: 'Extra voyageurs',
    FORFAIT_VERIFICATION_MENAGE_HOTE: "Forfait - 'Vérification' ménage hôte",
    FRAIS_ACCUEIL: "Frais d'accueil",
    FRAIS_DE_BLANCHISSERIE: 'Frais de blanchisserie',
    FRAIS_ASSURANCE: "Frais d'assurance",
    FRAIS_DE_MAINTENANCE: 'Frais de maintenance',
    FRAIS_DE_LANCEMENT: 'Frais de lancement',
    FRAIS_DE_LANCEMENT_PARTNER: 'Frais de lancement concierge partenaire',
    FRAIS_DE_FONCTIONNEMENT: 'Frais de fonctionnement',
    FRAIS_DE_MAINTENANCE_OLD: 'Frais de maintenance (ancien)',
    MAINTENANCE: 'Maintenance',
    FRAIS_DE_MENAGE: 'Frais de ménage',
    FRAIS_DE_MENAGE_HOTE: 'Frais de ménage hôte',
    FRAIS_DE_MENAGE_VOYAGEUR: 'Frais de ménage voyageur',
    FRAIS_DE_SERVICE_GA: 'Frais de service GA',
    FRAIS_OPERATIONNEL: 'Frais opérationnel',
    FSTRIPE: 'Frais Stripe',
    LITIGE: 'Litige voyageur',
    NUISANCE_SONORE: 'Nuisance sonore',
    OD_LIBRE: 'OD Libre',
    OUVERTURE_HIVERNAGE: 'Forfait ouverture hivernage',
    FERMETURE_HIVERNAGE: 'Forfait fermeture hivernage',
    PAYMENT: 'Paiement',
    REFUND: 'Remboursement',
    RECLAMATION: 'Réclamation voyageur',
    REMBOURSEMENT_HOTE: 'Remboursement hôte',
    REMBOURSEMENT_VOYAGEUR: 'Remboursement voyageur',
    REFUND_GUEST: 'Remboursement voyageur',
    REFUND_GUESTADOM: 'Remboursement Guestadom',
    RESERVATION: 'Réservation',
    REVERT: 'Rejet de paiement',
    TDS: 'Taxe de séjours',
    TROP_PERCU: 'Trop perçu',
    VERIFICATION_MENAGE_HOTE: 'Vérification ménage hôte',
    VIREMENT_CRG: 'Virement de CRG',
    VIREMENT_HOUSEKEEPER_CRG: 'Virement de CRG Concierge',
    PRELEVEMENT_CRG: 'Prélèvement de CRG',
    VIREMENT_OTA: 'Virement OTA',
    VIREMENT_TDS: 'Virement TDS',
    START_FEES: 'Frais de lancement',
    CANCEL_FEE: "Frais d'annulation",
    CANCEL: 'Annulation',
    HOTE: "Remboursement pour l'hôte",
    GAV: 'Remboursement pour GAV',
    GAS: 'Remboursement pour GAS',
    od22: "OD d'encaissement remboursement champs libre",
  },
  owner_cancel: {
    item: 'Annulation hôte',
    empty: 'Aucune annulation hôte à afficher',
    date_cancel: "Date d'annulation",
    details: "Détails de l'annulation",
    guest_contacted: 'Guest contacté',
    guest_refunded: 'Remboursement voyageur fait',
    status_updated: 'Le statut a été mis à jour',
    GUEST_TO_CONTACT: 'Guest à contacter',
    GUEST_TO_REFUND: 'Remboursement voyageur à faire',
    DONE: 'Annulation traitée',
  },
  facturation_voyageur: {
    empty: 'Aucune facturation voyageur à afficher',
    title: 'Facturation voyageur',
    REMBOURSEMENT_VOYAGEUR: 'Remboursement voyageur',
    RECLAMATION: 'Réclamation voyageur',
    LITIGE: 'Litige voyageur',
    amount: 'Montant',
    type: 'Type de facturation',
    add: 'Ajouter une transaction',
    added: 'Transaction ajoutée',
  },
  facturation_hote: {
    details: "Détail d'une facturation hôte",
    filter: 'Filtrer',
    facturation_hote: 'Facturation hôte',
    owner_charge: 'Charge hôte',
    type: 'Type de facturation',
    ACHAT_HOTE: 'Achat hôte',
    FRAIS_DE_MAINTENANCE: 'Frais de maintenance',
    FORFAIT_HIVERNAGE: 'Forfait hivernage',
    OUVERTURE_HIVERNAGE: 'Forfait ouverture hivernage',
    FERMETURE_HIVERNAGE: 'Forfait fermeture hivernage',
    FRAIS_DE_MENAGE_HOTE: 'Frais de ménage hôte',
    FRAIS_ANNULATION_HOTE: "Frais d'annulation hôte",
    NUISANCE_SONORE: 'Nuisance sonore',
    REMBOURSEMENT_HOTE: 'Remboursement hôte',
    status: 'Statut',
    IN_PROGRESS: 'En cours',
    VALIDATED: 'Validée',
    DELETED: 'Supprimée',
    amount: 'Montant',
    motif: 'Motif',
    deplacement_minutes: 'Temps',
    date_created: 'Création',
    date_transaction: 'Opération',
    date_intervention: "Date d'intervention",
    date_purchase: "Date d'achat hôte",
    type_operation: "Type d'opération",
    add_owner_charge: 'Ajouter une charge hôte',
    update_owner_charge: 'Modifier une charge hôte',
    empty: 'Aucune charge hôte à afficher',
    owner_charge_added: 'Charge hôte ajoutée',
    owner_charge_validated: 'Charge hôte validée',
    owner_charge_updated: 'Charge hôte modifiée',
    owner_charge_deleted: 'Charge hôte supprimée',
    validate: 'Valider',
    update: 'Modifier',
    update_validate: 'Modifier et valider',
    delete: 'Supprimer',
    files_deleted: 'Le fichier a bien été supprimé',
    confirm_validate: 'Êtes-vous sûr de vouloir valider cette charge hôte ?',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette charge hôte ?',
    confirm_delete_file: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
    error: 'Une erreur est survenue',
    error_already_validated: 'Cette charge hôte est déjà validée',
    error_add: "Une erreur est survenue lors de l'ajout de charge hôte",
    error_delete: 'Une erreur est survenue lors de la suppression',
    error_validate: 'Une erreur est survenue lors de la validation',
    error_files_missing: "Le fichier n'existe pas",
    empty_motif_deplacement: "Les motifs de déplacement doivent être parametrés par l'admin",
    empty_raison_achat_hote: "Les raisons d'achat hôte doivent être parametrées par l'admin",
  },
  owner_charge: {
    list: 'Achats hôtes',
    empty: 'Aucun achat hôte validé',
    IN_PROGRESS: 'En cours',
    VALIDATED: 'Validé',
    DELETED: 'Supprimé',
    error_empty_date_transaction: "Impossible de valider une charge hôte sans date d'opération",
  },
  account: {
    showPositive: 'Soldes positifs',
    showNegative: 'Soldes négatifs',
    showZero: 'Soldes à zéro',
    number: 'Numéro de compte',
    empty: 'Aucune opération trouvée sur ce compte',
    progressive_balance: 'Solde progressif',
    consultation: 'Consultation',
    no_exist: 'Aucun compte trouvé',
    no_cancel_fee: "Aucun frais d'annulation pour ce mandat de gestion",
    no_operations: 'Aucunes opérations trouvées sur ce compte',
    no_mandat: "Un des mandats de gestion n'existe pas",
    already_exist: 'Le compte comptable saisie existe déjà',
    balance: 'Solde',
    third_party_creation_in_progress: 'Comptes de tiers en cours de création',
    fic_mandat_creation_in_progress: 'Registre des mandats de gestion en cours de création',
    fic_avenant_creation_in_progress: 'Registre des avenants en cours de création',
    account_creation_in_progress: 'Consultation en cours de création',
    no_account_number_or_accommodation: 'Le numéro de compte ou le logement doit être renseigné',
    all_third_party: 'Tous les comptes de tiers',
    enabled_only_third_party: 'Uniquement les comptes de tiers actifs',
    disabled_only_third_party: 'Uniquement les comptes de tiers inactifs',
    mandat_resiliated: 'Mandats de gestion résiliés',
  },
  visitor_tax: {
    visitor_tax: 'Taxes de séjour',
    tds: 'TDS',
    date: 'Date de réservation',
    number: 'Numéro de réservation',
    group: 'Groupe TDS',
    amount: 'Montant TDS',
    regional_amount: 'Montant TDS additionnelle',
    total: 'Total TDS',
    status: 'Etat',
    transfert_num: 'Numéro de virement',
    prelevement_num: 'Numéro de prélèvement',
    update: 'Virement de TDS',
    update_transfert_num: 'Num Virement',
    update_prelevement_num: 'Num prélèvement',
    filter_group: 'Rechercher par groupe de TDS',
    filter_region: 'Rechercher par TDS additionnelle',
    filter_date: 'Rechercher par période',
    filter_status: 'Rechercher par état',
    filter_type: 'Rechercher par type',
    date_from: 'A partir du',
    date_to: "Jusqu'au",
    date_created: 'Date création',
    filter: 'Rechercher',
    total_reversed: 'Total reversé',
    total_not_reversed: 'Total en attente',
    state_reversed: 'Reversée',
    state_not_reversed: 'En attente',
    select_all: 'Tout sélectionner',
    submit: 'Générer virement',
    transfert: 'Virement de TDS',
    transferts: 'Virements',
    total_not_selected: 'Total',
    total_selected: 'Total selectionné',
    empty_stayrate_group: "Le groupe de TDS selectionné n'a pas de compte",
    error_stayrate_account: 'Le compte de la TDS ne correspond pas à celui du groupe de TDS',
    error_already_reversed: 'Une TDS selectionnée à déjà été reversée',
    error_empty_selection: 'Aucune TDS selectionnée dans ce lot',
    type: 'Type de TDS',
    details: 'Details des virements TDS',
    date_start: 'Date de début',
    date_end: 'Date de fin',
    date_checkin: 'Date de checkin',
    date_checkout: 'Date de checkout',
    period: 'Période',
    to: 'au',
    stayrate_group_added: 'Lot de TDS enregistré avec succès',
    error_not_same_group: 'Le lot selectionné appartient à plusieurs groupes de TDS différent',
    stayrate_export_in_progress: 'Export des TDS en cours',
    undefined: 'Non défini',
  },
  refund: {
    date: 'Date',
    refund: 'Rembourser',
    add: 'Rembourser',
    added: 'Remboursement ajouté',
    amountTotal: 'Total à rembourser au voyageur',
    amountNight: 'A rembourser pour la nuit',
    amountOta: 'A rembourser à la plateforme',
    change_amount: 'Le montant du remboursement à été modifié',
    change_amount_confirm: 'Le montant à rembourser à été modifié. Confirmer le remboursement?',
  },
  payment: {
    euros: '€',
    statut: 'Statut',
    refundStatut: 'Statut de remboursement',
    filter: 'Rechercher',
    filter_accommodation: 'Rechercher par logement',
    filter_localizer: 'Rechercher par numéro de réservation',
    filter_owner: 'Rechercher par hôte',
    filter_mandat: 'Rechercher par mandat de gestion',
    filter_state_reversed: 'Rechercher par état',
    reset_filter: 'Vider les filtres',
    total: 'Total TTC',
    remaining_payment: 'Reste à payer',
    no_payment: 'Aucun réglèment à afficher',
    next_operations: 'Opérations à venir',
    past_operations: 'Paiements effectués',
    fully_paid: 'Paiement complet',
    action: 'Action',
    actions: 'Actions',
    payment: 'Régler',
    add_payment: 'Nouveau règlement',
    reject_payment: 'Saisir un rejet de paiement',
    reject: 'Rejeter',
    reject_disclaimer1: 'Attention, montant du rejet',
    reject_disclaimer2: 'Pour un rejet partiel, merci de passer par une OD libre.',
    rejected_payment: 'Rejet de paiement enregistré',
    rejected_reason: 'Motif du rejet',
    rejected_amount: 'Montant du rejet',
    rejected_date: 'Date du rejet',
    add: 'Ajouter',
    added: 'Règlement ajouté',
    owner_tds: 'TDS hôte',
    guest_tds: 'TDS voyageur',
    guest_adom_tds: 'TDS Guestadom',
    commission_ota: 'Commission OTA',
    housework: 'Frais de ménage',
    service: 'Frais de service',
    paid: 'Payé',
    paidByGuest: 'Payé par le voyageur',
    refundedToGuest: 'Remboursé au voyageur',
    amount: 'Montant',
    amount_to_refund: 'Montant à rembourser',
    amount_fee: 'Montant frais',
    amount_fee_resa: 'Montant frais (réservation)',
    amount_fee_avenant: 'Montant frais (mandat de gestion)',
    amount_by_night: 'Montant des nuits',
    amount_by_night_percent: '30% montant de la nuit',
    amount_stayrate: 'Montant TDS',
    amount_owner_tds: 'Montant TDS hôte',
    amount_guest_tds: 'Montant TDS voyageur',
    amount_guest_adom_tds: 'Montant TDS Guestadom',
    amount_tds_paid: 'Montant TDS payé',
    amount_owner_tds_paid: 'Montant TDS payé hôte',
    amount_guest_tds_paid: 'Montant TDS payé voyageur',
    amount_guest_adom_tds_paid: 'Montant TDS payé Guestadom',
    amount_tds_total: 'Montant TDS total',
    amount_commission: 'Montant de la commission OTA',
    amount_housework: 'Montant total de ménage',
    extra: 'Extra',
    stripe_fee: 'Frais STRIPE',
    who: 'TDS payé par',
    extra_paid: 'Extra payé?',
    recurrence: 'Récurrence',
    monthly: 'Mensuelle',
    none: 'Aucune',
    date: 'Date',
    days_left_before_start: 'Jours avant résa',
    date_start_end: 'Date',
    source: 'Source',
    method: 'Mode de règlement',
    transfer_num: 'Numéro de virement',
    VACATION_CHECK: 'Chèque vacances',
    CREDIT_CARD: 'TPV Carte de crédit',
    VIRTUAL_CARD: 'Carte virtuelle',
    TRANSFERT: 'Virement',
    UNPAID: 'Impayée',
    PARTIALLY_PAID: 'Partiellement payée',
    TOTALLY_PAID: 'Payée',
    check: 'Chèque',
    stripe: 'Stripe',
    other: 'Autre',
    export: 'Export',
    export_xml: 'Export XML',
    export_excel: 'Export Excel',
    download: 'Télécharger',
    download_mandat: 'Télécharger le rapport des réservations',
    download_pdf: 'Télécharger PDF',
    download_excel: 'Excel',
    download_transfert: 'Exporter le virement',
    number_results: 'Nombre de résultat : ',
    state_reversed: 'Etat',
    update: 'Modifier',
    delete: 'Supprimer',
    delete_warning: 'Supprimer le règlement?',
    success_update: 'Transaction modifiée',
    error_no_payment_reservation: 'Aucun paiement à rejeter sur cette réservation',
    error_no_reservation: 'Aucune réservation trouvée',
    error_transaction_closed: 'Cette transaction est clôturée',
    error_transaction_not_updatable: "Cette transaction n'est pas modifiable",
    notPay: 'Ne pas encaisser',
    not_pay_confirm_title: 'Non encaissement de la réservation',
    not_pay_confirm_message: 'Êtes-vous sûr de ne pas encaisser la réservation ?',
    not_pay_success: 'La réservation a été marquée comme non encaissée.',
    export_in_progress: 'Export en cours. Veuillez patienter.',
  },
  bank_reconciliation: {
    error_cant_create: "Impossible de créer un nouveau rapprochement bancaire si le dernier n'est pas validé",
    empty_operation: 'Aucune opération dans ce rapprochement bancaire',
    empty_reconciliated: 'Aucune opération rapprochée',
    empty_not_reconciliated: 'Aucune opération à rapprocher',
    operations_flagged: 'Opérations mises à jour',
    operations_to_reconciliate: 'Écritures à rapprocher',
    operations_reconciliated: 'Écritures rapprochées',
    validate: 'Valider',
    details: 'Détails',
    difference: 'Ecart',
    update_reconciliation: 'Modifier',
    add_operation: 'Ajouter',
    add_operations: 'Ajouter des opérations',
    save_operations: 'Enregistrer',
    amount: 'Montant à rapprocher',
    amount_reconciliated: 'Montant déjà rapproché',
    remove_operation: "Supprimer l'opération",
    delete_warning: 'Supprimer le rapprochement ?',
    delete_reconciliation: 'Supprimer le rapprochement bancaire',
    success_update: 'Rapprochement bancaire modifié',
    success_delete: 'Rapprochement bancaire supprimé',
    success_remove_operation: 'Opération retirée du rapprochement bancaire',
    success_remove_operations: 'Opérations retirées du rapprochement bancaire',
    cant_delete: 'Impossible de supprimer un rapprochement bancaire validé',
    success_validate: 'Rapprochement bancaire validé',
    error_update: 'Un problème est survenue lors de la modification',
    error_details: 'Un problème est survenu lors de la récupération des opérations',
    error_wrong_amount: 'Le montant du rapprochement bancaire ne correspond pas aux opérations ajoutées',
    error_remove_operations: 'Un problème est survenu lors de la suppression des opérations',
    error_no_operations: "Aucunes opérations enregistrée dans ce rapprochement. Merci d'enregistrer avant de valider.",
    error_validate: 'Un problème est survenu lors de la validation',
    error_delete: 'Un problème est survenu lors de la suppression',
    error_empty_selected: 'Aucune opération sélectionnées',
    error_add: "Un problème est survenu lors de l'ajout d'opérations",
  },
  recapitulatif_facturation: {
    recapitulatif: 'Récapitulatif de facturation',
    partenaire: 'Concierge partenaire',
    partenaire_GAV_HT: 'Concierge partenaire (HT)',
    partenaire_GAV_TTC: 'Concierge partenaire (TTC)',
    type: 'Type',
    gas: 'Guestadom',
    gas_ht: 'Guestadom (HT)',
    gas_ttc: 'Guestadom (TTC)',
    total: 'Total',
    total_ht: 'Total (HT)',
    total_ttc: 'Total (TTC)',
    display_not_closed: 'OD non clôturées',
    offer1: 'Formule Premium',
    offer3: 'Formule Essentielle',
    offer2: 'Formule Confort',
    label: 'Libellé',
    total_amount: 'Montant total',
    guest_adom: 'Guestadom',
    date: 'Date',
    add: 'Nouvelle grille tarifaire',
    added: 'Grille tarifaire ajoutée',
    update: 'Modifier la grille tarifaire',
    updated: 'Grille tarifaire modifiée',
    delete: 'Supprimer la grille tarifaire',
    deleted: 'Grille tarifaire supprimée',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer la grille tarifaire ?',
    empty: 'Aucune donnée à afficher',

    achat_hote_type: 'Achat hôte (Type)',
    achat_hote_gas: 'Achat hôte (Guestadom)',
    achat_hote_gav: 'Achat hôte (Concierge partenaire)',

    commission_type: 'Frais de gestion (Type)',
    commission_gas: 'Frais de gestion (Guestadom)',
    commission_gav: 'Frais de gestion (Concierge partenaire)',

    commission_frais_annulation_hote_type: "Frais de gestion frais d'annulation hôte (Type)",
    commission_frais_annulation_hote_gas: "Frais de gestion frais d'annulation hôte (Guestadom)",
    commission_frais_annulation_hote_gav: "Frais de gestion frais d'annulation hôte (Concierge partenaire)",

    commission_frais_annulation_voyageur_type: "Frais de gestion frais d'annulation voyageur (Type)",
    commission_frais_annulation_voyageur_gas: "Frais de gestion frais d'annulation voyageur (Guestadom)",
    commission_frais_annulation_voyageur_gav: "Frais de gestion frais d'annulation voyageur (Concierge partenaire)",

    deep_cleaning_type: 'Deep cleaning (Type)',
    deep_cleaning_gas: 'Deep cleaning (Guestadom)',
    deep_cleaning_gav: 'Deep cleaning (Concierge partenaire)',

    fermeture_hivernage_type: 'Fermeture hivernage (Type)',
    fermeture_hivernage_gas: 'Fermeture hivernage (Guestadom)',
    fermeture_hivernage_gav: 'Fermeture hivernage (Concierge partenaire)',

    forfait_frais_annulation_hote_type: "Forfait frais d'annulation hôte (Type)",
    forfait_frais_annulation_hote_gas: "Forfait frais d'annulation hôte (Guestadom)",
    forfait_frais_annulation_hote_gav: "Forfait frais d'annulation hôte (Concierge partenaire)",

    forfait_verification_menage_hote_type: 'Forfait vérification ménage hôte (Type)',
    forfait_verification_menage_hote_gas: 'Forfait vérification ménage hôte (Guestadom)',
    forfait_verification_menage_hote_gav: 'Forfait vérification ménage hôte (Concierge partenaire)',

    frais_accueil_type: "Frais d'accueil (Type)",
    frais_accueil_gas: "Frais d'accueil (Guestadom)",
    frais_accueil_gav: "Frais d'accueil (Concierge partenaire)",

    frais_assurance_type: "Frais d'assurance (Type)",
    frais_assurance_gas: "Frais d'assurance (Guestadom)",
    frais_assurance_gav: "Frais d'assurance (Concierge partenaire)",

    frais_blanchisserie_type: 'Frais de blanchisserie (Type)',
    frais_blanchisserie_gas: 'Frais de blanchisserie (Guestadom)',
    frais_blanchisserie_gav: 'Frais de blanchisserie (Concierge partenaire)',

    frais_deplacement_type: 'Frais de déplacement (Type)',
    frais_deplacement_gas: 'Frais de déplacement (Guestadom)',
    frais_deplacement_gav: 'Frais de déplacement (Concierge partenaire)',

    frais_lancement_type: 'Frais de lancement (Type)',
    frais_lancement_gas: 'Frais de lancement (Guestadom)',
    frais_lancement_gav: 'Frais de lancement (Concierge partenaire)',

    frais_maintenance_type: 'Frais de maintenance (Type)',
    frais_maintenance_gas: 'Frais de maintenance (Guestadom)',
    frais_maintenance_gav: 'Frais de maintenance (Concierge partenaire)',
    frais_maintenance_taux: 'Taux horaire de frais de maintenance',

    frais_menage_hote_type: 'Frais de ménage hôte (Type)',
    frais_menage_hote_gas: 'Frais de ménage hôte (Guestadom)',
    frais_menage_hote_gav: 'Frais de ménage hôte (Concierge partenaire)',

    frais_menage_voyageur_type: 'Frais de ménage voyageur (Type)',
    frais_menage_voyageur_gas: 'Frais de ménage voyageur (Guestadom)',
    frais_menage_voyageur_gav: 'Frais de ménage voyageur (Concierge partenaire)',

    frais_service_ga_type: 'Frais de service GA (Type)',
    frais_service_ga_gas: 'Frais de service GA (Guestadom)',
    frais_service_ga_gav: 'Frais de service GA (Concierge partenaire)',

    frais_operationnel_type: 'Frais opérationnel (Type)',
    frais_operationnel_gas: 'Frais opérationnel (Guestadom)',
    frais_operationnel_gav: 'Frais opérationnel (Concierge partenaire)',

    nuisance_sonore_type: 'Nuisance sonore (Type)',
    nuisance_sonore_gas: 'Nuisance sonore (Guestadom)',
    nuisance_sonore_gav: 'Nuisance sonore (Concierge partenaire)',

    ouverture_hivernage_type: 'Ouverture hivernage (Type)',
    ouverture_hivernage_gas: 'Ouverture hivernage (Guestadom)',
    ouverture_hivernage_gav: 'Ouverture hivernage (Concierge partenaire)',

    error_empty_filter: 'La période doit être renseignée',
    error_empty_filter_param: "L'agence doit être renseignée",
  },
  settings: {
    list: 'Paramètres',
    purchase_types: "Types d'achat",
    recapitulatif_facturation: 'Récapitulatif de facturation',
    achat_hote_types: "Types d'achat hôte",
    raison_achat_hote: "Raison d'achat hôte",
    motif_deplacement: 'Motif de déplacement',
    mandat_cluster_rm: 'Cluster',
    marche: 'Marché',
    cancel_rule: "Règle d'annulation",
    night_price: 'Prix minimum à la nuit',
    minimum_stay: 'Durée de séjour minimum',
    cancel_rule_added: "Règle d'annulation ajoutée",
    cancel_rule_empty: "Aucune règle d'annulation",
    cancel_rule_updated: "La règle d'annulation à bien été modifiée",
    rental_tag_added: 'Étiquette de logement ajoutée',
    rental_tag_updated: 'Étiquette de logement modifiée',
    rental_tag_empty: 'Aucune étiquette de logement',
    confirm_delete_cancel_rule: "Êtes-vous sûr de vouloir supprimer cette règle d'annulation?",
    ticket_category: 'Catégorie de ticket',
    ticket_category_added: 'Catégorie de ticket ajoutée',
    ticket_category_empty: 'Aucune catégorie de ticket',
    ticket_category_updated: 'La catégorie de ticket à bien été modifiée',
    add_ticket_category: 'Ajouter une catégorie de ticket',
    update_ticket_category: 'Modifier une catégorie de ticket',
    delete_ticket_category: 'Effacer une catégorie de ticket',
    confirm_delete_ticket_category: 'Êtes-vous sûr de vouloir supprimer cette catégorie de ticket?',
    message_template: 'Modèle de message',
    message_template_content: 'Contenu',
    message_template_added: 'Modèle de message ajouté',
    message_template_empty: 'Aucun modèle de message',
    message_template_updated: 'Le modèle de message a bien été modifié',
    message_template_deleted: 'Le modèle de message a bien été supprimé',
    add_message_template: 'Ajouter un modèle de message',
    update_message_template: 'Modifier un modèle de message',
    delete_message_template: 'Effacer un modèle de message',
    confirm_delete_message_template: 'Êtes-vous sûr de vouloir supprimer ce modèle de message ?',
    message_template_placeholders_hint: 'Variables disponibles dans le contenu :',
    message_template_placeholder_guest_first_name: 'prénom du client ou de l’invité',
    message_template_placeholder_checkin_date: "date d'arrivée (JJ/MM/AAAA)",
    message_template_placeholder_checkout_date: 'date de départ (JJ/MM/AAAA)',
    message_template_placeholder_reservation_localizer: 'référence de réservation (réservations uniquement)',
    message_template_placeholder_nb_bed: 'nombre de lits',
    message_template_placeholder_nb_bedroom: 'nombre de chambres',
    message_template_placeholder_nb_bathroom: 'nombre de salles de bain',
    message_template_placeholder_nb_nights: 'nombre de nuits',
    message_template_placeholder_nb_adults: 'nombre d’adultes',
    message_template_placeholder_nb_children: 'nombre d’enfants',
    message_template_placeholder_accommodation_name: 'nom du logement',
    message_template_placeholder_boarding_pass: 'lien du livret d’accueil',
    message_template_placeholder_housekeeper_name: 'prénom et nom du concierge partenaire',
    message_template_placeholder_housekeeper_phone: 'téléphone du concierge partenaire',
    message_template_placeholder_owner_name: "prénom et nom de l'hôte (raison sociale pour une société)",
    message_template_placeholder_owner_phone: "téléphone de l'hôte",
    message_template_placeholder_coffee_machine: 'machine(s) à café du logement',
    message_template_placeholder_linen_included:
      "« que le linge de lit et de bain est bien inclus » / « que le linge de lit est inclus mais pas le linge de bain » / « que le linge de lit et de bain n'est pas inclus »",
    message_template_placeholder_wifi_name: 'nom du réseau wifi',
    message_template_placeholder_wifi_password: 'mot de passe wifi',
    message_template_placeholder_floor: "numéro d'étage (« rez-de-chaussée » pour 0)",
    message_template_placeholder_garden_closed: "« est bien clos » / « n'est pas clos » (jardin)",
    error_empty_field: 'Tous les champs sont requis',
    societe_guestadom: 'Société Guestadom',
    extra_types: "Types d'extra",
    rental_tag: 'Étiquettes de logement',
    rental_tag_label: "Nom de l'étiquette",
    origin_marketing: 'Origine marketing',
    profile_client: 'Profil voyageur',
    forme_juridique: 'Forme juridique',
    stocks: 'Stocks',
    zones: 'Zones',
    contactTypes: 'Contacts utiles',
    tasks: 'Tâches',
    taskgroups: 'Groupes de tâches',
    cdcmodels: 'Modèles de CDC',
    mandats: 'Registre des mandats de gestion',
    mandatAttachedFiles: 'Pièces jointes du mandat de gestion',
    motifrefus: 'Motifs de refus',
    resiliation_reason: 'Raisons de résiliation',
    document_model: 'Modèles de documents',
    mail_template: 'Modèles de mails',
    document_balance: 'Balance',
    poles: 'Poles',
    stakeholders: 'Intervenants',
    mandat_num: 'Numéro de mandat de gestion',
    mandat_num_next: 'Prochain numéro de mandat de gestion',
    mandat_num_updated: 'Numéro de mandat de gestion mis à jour',
    mandats_empty: 'Aucun mandat de gestion',
    avenants_empty: 'Aucun avenants',
    mandat_edit_num: 'Editer le numéro',
    jobs: 'Postes',
    geosector: 'Secteurs géographiques d’intervention',
    filetype: 'Types de fichier',
    contracts: 'Contrats',
    epitype: "Types d'EPI",
    infos_mandat: 'Informations mandat de gestion',
    travel_expenses: 'Frais de déplacement',
    description: 'Description',
    ota_settings: 'Paramétrages plateforme',
    api_key: 'Clés API',
    ota_message: 'Modèles de messages automatiques',
  },
  api_key: {
    add: 'Ajouter une clé API',
    client_name: 'Nom',
    last_used: 'Dernière utilisation',
    never_used: 'Jamais utilisée',
    empty: 'Aucune clé API',
    created_title: 'Clé API créée',
    created_warning:
      'Copiez cette clé dès maintenant : pour des raisons de sécurité, elle ne sera plus jamais affichée.',
    copy: 'Copier',
    copied: 'Clé copiée dans le presse-papier',
    close: 'Fermer',
    added: 'Clé API créée',
    confirm_delete:
      'Êtes-vous sûr de vouloir supprimer cette clé API ? Elle ne pourra plus être utilisée pour authentifier des requêtes.',
    deleted: 'Clé API supprimée',
  },
  sub_category: {
    create: 'Ajouter une sous-catégorie',
    sub_category: 'Sous-catégorie',
    added: 'Sous-catégorie ajoutée',
    updated: 'Sous-catégorie modifiée',
    delete_sub_category: 'Effacer une sous-catégorie',
    confirm_delete_sub_category: 'Êtes-vous sûr de vouloir supprimer cette sous-catégorie ?',
  },
  travel_expenses: {
    amount: 'Taux horaire',
  },
  stock: {
    stock: 'Stock',
    label: 'Libellé',
    details: 'Fiche de stock',
    empty: 'Aucun stock',
    add: 'Ajouter un stock',
    added: 'Le stock a bien été ajouté',
    update: 'Modifier un stock',
    updated: 'Le stock a bien été modifié',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce stock ?',
  },
  zone: {
    zone: 'Zone',
    zones: 'Zones',
    label: 'Libellé',
    type: 'Type',
    subzone: 'Sous-zone',
    subzones: 'Sous-zones',
    details: 'Fiche de zone',
    empty: 'Aucune zone',
    add: 'Ajouter une zone',
    added: 'La zone a bien été ajoutée',
    update: 'Modifier une zone',
    updated: 'La zone a bien été modifiée',
    deleted: 'La zone a bien été supprimée',
    moved: 'La zone a bien été déplacée',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette zone ?',
    zoneType_zone: 'Zone',
    zoneType_subzone: 'Sous-zone',
  },
  job: {
    job: 'Poste',
    label: 'Libellé',
    empty: 'Aucun poste',
    add: 'Ajouter un poste',
    added: 'Le poste a bien été ajouté',
    update: 'Modifier un poste',
    updated: 'Le poste a bien été modifié',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce poste ?',
  },
  restriction: {
    restriction: 'Restriction',
    file: 'Fichier',
    restrictionType: 'Type',
    empty: 'Aucune restriction',
    add: 'Ajouter une restriction',
    added: 'La restriction a bien été ajoutée',
    update: 'Modifier une restriction',
    updated: 'La restriction a bien été modifiée',
    deleted: 'La restriction a bien été supprimée',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette restriction ?',
    startDate: 'Début',
    endDate: 'Fin',
    details: 'Précisez',
    value: 'Valeur',
    restriction1: "Nombre maximum d'heures",
    restriction2: 'Mi-temps',
    restriction3: 'Pas de port de charges',
    restriction4: "Pas d'escaliers",
    restriction5: "Pas de contact avec les produits d'entretien",
    restriction6: "Pas d'utilisation de machines (type mono brosse)",
    restriction7: 'Pas de travail le WE et jours fériés',
    restriction8: 'Pause obligatoire',
    restriction9: 'Aménagement du poste de travail',
    restriction10: 'EPI (Equipement de Protection Individuel)',
    restriction11: 'Autre',
  },
  ppe: {
    ppe: 'Équipement de protection individuelle',
    label: 'Libellé',
    empty: 'Aucun équipement',
    add: 'Ajouter un équipement',
    added: "L'équipement a bien été ajouté",
    update: 'Modifier un équipement',
    updated: "L'équipement a bien été modifié",
    deleted: "L'équipement a bien été supprimé",
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet équipement ?',
    deliveryDate: 'Remise',
    quantity: 'Quantité',
    epiType: 'Type',
  },
  absence: {
    absence: 'Absence',
    file: 'Fichier',
    files: 'Fichiers',
    reason: 'Motif',
    empty: 'Aucune absence',
    add: 'Ajouter une absence',
    update: 'Modifier une absence',
    added: "L'absence a bien été ajoutée",
    updated: "L'absence a bien été modifiée",
    deleted: "L'absence a bien été supprimée",
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette absence ?',
    startDate: 'Début',
    startTime: 'Heure début',
    endDate: 'Fin',
    endTime: 'Heure fin',
    replace: 'Remplacer ?',
    substitute: 'Remplaçant',
    comment: 'Commentaire',
    abs1: 'Accident de travail',
    abs2: 'Maladie non professionnelle',
    abs3: 'Congés de deuil',
    abs4: 'Maladie enfant',
    abs5: 'Maladie grave enfant',
    abs6: 'Maternité',
    abs7: 'Congés Payés',
    abs8: 'Absence légale autorisée sans retenue',
    abs9: 'Autre absence légale avec retenue',
    abs10: 'Absence non rémunérée (autorisée)',
    abs11: 'Absence non rémunérée (non autorisée)',
    abs12: 'Absence rémunérée',
    abs13: 'Fermeture de site',
    abs14: 'Accident de trajet',
    abs15: 'Accident de travail',
    abs16: 'Congé pathologique post-natal',
    abs17: 'Congé pathologique pré-natal (14 jours)',
    abs18: 'Femme enceinte dispensée de travail',
    abs19: 'Hospitalisation Accident de trajet',
    abs20: 'Hospitalisation AT',
    abs21: 'Hospitalisation Maladie non professionnelle',
    abs22: 'Invalidité catégorie 1',
    abs23: 'Invalidité catégorie 2',
    abs24: 'Invalidité catégorie 3',
    abs25: 'Longue maladie (secteur public)',
    abs26: 'Maladie longue durée (secteur public)',
    abs27: 'Maladie non professionnelle',
    abs28: 'Maladie non professionnelle (ALD)',
    abs29: 'Maladie non professionnelle (IJSSAT/multi-employeurs)',
    abs30: 'Maladie professionnelle',
    abs31: 'Temps partiel thérapeutique',
    abs32: 'Temps partiel thérapeutique (AT)',
    abs33: 'Absence événement familial (sans retenue)',
    abs34: 'Adoption',
    abs35: 'Congé conventionnel / maintien partiel',
    abs36: 'Congé conventionnel / maintien total',
    abs37: 'Congé de présence parentale',
    abs38: 'Congé de proche aidant',
    abs39: 'Congé de solidarité familiale',
    abs40: 'Congé parental',
    abs41: 'Congés de deuil',
    abs42: 'Maladie enfant',
    abs43: 'Maladie grave conjoint',
    abs44: 'Maladie grave enfant',
    abs45: 'Maternité',
    abs46: 'Paternité',
    abs47: 'Congés Payés',
    abs48: 'CP supplémentaires',
    abs49: 'CP supplémentaires 2',
    abs50: 'Férié chômé',
    abs51: 'Heure banque',
    abs52: 'Repos compensateur complémentaire',
    abs53: 'Repos compensateur de remplacement',
    abs54: 'Repos compensateur obligatoire',
    abs55: 'Repos forfait jour',
    abs56: 'RTT',
    abs57: 'Absence Formation en Alternance',
    abs58: 'Absence Formation non rémunérée',
    abs59: 'Congé de mobilité (au-delà du préavis)',
    abs60: 'Congé de reclassement (au-delà du préavis)',
    abs61: 'Congé de reconversion',
    abs62: 'Congé de restructuration',
    abs63: 'Congé formation rémunérée',
    abs64: 'Congé individuel de formation',
    abs65: 'Congé pour bilan de compétences',
    abs66: 'Congé pour formation syndicale',
    abs67: 'Congé pour VAE',
    abs68: 'Absence légale autorisée sans retenue',
    abs69: 'Absence pour Représentation du personnel',
    abs70: 'Autre absence légale avec retenue',
    abs71: 'Congé sabbatique',
    abs72: 'Mobilité volontaire sécurisée',
    abs73: 'Solidarité internationale',
    abs74: 'Absence non rémunérée (autorisée)',
    abs75: 'Absence non rémunérée (non autorisée)',
    abs76: 'Absence rémunérée',
    abs77: 'Activité partielle (réduction du teams)',
    abs78: 'Activité partielle (suspension intégrale)',
    abs79: 'Activité partielle/ formation',
    abs80: 'Cessation concertée de travail (grève)',
    abs81: 'Chômage intempérie',
    abs82: 'Chômage partiel (activité partielle de longue durée)',
    abs83: 'Chômage partiel congés payés',
    abs84: 'Congés Sans Solde',
    abs85: 'Détention provisoire',
    abs86: 'Férié chômé non payé',
    abs87: 'Fermeture de site',
    abs88: 'Mise à pied conservatoire',
    abs89: 'Mise à pied disciplinaire',
    abs90: 'Préavis non effectué',
    abs91: 'Préavis non effectué payé',
    abs92: 'Préavis non effectué payé (congé de mobilité)',
    abs93: 'Préavis non effectué payé (congé de reclassement)',
    abs94: 'Autre',
  },
  unavailability: {
    unavailability: 'Indisponibilité fixe',
    label: 'Libellé',
    type: 'Type',
    comment: 'Commentaire',
    empty: 'Aucune indisponibilité',
    manage: 'Gérer les indisponibilités',
    add: 'Nouvelle réservation hôte',
    edit: 'Modifier la réservation hôte',
    remove: 'Supprimer une indisponibilité',
    change: 'Changer une indisponibilité',
    added: "L'indisponibilité a bien été ajoutée",
    update: 'Modifier une indisponibilité',
    updated: "L'indisponibilité a bien été modifiée",
    deleted: 'Réservation annulée avec succès',
    confirm_delete:
      'Attention, vous souhaitez supprimer une réservation hôte. Souhaitez-vous confirmer cette suppression ?',
    impossible_to_cancel:
      "Une erreur est survenue durant l'annulation, rapprochez-vous de votre conciergerie locale pour plus d'informations",
    add_success: 'Votre demande de réservation hôte a été prise en compte.',
    edit_success: 'Votre demande de modification de réservation hôte a bien été prise en compte.',
    in_progress: 'Réservation en cours de création',
    wholeDay: 'Journée entière',
    dateStart: 'Date de début',
    dateEnd: 'Date de fin',
    hourCheckin: 'Heure de check-in',
    hourCheckout: 'Heure de check-out',
    startDateNew: 'Nouvelle date de début',
    endDateNew: 'Nouvelle date de fin',
    timeFrom: 'De',
    timeTo: 'À',
    weeksNbr1: 'Toutes les',
    weeksNbr2: 'semaine(s), le',
    monday: 'L',
    tuesday: 'Ma',
    wednesday: 'Me',
    thursday: 'J',
    friday: 'V',
    saturday: 'S',
    sunday: 'D',
    days: 'Jours',
  },
  employee_unavailability: {
    unavailability: 'Indisponibilité fixe',
    label: 'Libellé',
    type: 'Type',
    comment: 'Commentaire',
    empty: 'Aucune indisponibilité fixe',
    manage: 'Gérer les indisponibilités fixes',
    add: 'Nouvelle indisponibilité fixe',
    edit: "Modifier l'indisponibilité fixe",
    remove: 'Supprimer une indisponibilité fixe',
    change: 'Changer une indisponibilité fixe',
    added: "L'indisponibilité fixe a bien été ajoutée",
    update: 'Modifier une indisponibilité fixe',
    updated: "L'indisponibilité fixe a bien été modifiée",
    deleted: 'Indisponibilité fixe annulée avec succès',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette indisponibilité ?',
    startDate: 'Début',
    endDate: 'Fin',
    startDateNew: 'Nouvelle date de début',
    endDateNew: 'Nouvelle date de fin',
    wholeDay: 'Journée entière',
    timeFrom: 'De',
    timeTo: 'À',
    weeksNbr1: 'Toutes les',
    weeksNbr2: 'semaine(s), le',
    monday: 'L',
    tuesday: 'Ma',
    wednesday: 'Me',
    thursday: 'J',
    friday: 'V',
    saturday: 'S',
    sunday: 'D',
    days: 'Jours',
  },
  contract_settings: {
    contract: 'Contrat',
    amendment: 'Avenant',
    amendment_add: 'Ajouter un avenant',
    type: 'Type',
    label: 'Libellé',
    empty: 'Aucun contrat',
    add: 'Ajouter un contrat',
    added: 'Le contrat a bien été ajouté',
    added_amendment: "L'avenant a bien été ajouté",
    update: 'Modifier un contrat',
    updated: 'Le contrat a bien été modifié',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce contrat/avenant ?',
    confirm_contract_delete: 'Êtes-vous sûr de vouloir supprimer ce contrat ?',
    deleted: 'Le contract/avenant a bien été supprimé',
  },
  geosector: {
    geosector: 'Secteur géographique d’intervention',
    label: 'Libellé',
    empty: 'Aucun secteur géographique',
    add: 'Ajouter un secteur géographique',
    added: 'Le secteur géographique a bien été ajouté',
    update: 'Modifier un secteur géographique',
    updated: 'Le secteur géographique a bien été modifié',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce secteur géographique ?',
  },
  filetype: {
    filetype: 'Type de fichier',
    label: 'Libellé',
    empty: 'Aucun type de fichier',
    add: 'Ajouter un type de fichier',
    added: 'Le type de fichier a bien été ajouté',
    update: 'Modifier un type de fichier',
    updated: 'Le type de fichier a bien été modifié',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce type de fichier ?',
  },
  epitype: {
    epitype: "Type d'EPI",
    label: 'Libellé',
    empty: "Aucun type d'EPI",
    add: "Ajouter un type d'EPI",
    added: "Le type d'EPI a bien été ajouté",
    update: "Modifier un type d'EPI",
    updated: "Le type d'EPI a bien été modifié",
    confirm_delete: "Êtes-vous sûr de vouloir supprimer ce type d'EPI ?",
  },
  contract: {
    add: 'Ajouter un contrat',
    contract: 'Contrat',
    file: 'Fichier',
    amendment_pattern: 'Motif avenant',
    added: 'Le contrat a bien été ajouté',
    startDate: 'Début',
    endDate: 'Fin',
    endReason: 'Motif de fin',
    startingEmploymentReason: 'Motif début emploi',
    startTime: 'Horaire de début',
    trialPeriodDuration: 'Durée période essai',
    trialEndDate: 'Fin essai',
    occupationClassification: 'Classification métier',
    employmentNature: "Nature de l'emploi",
    grossHourlyTx: 'Tx horaire brut',
    conventionalMinimumWage: 'Salaire minimum conventionnel',
    doNotTransmitTheRate: 'Ne pas transmettre le taux',
    endReason1: 'Changement de situation administrative du salarié ou de l’assuré',
    endReason2: 'Congé de présence parentale',
    endReason3: 'Congé de solidarité familiale',
    endReason4: 'Congé demi solde',
    endReason5: 'Congé parental d’éducation',
    endReason6:
      'Congé sabbatique, disponibilité, congé sans traitement de l’agent public stagiaire, fonctionnaire hors cadre',
    endReason7: 'Congé sans solde supérieur ou égal à 30 jours consécutifs',
    endReason8: 'Continuité d’activité en fin de période',
    endReason9: 'Convention de conversion',
    endReason10: 'Créateur d’entreprise',
    endReason11: 'Décès, disparition',
    endReason12: 'Démission',
    endReason13: 'Départ en détachement',
    endReason14: 'Départ volontaire à la retraite',
    endReason15: 'Evènements prévoyance (réservé aux déclarations prévoyance événementielles)',
    endReason16:
      'Fin de contrat de travail, fin d’activité, fin de détachement, perte de la qualité culturelle (cultes)',
    endReason17: 'Fin de période d’apprentissage dans le cadre d’un CDI',
    endReason18: 'Fin de période pré retraite IEG (réservé échanges inter-organismes)',
    endReason19: 'Fin de période RATP (réservé échanges inter organisme)',
    endReason20: 'Licenciement',
    endReason21: 'Mise a la retraite d’office à l’initiative de l’employeur',
    endReason22: 'Paiement des congés payé',
    endReason23: 'Rupture conventionnelle du contrat de travail',
    endReason24:
      'Salarié quittant ou ayant quitté l’entreprise (sommes versées dont indemnités de non concurrence pour l’Agirc)',
    endReason25: 'Service national volontaire (y compris volontaires du service civique)',
    endReason26: 'Sortie d’activité d’un retraité cumulant retraite et activité',
    endReason27: 'Suppression du contrat de travail',
    daysNumber: 'Nb Jours / Semaine',
    monday: 'L',
    tuesday: 'Ma',
    wednesday: 'Me',
    thursday: 'J',
    friday: 'V',
    workedDays: 'Jours travaillés',
    signed: 'Signé',
    signatureDate: 'Date de signature',
    startPattern1:
      "embauche, début d'activité, recrutement direct ou sur concours (fonction publique), début de détachement, début",
    startPattern2: "reprise d'activité suite à suspension du contrat de travail",
    startPattern3: 'congés sans solde supérieur ou égal à 30 jours consécutifs',
    startPattern4: 'congé demi solde',
    startPattern5: 'service national volontaire (y compris volontaires du service civique)',
    startPattern6: 'paiement des congés payés',
    startPattern7: "congé parental d'éducation",
    startPattern8: "embauche d'un retraité reprenant une activité",
    startPattern9: "salarié quittant ou ayant quitté l'entreprise (sommes versées dont indemnités de non concurrence)",
    startPattern10: "continuité d'activité en début de période",
    startPattern11: 'congés de solidarité familiale',
    startPattern12: 'congés de présence parentale',
    startPattern13: 'début de période IEG pensions (réservé aux échanges inter organismes)',
    startPattern14: 'congé sabbatique',
    startPattern15: 'début de période RATP',
    startPattern16: 'évènement prévoyance',
    startPattern17: 'retour de détachement',
    startPattern18: "changement de situation administrative du salarié ou de l'assuré",
    startPattern19: "début de période d'apprentissage dans le cadre d'un CDI",
    occupation1: 'Agent d’entretien petits travaux de bricolage',
    occupation2: 'Agent d’entretien petits travaux de jardinage',
    occupation3: 'Assistant(e) de vie 1',
    occupation4: 'Garde d’enfant(s) 1',
    occupation5: 'Assistant(e) ménager(e) 1',
    occupation6: 'Garde d’enfant(s) 2',
    occupation7: 'Assistant(e) ménager(e) 2',
    occupation8: 'Assistant(e) de vie 2',
    occupation9: 'Garde d’enfant(s) 3',
    occupation10: 'Assistant(e) de vie 3',
    amendmentReason1: '10-Courrier augmentation taux horaire',
    amendmentReason2: '11-Modification de la durée annuelle de travail',
    amendmentReason3: '5-Avenant de transformation du CDI temps partiel mensualisé à annualisé réel',
    amendmentReason4: '6-Avenant de transformation du CD2i à annualisé réel',
    amendmentReason5: '7-Annexe de mise à disposition du véhicule déplacement professionnel',
    amendmentReason6: '8-Annexe de mise à disposition du véhicule professionnel domicile – travail',
    amendmentReason7: '9-Annexe de mise à disposition du téléphone portable',
  },
  subzone: {
    empty: 'Aucune sous-zone',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette sous-zone ?',
    updated: 'La sous-zone a bien été modifiée',
    added: 'La sous-zone a bien été ajoutée',
  },
  motifrefus: {
    item: 'Motif de refus',
    empty: 'Aucun motif de refus',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce motif de refus ?',
    update: 'Modifier un motif de refus',
    updated: 'Le motif de refus a bien été modifié',
    add: 'Ajouter un motif de refus',
    added: 'Le motif de refus a bien été ajouté',
    delete: 'Supprimer un motif de refus',
  },
  resiliation_reason: {
    list: 'Raisons de résiliation',
    item: 'Raison de résiliation',
    empty: 'Aucune raison de résiliation',
    update: 'Modifier une raison de résiliation',
    updated: 'La raison de résiliation a bien été modifiée',
    add: 'Ajouter une raison de résiliation',
    added: 'La raison de résiliation a bien été ajoutée',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette raison de résiliation ?',
    delete: 'Supprimer une raison de résiliation',
  },
  document_model: {
    item: 'Modèle de document',
    empty: 'Aucun modèle de document',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce modèle de document ?',
    update: 'Modifier un modèle de document',
    updated: 'Le modèle de document a bien été modifié',
    add: 'Ajouter un modèle de document',
    added: 'Le modèle de document a bien été ajouté',
    delete: 'Supprimer un modèle de document',
    name: 'Nom du modèle',
    type: 'Type',
    subtype: 'Sous-type',
    file: 'Modèle Word',
    updateThis: 'Modifier',
    working_contract: 'Générer le contrat de travail',
    in_progress: 'Génération du document en cours',
  },
  mail_template: {
    item: 'Modèle de mail',
    empty: 'Aucun modèle de mail',
    update: 'Modifier un modèle de mail',
    updated: 'Le modèle de mail a bien été modifié',
    name: 'Nom du modèle Brevo',
    technical_name: 'Nom',
    active: 'Activé',
    updateThis: 'Modifier',
    technical_key: {
      AccessAutonomousOwner: "Prospect - Email d'inscription",
      AccessAutonomousOwner_commerciale: "Équipe commerciale - Email d'inscription",
      AccessAutonomousOwnerEstimation: "Prospect - Email d'inscription via estimation",
      AccessAutonomousOwnerEstimation_commerciale: "Équipe commerciale - Email d'inscription via estimation",
      AccessPasswordForgotEmployee: "Employé - Email d'oubli de mot de passe",
      AccessPasswordForgotOwner: "Hôte - Email d'oubli de mot de passe",
      PasswordUpdateConfirm: 'Global - Email de confirmation de modification de mot de passe',
      CRGFirst: 'Hôte - Premier email de CRG',
      CRGHost: 'Hôte - Email de CRG',
      CRGMulti: 'Hôte - Email de CRG (Multi-logements)',
      MandatAvenantSigned_hote: "Équipe hôte - Email de confirmation d'avenant signé",
      MandatAvenantSigned_owner: "Hôte - Email de confirmation d'avenant signé",
      MandatAvenantToSign: "Hôte - Email d'avenant à signer",
      MandatResiliationCheckList: 'Équipe hôte - Email de check list de résiliation',
      MandatResiliationCheckList_comptabilite: 'Équipe comptabilité mandante - Email de check list de résiliation',
      MandatResiliationDeclared_concierge: 'Équipe conciergerie - Email de déclaration de résiliation',
      MandatResiliationDeclared_distribution: 'Équipe distribution - Email de déclaration de résiliation',
      MandatResiliationDeclared_hote: 'Équipe hôte - Email de déclaration de résiliation',
      MandatResiliationDeclared_owner: 'Hôte - Email de déclaration de résiliation',
      MandatResiliationDone_distribution: 'Équipe distribution - Email de résiliation effectuée',
      MandatResiliationDone_hote: 'Équipe hôte - Email de résiliation effectuée',
      MandatResiliationDone_owner: 'Hôte - Email de résiliation effectuée',
      OnboardingCreated_hote: "Équipe hôte - Email de création d'un onboarding",
      OnboardingStep1Validated: "Hôte - Email de validation de l'étape 1 de l'onboarding",
      OnboardingStep2Updated_confort: "Hôte - Email de modification de l'étape 2 (formule confort) de l'onboarding",
      OnboardingStep2Updated_essentielle:
        "Hôte - Email de modification de l'étape 2 (formule essentielle) de l'onboarding",
      OnboardingStep2Updated_premium: "Hôte - Email de modification de l'étape 2 (formule premium) de l'onboarding",
      OnboardingStep2Updated_concierge: "Équipe conciergerie - Email de modification de l'étape 2 de l'onboarding",
      OnboardingStep2Updated_hote: "Équipe hôte - Email de modification de l'étape 2 de l'onboarding",
      OnboardingStep2Updated_distribution: "Équipe distribution - Email de modification de l'étape 2 de l'onboarding",
      OnboardingStep2Validated_confort: "Hôte - Email de validation de l'étape 2 (formule confort) de l'onboarding",
      OnboardingStep2Validated_essentielle:
        "Hôte - Email de validation de l'étape 2 (formule essentielle) de l'onboarding",
      OnboardingStep2Validated_premium: "Hôte - Email de validation de l'étape 2 de l'onboarding",
      OnboardingStep2Validated_commerciale: "Équipe commerciale - Email de validation de l'étape 2 de l'onboarding",
      OnboardingStep2Validated_concierge:
        "Équipe conciergerie - Email de validation de l'étape 2 (formule premium)  de l'onboarding",
      OnboardingStep2Validated_distribution:
        "Équipe distribution - Email de validation de l'étape 2 (formule premium) de l'onboarding",
      OnboardingStep2Validated_hote: "Équipe hôte - Email de validation de l'étape 2 de l'onboarding",
      OnboardingStep3Validated: "Hôte - Email de validation de l'étape 3 de l'onboarding",
      OnboardingStep3Validated_hote: "Équipe hôte - Email de validation de l'étape 3 de l'onboarding",
      OnboardingStep4Validated: "Hôte - Email de validation de l'étape 4 de l'onboarding",
      OnboardingStep4Validated_concierge: "Équipe conciergerie - Email de validation de l'étape 4 de l'onboarding",
      OnboardingStep4Validated_hote: "Équipe hôte - Email de validation de l'étape 4 de l'onboarding",
      OnboardingStep5DocsRefused: "Hôte - Email de refus des documents de l'onboarding",
      OnboardingStep5DocsResubmitted: "Hôte - Email de re-dépôt des documents de l'onboarding",
      OnboardingStep5DocsValidated: "Hôte - Email de validation des documents de l'onboarding",
      OnboardingStep5Validated: "Hôte - Email de validation de l'étape 5 de l'onboarding",

      OnboardingStep5Validated_commerciale: "Équipe commerciale - Email de validation de l'étape 5 de l'onboarding",
      OnboardingStep5Validated_comptabilite:
        "Équipe comptabilité mandante - Email de validation de l'étape 5 de l'onboarding",
      OnboardingStep5Validated_confort_premium_hote:
        "Équipe hôte - Email de validation de l'étape 5 de l'onboarding (formule confort ou premium)",
      OnboardingStep5Validated_essentielle_hote:
        "Équipe hôte - Email de validation de l'étape 5 de l'onboarding (formule essentielle)",
      OnboardingStep5Validated_conciergerie:
        "Équipe conciergerie - Email de validation de l'étape 5 de l'onboarding (formule premium)",
      OnboardingStep6Published_owner: "Hôte - Email de publication de l'onboarding",
      OnboardingStep6Published_communication: "Équipe communication - Email de publication de l'onboarding",
      OnboardingStep6Published_hote: "Équipe hôte - Email de publication de l'onboarding",
      OnboardingStep6Published_voyageur: "Équipe voyageur - Email de publication de l'onboarding",
      OnboardingStep6Published_distribution: "Équipe distribution - Email de synchronisation Smily de l'onboarding",
      ReservationGuestCanceled_concierge: 'Concierge - Email de réservation voyageur annulée',
      ReservationGuestCanceled_hote: 'Équipe hôte - Email de réservation voyageur annulée',
      ReservationGuestCanceled_owner: 'Hôte - Email de réservation voyageur annulée',
      ReservationGuestCreated_concierge: 'Concierge - Email de réservation voyageur créée',
      ReservationGuestCreated_hote: 'Équipe hôte - Email de réservation voyageur créée',
      ReservationGuestCreated_owner: 'Hôte - Email de réservation voyageur créée',
      ReservationGuestUpdated_concierge: 'Concierge - Email de réservation voyageur modifiée',
      ReservationGuestUpdated_hote: 'Équipe hôte - Email de réservation voyageur modifiée',
      ReservationGuestUpdated_owner: 'Hôte - Email de réservation voyageur modifiée',
      ReservationHostCanceled_concierge: 'Concierge - Email de réservation hôte annulée',
      ReservationHostCanceled_hote: 'Équipe hôte - Email de réservation hôte annulée',
      ReservationHostCanceled_owner: 'Hôte - Email de réservation hôte annulée',
      ReservationHostCreated_concierge: 'Concierge - Email de réservation hôte créée',
      ReservationHostCreated_hote: 'Équipe hôte - Email de réservation hôte créée',
      ReservationHostCreated_owner: 'Hôte - Email de réservation hôte créée',
      ReservationHostUpdated_concierge: 'Concierge - Email de réservation hôte modifiée',
      ReservationHostUpdated_hote: 'Équipe hôte - Email de réservation hôte modifiée',
      ReservationHostUpdated_owner: 'Hôte - Email de réservation hôte modifiée',
      StayRateMissing: 'Équipe distribution & comptabilité mandante - Email de TDS non paramétrée',
      LoginCode: 'Inscription - Code de vérification',
      AccessUser: 'Identifiants d’accès',
      MaintenanceCreated: 'Nouvelle maintenance',
      MaintenanceCreated_hote: 'Équipe hôte - Nouvelle maintenance',
      MaintenanceCreated_voyageur: 'Équipe voyageur - Nouvelle maintenance',
      LitigeCreated: 'Nouveau litige',
      LitigeCreated_voyageur: 'Équipe voyageur - Nouveau litige',
      LitigeLost: 'Litige perdu',
      LitigeWon: 'Litige gagné',
      MaintenanceResolved: 'Maintenance résolue',
      AccessReactivateOwner: 'Réactivation du compte',
      SmilySyncedProduct: 'Équipe produit - Synchronisation Smily logements dupliqués',
      SmilySyncedDistribution: 'Équipe distribution - Synchronisation Smily logements dupliqués',
      MandatOperatingCosts: 'Équipe hôte - Frais de fonctionnement sur mandat',
      RequestOwnerConfirmReceipt: 'Hôte - Confirmation de la réception de la demande',
      TrustpilotOwnerRating: 'Hôte - Avis Trustpilot',
      HousekeeperMiddleOfTheMonth: 'Concierge - Rappel de facturation à mi-mois',
      HousekeeperEndOfTheMonth: 'Concierge - Rappel de facturation à la fin du mois',
      HousekeeperCreated: "Équipe comptabilité mandante - Création d'un concierge",
      HousekeeperDisabled: "Équipe comptabilité mandante - Désactivation d'un concierge",
      // Nurturing emails
      NurturingS1AE1WelcomeAccess: 'Nurturing - S1A E1 - Bienvenue',
      NurturingS1AE2CustomerCase: 'Nurturing - S1A E2 - Cas clients',
      NurturingS1AE3EasyUse: 'Nurturing - S1A E3 - Simplicité',
      NurturingS1AE4FAQ: 'Nurturing - S1A E4 - FAQ',
      NurturingS1AE5FOMO: 'Nurturing - S1A E5 - Dernier rappel (FOMO)',
      NurturingS1BE1PresqueFini: 'Nurturing - S1B E1 - Presque fini',
      NurturingS1BE2FormuleAttend: 'Nurturing - S1B E2 - Votre formule vous attend',
      NurturingS1BE3AideProposee: 'Nurturing - S1B E3 - Aide proposée',
      NurturingS2E1RecommendationPremium: 'Nurturing - S2 E1 - Recommendation formule - Premium',
      NurturingS2E1RecommendationEssentiel: 'Nurturing - S2 E1 - Recommendation formule - Essentiel',
      NurturingS2E1RecommendationConfort: 'Nurturing - S2 E1 - Recommendation formule - Confort',
      NurturingS2E2HesitationPremium: 'Nurturing - S2 E2 - Hésitation - Premium',
      NurturingS2E2HesitationEssentiel: 'Nurturing - S2 E2 - Hésitation - Essentiel',
      NurturingS2E2HesitationConfort: 'Nurturing - S2 E2 - Hésitation - Confort',
      NurturingS2E3Questions: 'Nurturing - S2 E3 - Questions',
      NurturingS3E1OneMoreStep: "Nurturing - S3 E1 - Plus qu'une étape",
      NurturingS3E2MandateExplanation: 'Nurturing - S3 E2 - Explication mandat',
      NurturingS3E3Projection: 'Nurturing - S3 E3 - Projection',
      NurturingS3E4FinancialComparison: 'Nurturing - S3 E4 - Comparaison financière',
      NurturingS2ME130Seconds: 'Nurturing - S2M E1 - 30 secondes',
      NurturingS2ME2MistakeToAvoid: 'Nurturing - S2M E2 - Erreur à éviter',
      UserEmailUpdate: "Modification de l'adresse e-mail",
      ReservationQueryReminderStep1_owner: 'Hôte - Relance demande de réservation - Mail 1 (à réception)',
      ReservationQueryReminderStep2_owner: 'Hôte - Relance demande de réservation - Mail 2 (+30min)',
      ReservationQueryReminderStep3_owner: 'Hôte - Relance demande de réservation - Mail 3 (+4h)',
      ReservationQueryReminderStep4_owner: 'Hôte - Relance demande de réservation - Mail 4 (+8h)',
      ReservationQueryReminderStep5_owner: 'Hôte - Relance demande de réservation - Mail 5 (+16h)',
      ReservationQueryReminderStep1_concierge: 'Concierge - Relance demande de réservation - Mail 1 (à réception)',
      ReservationQueryReminderStep2_concierge: 'Concierge - Relance demande de réservation - Mail 2 (+30min)',
      ReservationQueryReminderStep3_concierge: 'Concierge - Relance demande de réservation - Mail 3 (+4h)',
      ReservationQueryReminderStep4_concierge: 'Concierge - Relance demande de réservation - Mail 4 (+8h)',
      ReservationQueryReminderStep5_concierge: 'Concierge - Relance demande de réservation - Mail 5 (+16h)',
      ReservationDoubleCheck: 'Notification double réservation - Équipe Voyageurs',
    },
  },
  pole: {
    item: 'Pole',
    list: 'Poles',
    name: 'Nom',
    technicalKey: 'Clé technique',
    email: 'Adresse mail',
    empty: 'Aucun pole',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce pole ?',
    update: 'Modifier un pole',
    updated: 'Le pole a bien été modifié',
    add: 'Ajouter un pole',
    added: 'Le pole a bien été ajouté',
    delete: 'Supprimer un pole',
    error_pole_owner: 'Une erreur est survenue lors de la récupération du pole Hôte',
  },
  product: {
    label: 'Libellé',
    type: 'Type',
    quantity: 'Quantité',
    products: 'Produits du kit',
    details: 'Fiche de produit',
    empty: 'Aucun produit',
    list: 'Produits',
    add: 'Ajouter un produit',
    update: 'Modifier un produit',
    updateThis: 'Modifier',
    added: 'Le produit a bien été ajouté',
    updated: 'Le produit a bien été modifié',
    deleted: 'Le produit a bien été supprimé',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
    productType_consumable: 'Consommable',
    productType_extra: 'Extra',
    productType_kit: 'Kit',
  },
  prestataire: {
    prestataire: 'Prestataire',
    title: 'Prestataires',
    status_available: 'Disponible',
    status_unavailable: 'Indisponible',
    status_in_mission: 'En mission',
    create: 'Ajouter un prestataire',
    update: 'Modifier le prestataire',
    added: 'Prestataire ajouté',
    updated: 'Prestataire modifié',
    filter: 'Filtrer',
    search: 'Recherche',
    civility: 'Civilité',
    phone: 'Mobile',
    homePhone: 'Téléphone',
    availability: 'Disponibilité',
    lastName: 'Nom',
    firstName: 'Prénom',
    birthDate: 'Date de naissance',
    email: 'E-mail',
    enabled: 'Actif',
    company: 'Agence',
    all: 'Tous les prestataires',
    empty: 'Aucun prestataire',
    confirm_deactivate: 'Êtes-vous sûr de vouloir désactiver ce prestataire ?',
    activated: 'Prestataire activé',
    deactivated: 'Prestataire désactivé',
  },
  prestation: {
    filter: 'Filtrer',
    label: 'Libellé',
    type: 'Type',
    status: 'Statut de la mission',
    assigned_staff: 'Personnel affecté',
    dateStart: 'Date de début',
    dateEnd: 'Date de fin',
    timeStart: 'Heure de début',
    timeEnd: 'Heure de fin',
    date: "Date de création de l'ordre",
    schedule: 'Horaires',
    company: 'Agence',
    accommodation_name: 'Nom du logement',
    date_checkin: 'Date de check-in',
    date_checkout: 'Date de check-out',
    details: 'Fiche de prestation',
    empty: 'Aucune prestation',
    plural: '{0} prestations',
    list: 'Prestations',
    add: 'Ajouter une prestation',
    update: 'Modifier une prestation',
    updateThis: 'Modifier',
    added: 'La prestation a bien été ajoutée',
    updated: 'La prestation a bien été modifiée',
    deleted: 'La prestation a bien été supprimée',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette prestation ?',
    prestationType_check_in: 'Check-in',
    prestationType_check_out: 'Check-out',
    prestationType_cleaning: 'Ménage interlocatif',
    prestationType_cleaning_before: 'Ménage retour hôte',
    prestationType_cleaning_after: 'Ménage départ hôte',
    prestationType_running: 'Running',
    prestationType_quality_control: 'Contrôle qualité',
    prestationType_maintenance: 'Maintenance',
    status_accepted: 'Acceptée',
    status_proposed: 'Proposée',
    status_partially_accepted: 'Partiellement acceptée',
    status_to_plan: 'À planifier',
    status_todo: 'Planifiée',
    status_to_do: 'À faire',
    status_doing: 'En cours',
    status_completed: 'Terminée',
    status_canceled: 'Annulée',
    status_partially_canceled: 'Partiellement annulée',
    status_litigation: 'Litige',
  },
  partenaire: {
    title: 'Partenaires',
    name: 'Nom du partenaire',
    details: 'Fiche partenaire',
    create: 'Ajouter une conciergerie partenaire',
    createOwner: 'Ajouter un prestataire',

    update: 'Modifier la conciergerie partenaire',
    list: 'Conciergeries partenaires',
    updated: 'Conciergerie partenaire modifiée',
    enabled: 'Conciergerie partenaire activée',
    enabledState: 'Actif / Inactif',
    disabled: 'Prestataire désactivé',
    accessSent: 'Les accès ont été envoyés',
    representant: 'Représentant',
    representantLastName: 'Nom du représentant',
    representantFirstName: 'Prénom du représentant',
    empty: 'Aucun prestataire',
    updateThis: 'Modifier',
    createAccess: "Créer l'accès",
    resendAccess: "Renvoyer l'accès",
    create_access_confirmation: "Êtes-vous sur de vouloir créer l'accès prestataire ?",
    resend_access_confirmation: "Êtes-vous sur de vouloir renvoyer l'accès prestataire ?",
    accommodation: 'Logement',
    company: 'Agence',
    errorNoId: "Ce prestataire n'a pas de compte utilisateur",
    accommodation_number: 'Nombre de logements',
    all: 'Toutes les conciergeries partenaires',
    confirm_remove: 'Êtes-vous sur de vouloir retirer le prestataire de ce logement ?',
    remove_item: 'Retirer le prestataire',
    deleted: 'Prestataire retiré',
    added: 'Prestataire ajouté',
  },
  housekeeper: {
    title: 'Concierges',
    name: 'Nom du concierge',
    details: 'Fiche concierge',
    create: 'Ajouter un concierge partenaire',
    update: 'Modifier le concierge partenaire',
    list: 'Concierges partenaires',
    updated: 'Concierge modifié',
    enabled: 'Concierge activé',
    enabledState: 'Actif / Inactif',
    disabled: 'Concierge désactivé',
    accessSent: 'Les accès ont été envoyés',
    representant: 'Représentant',
    representantLastName: 'Nom du représentant',
    representantFirstName: 'Prénom du représentant',
    empty: 'Aucun concierge',
    updateThis: 'Modifier',
    createAccess: "Créer l'accès",
    resendAccess: "Renvoyer l'accès",
    create_access_confirmation: "Êtes-vous sur de vouloir créer l'accès concierge partenaire ?",
    resend_access_confirmation: "Êtes-vous sur de vouloir renvoyer l'accès concierge partenaire ?",
    accommodation: 'Logement',
    company: 'Agence',
    errorNoId: "Ce concierge n'a pas de compte utilisateur",
    accommodation_number: 'Nombre de logements',
    all: 'Tous les concierges',
    added: 'Concierge partenaire ajouté',
    accommodations_history: 'Historique',
    accommodations_history_empty: 'Aucune affectation antérieure',
  },
  commercial: {
    title: 'Agents commerciaux',
    one: 'Agent commercial',
    details: 'Fiche agent commercial',
    create: 'Ajouter un agent commercial',
    update: "Modifier l'agent commercial",
    list: 'Agents commerciaux',
    created: 'Agent commercial ajouté !',
    updated: 'Agent commercial modifié',
    enabled: 'Agent commercial activé',
    enabledState: 'Actif / Inactif',
    disabled: 'Agent commercial désactivé',
    accessSent: 'Les accès ont été envoyés',
    representant: 'Représentant',
    representantLastName: 'Nom du représentant',
    representantFirstName: 'Prénom du représentant',
    empty: 'Aucun agent commercial',
    createAccess: "Créer l'accès",
    resendAccess: "Renvoyer l'accès",
    create_access_confirmation: "Êtes-vous sur de vouloir créer l'accès agent commercial ?",
    resend_access_confirmation: "Êtes-vous sur de vouloir renvoyer l'accès agent commercial ?",
    errorNoId: "Cet agent commercial n'a pas de compte utilisateur",
    all: 'Tous les agents commerciaux',
  },
  employee: {
    files: 'Pièces jointes',
    add_file: 'Ajouter une pièce jointe',
    file_added: 'Pièce jointe ajoutée',
    file_deleted: 'Pièce jointe supprimée',
    file_confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe ?',
    activity: 'Communication',
    contracts: 'Contrats/Avenants',
    civility: 'Civilité',
    firstName: 'Prénom',
    lastName: 'Nom',
    type: 'Type',
    maidenName: 'Nom de jeune fille',
    company: 'Agence',
    color: 'Couleur',
    poles: 'Poles',
    team: 'Équipes',
    roleKey: 'Poste',
    roleType: 'Type de rôle',
    userEnabled: 'Actif',
    email: 'E-mail',
    details: 'Fiche de salarié',
    empty: 'Aucun salarié',
    one: 'Salarié',
    list: 'Salariés',
    add: 'Ajouter un salarié',
    update: 'Modifier un salarié',
    updateThis: 'Modifier',
    added: 'Le salarié a bien été ajouté',
    updated: 'Salarié modifié',
    deleted: 'Salarié supprimé',
    enabled: 'Salarié activé',
    disabled: 'Salarié désactivé',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce salarié ?',
    birthdate: 'Date de naissance',
    birthPlace: 'Lieu de naissance',
    birthDepartment: 'Département de naissance',
    birthCountry: 'Pays de naissance',
    maritalStatus: 'Situation familiale',
    childrenNumber: "Nombre d'enfants",
    source: 'Source de connaissance',
    address: 'Adresse',
    additionalAddress: 'Complément d’adresse',
    postalCode: 'Code postal',
    country: 'Pays',
    city: 'Ville',
    phoneNumber: 'Téléphone',
    mobileNumber: 'Mobile',
    personalInformation: 'Informations personnelles',
    contractInformation: 'Informations Contrat/Avenant',
    contact: 'Coordonnées',
    identityDocument: 'Justificatif d’identité',
    idNumber: 'Numéro du justificatif d’identité',
    idIssuedAt: 'Délivré à',
    idValidUntil: "Valide jusqu'au",
    nationality: 'Nationalité',
    socialSecurityNumber: 'Numéro de sécurité sociale',
    drivingPermit: 'Permis de conduire',
    drivingPermitNumber: 'Numéro de permis de conduire',
    drivingPermitObtainingDate: "Date d'obtention du permis",
    drivingPermitValidityDate: 'Date de validité du permis',
    registeredEmploymentCenter: 'Inscrit au pôle emploi',
    employmentCenterMembershipNumber: "Numéro d'adhésion au pôle emploi",
    professionalInformation: 'Informations professionnelles',
    seniorityDate: 'Date d’ancienneté',
    entryDate: 'Date d’entrée',
    entryHour: 'Heure d’entrée',
    dpaeNumber: 'Numéro DPAE',
    lastMedicalVisitDate: 'Date de la dernière visite médicale',
    nextMedicalVisitDate: 'Date de la prochaine visite médicale',
    usualTransportMode: 'Mode de transport habituel',
    personalVehicle: 'Véhicule personnel',
    companyVehicle: 'Véhicule de société',
    bicycle: 'Vélo',
    onFoot: 'À pied',
    publicTransport: 'Transport en commun',
    subscribedToComplementaryHealth: 'Adhère à la complémentaire santé',
    motif: 'Motif',
    iban: 'IBAN',
    bic: 'BIC',
    handicappedWorkerRecognition: 'Reconnaissance travailleur handicapé',
    recognitionGrantedByTheCDAPH: 'Reconnaissance attribuée par la CDAPH',
    rqth: 'RQTH',
    aah: 'AAH',
    disabilityCard: "Carte d'invalidité (min. 80%)",
    validityStartDate: 'Date de début de validité',
    validityEndDate: 'Date de fin de validité',
    renewalApplicationSubmissionDate: 'Date de dépôt de la demande de renouvellement',
    disabilityRate: "Taux d'incapacité",
    disabilityCauses: "Victime d'accident du travail, de maladie professionnelle ou invalide pensionné",
    typology: 'Typologie',
    disabilityValidityStartDate: 'Date de début de validité',
    IPPRate: "Taux d'IPP",
    category: 'Catégorie',
    otherCategories: 'Autres catégories',
    otherCategory: 'Autre catégorie',
    pensionStartDate: 'Date de début de pension',
    skills: 'Compétences',
    spokenLanguages: 'Langues',
    graduate: 'Diplômé',
    diplomas: 'Diplômes',
    married: 'Marié(e)',
    divorced: 'Divorcé(e)',
    widower: 'Veuf/Veuve',
    single: 'Célibataire',
    maritalLife: 'Vie maritale',
    pacs: 'Pacsé(e)',
    separated: 'Séparé(e)',
    typology1: 'Accident du travail / Maladie professionnelle',
    typology2: 'Invalide pensionné',
    otherCategory1: 'Mutilé de guerre',
    otherCategory2: 'Assimilé mutilé de guerre',
    otherCategory3: 'Sapeur-Pompier volontaire',
    motif1: "Vous avez déjà une mutuelle en tant qu'ayant droit (couverture collective)",
    motif2: 'Vous avez déjà une mutuelle (complémentaire individuelle)',
    motif3: "Vous êtes déjà dans l'entreprise lors de la mise en place du dispositif",
    motif4: "Vous bénéficiez de la CMUC ou de l'ACS",
    motif5: 'Vous êtes salarié à temps très partiel',
    motif6: "Vous êtes en CDD ou en contrat de mission (jusqu'à 3 mois)",
    motif7: 'Vous êtes en CDD ou en contrat de mission (entre 3 mois et 1 an)',
    motif8: "Vous êtes en CDD ou en contrat de mission d'1 an ou plus",
    motif9: 'Vous êtes apprenti',
    category1: 'Première catégorie',
    category2: 'Deuxième catégorie',
    category3: 'Troisième catégorie',
    job: 'Poste',
    multiEmployer: 'Multi-employeurs',
    employer1: 'Employeur 1',
    employer2: 'Employeur 2',
    employer3: 'Employeur 3',
    employer4: 'Employeur 4',
    employer5: 'Employeur 5',
    duration: 'Durée',
    geosector: 'Secteurs géographiques d’intervention',
    filetype: 'Type de fichier',
    commitmentEndDate: "Date de fin d'engagement",
    bankingInformation: 'Informations bancaires',
    unavailability_add: 'Ajouter une indisponibilité',
    all: 'Tous les salariés',
  },
  client: {
    download: 'Télécharger',
    details: 'Fiche voyageur',
    blacklist: 'Blacklister',
    unblock: 'Débloquer',
    empty: 'Aucun voyageur',
    one: 'Voyageur',
    list: 'Voyageurs',
    add: 'Ajouter un voyageur',
    update: 'Modifier un voyageur',
    updateThis: 'Modifier',
    added: 'Le voyageur a bien été ajouté',
    updated: 'Le voyageur a bien été modifié',
    deleted: 'Le voyageur a bien été supprimé',
    disabled: 'Le voyageur a bien été désactivé',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce voyageur ?',
    type: 'Type',
    profile: 'Profil voyageur',
    originMarketing: 'Origine marketing',
    spokenLanguages: 'Langues parlées',
    phone: 'Mobile',
    phone2: 'Mobile 2',
    phoneFix: 'Téléphone',
    periodCreated: 'Date de création',
    email: 'Email',
    name: 'Nom et prénom',
    newsletter: 'Newsletters',
    enabled: 'Actif',
    blocked: 'Bloqué',
    title_general: 'Informations générales',
    title_invoice: 'Informations de facturation',
    title_society: 'Societé',
    title_individual: 'Particulier',
    title_address: 'Adresse',
    civility: 'Civilité',
    firstName: 'Prénom',
    lastName: 'Nom',
    birthDate: 'Date de naissance',
    companyName: "Nom de l'entreprise",
    formeJuridique: 'Forme juridique',
    siren: 'SIREN',
    numTva: 'Numéro TVA intracommunautaire',
    companyOwner: 'Représentant de l’entreprise',
    address: 'Adresse postale',
    complement: "Complement d'adresse",
    city: 'Ville',
    postalCode: 'Code postal',
    country: 'Pays',
    state: 'Etat',
    province: 'Province',
    autorisationPrel: 'Autorisation de prélèvement',
    accountHolder: 'Titulaire du compte',
    accountIban: 'IBAN',
    accountBic: 'BIC',
    reservation: 'Réservations',
    activity: 'Communication',
    litigation: 'Litiges',
    claiming: 'Réclamations',
    referrer: 'Référents',
    files: 'Pièces jointes',
  },
  item_label: {
    label: 'Libellé',
    type: 'Type',
    enabled: 'Activé',
    position: 'Position',
    purchase_type: "Type d'achat",
    confirm_delete_purchase_type: "Êtes-vous sûr de vouloir supprimer ce type d'achat ?",
    purchase_type_added: "Le type d'achat a bien été ajouté",
    purchase_type_empty: "Aucun type d'achat",
    purchase_type_updated: "Le type d'achat a bien été modifié",
    achat_hote_type: "Type d'achat hôte",
    confirm_delete_achat_hote_type: "Êtes-vous sûr de vouloir supprimer ce type d'achat hôte ?",
    achat_hote_type_added: "Le type d'achat hôte a bien été ajouté",
    achat_hote_type_empty: "Aucun type d'achat hôte",
    achat_hote_type_updated: "Le type d'achat hôte a bien été modifié",
    raison_achat_hote: "Raison d'achat hôte",
    confirm_delete_raison_achat_hote: "Êtes-vous sûr de vouloir supprimer cette raison d'achat hôte ?",
    raison_achat_hote_added: "La raison d'achat hôte a bien été ajoutée",
    raison_achat_hote_empty: "Aucune raison d'achat hôte",
    raison_achat_hote_updated: "La raison d'achat hôte a bien été modifiée",
    motif_deplacement: 'Motif de déplacement',
    confirm_delete_motif_deplacement: 'Êtes-vous sûr de vouloir supprimer ce motif de déplacement ?',
    motif_deplacement_added: 'Le motif de déplacement a bien été ajouté',
    motif_deplacement_empty: 'Aucun motif de déplacement',
    motif_deplacement_updated: 'Le motif de déplacement a bien été modifié',
    mandat_cluster_rm: 'Cluster',
    mandat_cluster_rm_added: 'Le cluster a bien été ajouté',
    mandat_cluster_rm_empty: 'Aucun cluster',
    mandat_cluster_rm_updated: 'Le cluster a bien été modifié',
    confirm_delete_mandat_cluster_rm: 'Êtes-vous sûr de vouloir supprimer ce cluster?',
    extra_type: "Type d'extra",
    confirm_delete_extra_type: "Êtes-vous sûr de vouloir supprimer ce type d'extra ?",
    extra_type_added: "Le type d'extra a bien été ajouté",
    extra_type_empty: "Aucun type d'extra",
    extra_type_updated: "Le type d'extra a bien été modifié",
    origin_marketing: 'Origine marketing',
    origin_marketing_added: "L'origine marketing a bien été ajoutée",
    origin_marketing_empty: 'Aucune origine marketing',
    origin_marketing_updated: "L'origine marketing a bien été modifiée",
    confirm_delete_origin_marketing: 'Êtes-vous sûr de vouloir supprimer cette origine marketing ?',
    profile_client: 'Profil voyageur',
    profile_client_added: 'Le profil voyageur a bien été ajouté',
    profile_client_empty: 'Aucun profil voyageur',
    profile_client_updated: 'Le profil voyageur a bien été modifié',
    marche: 'Marché',
    marche_added: 'Le marché a bien été ajouté',
    marche_empty: 'Aucun marché',
    marche_updated: 'Le marché a bien été modifié',
    confirm_delete_profile_client: 'Êtes-vous sûr de vouloir supprimer ce marché ?',
    forme_juridique: 'Forme juridique',
    forme_juridique_added: 'La forme juridique a bien été ajoutée',
    forme_juridique_empty: 'Aucune forme juridique',
    forme_juridique_updated: 'La forme juridique a bien été modifiée',
    confirm_delete_forme_juridique: 'Êtes-vous sûr de vouloir supprimer cette forme juridique ?',
    error_item_label_cluster_used: 'Impossible de supprimer ce cluster, il est utilisé dans un mandat de gestion',
    error_item_label_achat_hote_used:
      "Impossible de supprimer cette raison d'achat, elle est utilisée dans une charge hôte",
    error_item_label_motif_deplacement_used:
      'Impossible de supprimer ce motif de déplacement, il est utilisé dans une charge hôte',
  },
  accommodationRole: {
    attribution: 'Attribution',
    attribute: "M'attribuer",
    attributeTo: 'Attribuer à',
    unattribute: 'Retirer',
    chooseUser: 'Choisir un salarié',
    error_already_exist: 'Cette attribution existe déjà',
  },
  clientRole: {
    attribute: "M'attribuer",
    unattribute: 'Se retirer',
  },
  accommodationType: {
    type: 'Type',
    file: 'Fichier',
    add: 'Ajouter un type de logement',
    added: 'Le type de logement a bien été ajouté',
    updated: 'Le type de logement a bien été modifié',
    deleted: 'Le type de logement a bien été supprimé',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce type de logement ?',
  },
  file: {
    one: 'Fichier',
    many: 'Fichiers',
    name: 'Nom du fichier',
    type: 'Type de fichier',
    size: 'Taille du fichier',
    empty: 'Aucun fichier',
    err_size: 'La taille du fichier ne peut pas dépasser {0} Mo.',
    err_type: 'Le type du fichier est incorrect. Les types de fichier autorisés sont : {0}',
    err_type_basic: "Le type du fichier n'est pas autorisé.",
    confirm_title: 'Supprimer un fichier',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
    deleted: 'Le fichier a bien été supprimé',
  },
  task: {
    item: 'Tâche',
    label: 'Libellé',
    position: 'Position',
    group: 'Groupe',
    groups: 'Groupes',
    groupsAssociated: 'Groupes associés',
    groupsNb: 'Nombre de groupes',
    selectGroups: 'Selectionnez des groupes',
    empty: 'Aucune tâche',
    type: 'Type de tâche',
    add: 'Ajouter une tâche',
    update: 'Modifier une tâche',
    associate_group: 'Associer des groupes',
    added: 'La tâche a bien été ajoutée',
    updated: 'La tâche a bien été modifiée',
    deleted: 'La tâche a bien été supprimée',
    moved: 'La tâche a bien été déplacée',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette tâche ?',
    confirm_dissociategroup: 'Êtes-vous sûr de vouloir dissocier ce groupe de la tâche ?',
    dialog_dissociategroup: 'Association de groupes',
    groupDissociated: 'Le groupe a été dissocié de la tâche',
  },
  taskgroup: {
    item: 'Groupe de tâches',
    label: 'Libellé',
    task: 'Tâche',
    tasks: 'Tâches',
    tasksAssociated: 'Tâches associées',
    tasksNb: 'Nombre de tâches',
    selectTasks: 'Selectionnez des tâches',
    empty: 'Aucun groupe de tâches',
    add: 'Ajouter un groupe de tâches',
    update: 'Modifier un groupe de tâches',
    associate_task: 'Associer des tâches',
    added: 'Le groupe de tâches a bien été ajouté',
    updated: 'Le groupe de tâches a bien été modifié',
    deleted: 'Le groupe de tâches a bien été supprimé',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce groupe de tâches ?',
    confirm_dissociatetask: 'Êtes-vous sûr de vouloir dissocier cette tâche du groupe ?',
    dialog_dissociatetask: 'Association de tâches',
    taskDissociated: 'La tâche a été dissociée du groupe',
  },
  cdcmodel: {
    reset: 'Réinitialiser les CDCs',
    cdc_reset_done: 'Réinitialisation effectuée',
    confirm_reset: 'Êtes-vous sûr de vouloir réinitialiser les CDCs ?',
    model: 'Modèle de cahier des charges',
    type: 'Type de modèle',
    item_count: 'Nombre de blocs',
    add_item: 'Ajouter un bloc',
    edit_item: 'Editer un bloc',
    delete_item: 'Supprimer un bloc',
    cdcmodelType_check_in: 'Check-in',
    cdcmodelType_check_out: 'Check-out',
    cdcmodelType_cleaning: 'Ménage interlocatif',
    cdcmodelType_cleaning_before: 'Ménage retour hôte',
    cdcmodelType_cleaning_after: 'Ménage départ hôte',
    cdcmodelType_running: 'Running',
    cdcmodelType_quality_control: 'Contrôle qualité',
    cdcmodelType_maintenance: 'Maintenance',
    error_reset_cdc_prestation: 'Un cdc est utilisé dans une prestation, réinitialisation impossible',
  },
  cdcmodelitem: {
    zone: 'Zone',
    subzone: 'Sous-zone',
    task: 'Tâche',
    taskgroup: 'Groupe de tâches',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce bloc ?',
  },
  cdc: {
    title: 'Cahier des charges',
    type: 'Type',
    duration: 'Durée',
    price: 'Prix',
    itemsNb: 'Nombre de blocs',
    tasksNb: 'Nombre de tâches',
    comment: 'Commentaire',
    updated: 'Le cahier des charges a bien été modifié',
    error_update: 'Une erreur est survenue lors de la mise à jour du cahier des charges',
  },
  cdcitem: {
    delete_item: 'Supprimer ce bloc',
    add_item: 'Ajouter un bloc',
    add_task: 'Ajouter une tâche',
    confirm_delete: "Êtes-vous sûr de vouloir supprimer cet item ? L'ensemble des sous-tâches sera également supprimée",
  },
  cdcitemtask: {
    delete_item: 'Supprimer cette tâche',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette tâche ?',
  },

  list: {
    additionalEquipment: {
      elements_basiques: 'Éléments basiques',
      cintres: 'Cintres',
      television_ecran_plat: 'Télévision écran plat',
      television_ecran_panoramique: 'Télévision écran panoramique',
      entree_privee: 'Entrée privée',
      salon_prive: 'Salon privé',
      serrure_dans_la_porte_de_la_chambre: 'Serrure dans la porte de la chambre',
      shampoing: 'Shampoing',
      oreillers_et_couvertures_supplementaires: 'Oreillers et couvertures supplémentaires',
      wifi_de_poche: 'Wifi de poche',
      espace_de_travail_pour_ordinateur_portable: 'Espace de travail pour ordinateur portable',
      chargeur_pour_vehicule_electrique: 'Chargeur pour véhicule électrique',
      pas_d_escalier_dans_le_logemnt: 'Pas d’escalier dans le logement',
      accessoires_de_plage: 'Accessoires de plage',
      bagagerie_autorisee: 'Bagagerie autorisée',
      extincteur: 'Extincteur',
      kit_de_premier_secours: 'Kit de premier secours',
      detecteur_de_fumee: 'Détecteur de fumée',
      detecteur_de_monoxyde_de_carbone: 'Détecteur de monoxyde de carbone',
      table_a_langer: 'Table à langer',
      livre_et_jeux_pour_enfants: 'Livre et jeux pour enfants',
      vaisselle_pour_enfants: 'Vaisselle pour enfants',
      par_feu_cheminee: 'Par feu cheminée',
      console_de_jeu: 'Console de jeu',
      cache_prise: 'Cache prise',
      berceau: 'Berceau',
      regulateur_de_lumiere: 'Régulateur de lumière',
      ecalier_avec_porte: 'Escalier avec porte',
      protection_coins_de_table: 'Protection coins de table',
      grille_de_securite_fenetre: 'Grille de sécurité fenêtre',
      couloir_spacieux: 'Couloir spacieux',
      hall_d_entree_illumine: 'Hall d’entrée illuminé',
      entree_de_la_maison_spacieuse: 'Entrée de la maison spacieuse',
      allee_ample_vers_la_porte_d_entree: 'Allée ample vers la porte d’entrée',
      pakring_pour_handicape: 'Parking pour handicapé',
      sortie_de_lit_tres_spacieuse: 'Sortie de lit très spacieuse',
      entree_de_chambre_tres_spacieuse: 'Entrée de chambre très spacieuse',
      hauteur_de_lit_accessible: 'Hauteur de lit accessible',
      lit_reglable_electriquement: 'Lit réglable électriquement',
      acces_a_la_salle_de_bain_sans_escalier: 'Accès à la salle de bain sans escalier',
      bar_d_appui_dans_la_douche: 'Bar d’appui dans la douche',
      bar_d_appui_dans_les_wc: 'Bar d’appui dans les WC',
      hauteur_des_toilettes_accessibles: 'Hauteur des toilettes accessibles',
      pas_de_marche_a_la_sortie_de_la_doiuche: 'Pas de marche à la sortie de la douche',
      douche_avec_chaise_incorpore: 'Douche avec chaise incorporée',
      entree_dans_la_salle_de_bain_spacieuse: 'Entrée dans la salle de bain spacieuse',
      baignoire_avec_chaise_incorpore: 'Baignoire avec chaise incorporée',
      sortie_de_douche_et_de_toilettes_spacieuses: 'Sortie de douche et de toilettes spacieuses',
      pommeau_de_douche_manuelle: 'Pommeau de douche manuel',
      acces_piece_commune_sans_escalier: 'Accès pièce commune sans escalier',
      entree_et_pieces_communes_tres_spacieuse: 'Entrée et pièces communes très spacieuses',
      souleve_personne: 'Soulève personne',
      piscine_avec_fauteuil_elevateur: 'Piscine avec fauteuil élévateur',
      leve_personne_au_plafond: 'Lève personne au plafond',
      coffre_fort_pour_ordinateur_portable: 'Coffre fort pour ordinateur portable',
      canape: 'Canapé',
      reveil: 'Réveil',
      salle_de_reunion: 'Salle de réunion',
      enceinte_ipod: 'Enceinte ipod',
      equipments_de_cuisine: 'Equipements de cuisine',
      bidet: 'Bidet',
      ordinateur: 'Ordinateur',
      ipad: 'Ipad',
      ordinateur_portable: 'Ordinateur portable',
      produit_de_nettoyage: 'Produit de nettoyage',
      couverture_electrique: 'Couverture électrique',
      vue_sur_la_ville: 'Vue sur la ville',
      table_de_salle_a_manger: 'Table de salle à manger',
      salle_a_manger_d_exterieur: 'Salle à manger d’extérieure',
      propriete_de_plein_pied: 'Propriété de plein pied',
      etendoir_a_linge: 'Etendoir à linge',
      protection_prise_pour_enfant: 'Protection prise pour enfant',
      jeu_de_societe: 'Jeu de société',
      puzzle: 'Puzzle',
      porte_de_secuite_pour_bebe: 'Porte de sécuité pour bébé',
      baignoire_adapte: 'Baignoire adaptée',
      cuvette_de_toilette_eleve: 'Cuvette de toilette élevée',
      lavabo_accessible: 'Lavabo accessible',
      piscine_sur_le_toit: 'Piscine sur le toit',
      piscine_a_debordement: 'Piscine à débordement',
      piscine_avec_vue: 'Piscine avec vue',
      piscine_d_eau_sale: 'Piscine d’eau salée',
      piscine_d_immersion: 'Piscine d’immersion',
      serviette_de_piscine: 'Serviette de piscine',
      piscine_avec_zone_peu_profonde: 'Piscine avec zone peu profonde',
      bache_de_protection_piscine: 'Bache de protection piscine',
      vin_champagne: 'Vin / champagne',
      bouteille_d_eau: 'Bouteille d’eau',
      fruit: 'Fruit',
      chocolat_biscuits: 'Chocolat / biscuits',
      poubelle: 'Poubelle',
      verre_a_vin: 'Verre à vin',
      brosse_a_dents: 'Brosse à dents',
      apres_shampoing: 'Après shampoing',
      gel_douche: 'Gel douche',
      baignoire_a_remou: 'Baignoire à remous',
      baignoire: 'Baignoire',
      article_de_bain_et_de_toilette_gratuit: 'Article de bain et de toilette gratuit',
      telephone_sans_fil: 'Téléphone sans fil',
      bureau: 'Bureau',
      bureau_avec_lampe: 'Bureau avec lampe',
      fax: 'Fax',
      fims_gratuit: 'Films gratuits',
      baignoire_grec: 'Baignoire grecque',
      table_a_repasser: 'Table à repasser',
      grand_bureau: 'Grand bureau',
      telephone_multi_ligne: 'Téléphone multi ligne',
      video_a_la_demande_vod: 'Vidéo à la demande / vod',
      telephone_dans_la_salle_de_bain: 'Téléphone dans la salle de bain',
      assiettes_et_bols: 'Assiettes et bols',
      refregirateur_avec_appareil_a_glacon: 'Réfrigérateur avec appareil à glaçons',
      armoire_separe: 'Armoire séparée',
      douche_uniquement: 'Douche uniquement',
      salon: 'Salon',
      climatisation_avec_telecommande_dans_la_chambre: 'Climatisation avec télécommande dans la chambre',
      baignoire_et_hydromassage_separe: 'Baignoire et hydromassage séparés',
      table_et_chaise: 'Table et chaise',
      baignoire_et_douche_separe: 'Baignoire et douche séparées',
      ventilateur_de_plagond: 'Ventilateur de plafond',
      armoire_dans_la_chambre: 'Armoire dans la chambre',
      systeme_de_chauffage_climatisation_auto_controlee: 'Système de chauffage / climatisation auto controlée',
      vue_sur_le_golf: 'Vue sur le golf',
      vue_sur_mer: 'Vue sur mer',
      armoire: 'Armoire',
      salon_avec_canape_chause: 'Salon avec canapé / chaise',
      zone_de_toilette_independante: 'Zone de toilette indépendante',
      raclette: 'Raclette',
      salle_a_manger: 'Salle à manger',
      epices: 'Epices',
      salle_de_jeu: 'Salle de jeux',
      poele_a_bois: 'Poêle à bois',
      non_accessible_pour_personnes_en_chaise_roulante: 'Non accessible pour personnes en chaise roulante',
      douche_et_baignoire_ensemble: 'Douche et baignoire ensemble',
      douche: 'Douche',
      baby_foot: 'Baby foot',
      bibliotheque_musical: 'Bibliothèque musicale',
      table_de_ping_pong: 'Table de ping pong',
      billard: 'Billard',
      stereo: 'Stéréo',
      video_tech: 'Vidéo tech',
      velo: 'Vélo',
      veranda: 'Véranda',
      piscine_interieur: 'Piscine intérieure',
      fetes_et_evenement_non_autorisees: 'Fêtes et évènements non autorisés',
      salle_de_musculation: 'Salle de musculation',
      famille: 'Famille',
      romantique: 'Romantique',
      spa: 'Spa',
      grill_pour_barbecue: 'Grill pour barbecue',
      baignoire_seulement: 'Baignoire seulement',
      bain_ou_douche: 'Bain ou douche',
      television_par_cable: 'Télévision par cable',
      chambre_communicante: 'Chambre communicante',
      materiel_de_cuisine: 'Matériel de cuisine',
      kitchenette: 'Kitchenette',
      salle_de_bain_prive: 'Salle de bain privée',
      cuisiniere: 'Cuisinière',
      xbox: 'Xbox',
      ps2: 'Ps2',
      ps3: 'ps3',
      wii: 'Wii',
      xbox_one: 'Xbox one',
      wii_u: 'Wii u',
      ps4: 'Ps4',
      espace_salon: 'Espace salon',
      patio: 'Patio',
      dressing: 'Dressing',
      salle_de_bain_supplementaire: 'Salle de bain supplémentaire',
      mobilier_d_exterieur: 'Mobilier d’extérieur',
      appartement_prive_dans_un_immeuble: 'Appartement privé dans un immeuble',
      sechoir_a_linge: 'Séchoir à linge',
      espace_barbecue_pique_nique: 'Espace barbecue / pique nique',
      piscine_exterieur: 'Piscine extérieure',
      stationnement_en_voirie: 'Stationnement en voirie',
      parking_securise: 'Parking sécurisé',
      tous_les_espaces_non_fumeur: 'Tous les espaces non fumeur',
      station_de_recharge_pour_vehicule_electrique: 'Station de recharge pour véhicule électrique',
      velo_gratuit: 'Vélo gratuit',
      cheminee_exterieur: 'Cheminée exterieure',
      terrasse_ensoleille: 'Terrasse ensoleillée',
      plage: 'Plage',
      flechette: 'Fléchette',
      snorkeling: 'Snorkeling',
      squash: 'Squash',
      canoe: 'Canoë',
      acces_ski_au_pied: 'Accès ski au pied',
      plongee: 'Plongée',
      equipement_de_tennis: 'Equipement de tennis',
      equipement_de_badminton: 'Equipement de badminton',
      local_a_ski: 'Local à ski',
      plage_privee: 'Plage privée',
      enfants_bienvenue: 'Enfants bienvenus',
      douche_exterieur: 'Douche extérieure',
      oreiller: 'Oreiller',
      veranda_meuble: 'Véranda meublée',
      patio_meuble: 'Patio meublé',
      balcon_ou_pation: 'Balcon ou patio',
      controle_de_la_climatisation: 'Contrôle de la climatisation',
      coffre_fort_standard: 'Coffre fort standard',
      rideau_opaque: 'Rideau opaque',
      chambre_decoree: 'Chambre décorée',
    },
    bathroomEquipment: {
      seche_cheveux: 'Sèche-cheveux',
      baignoire_bebe: 'Baignoire bébé',
      seche_serviette: 'Sèche-serviette',
      lave_linge: 'Lave-linge',
      seche_linge: 'Sèche-linge',
      radio: 'Radio',
      jacuzzi: 'Jacuzzi',
      sauna: 'Sauna',
      baignoire_spa: 'Baignoire Spa',
      radiateur: 'Radiateur',
      balance: 'Balance',
      porte_savon: 'Porte-savon',
    },
    bathroomFurniture: {
      douche: 'Douche',
      baignoire: 'Baignoire',
      vasques: 'Vasques',
      miroir: 'Miroir',
      meuble_de_rangement: 'Meuble de rangement',
      rangement_sous_vasques: 'Rangement sous vasques',
      wc: 'WC',
    },
    bedroomBed: {
      double: 'Double (140 x 200)',
      queen_size: 'Queen size (160 x 200)',
      king_size: 'King size (180 x 200)',
      king_size_xl: 'King size XL (200 x 200)',
      simple: 'Simple (90 x 200)',
      simple_80: 'Simple (80 x 190)',
      simple_120: 'Simple (120 x 190)',
      super_pose: 'Super posé',
      canape_lit: 'Canapé lit',
      lit_d_appoint: 'Lit d’appoint',
      lit_gigogne: 'Lit gigogne',
    },
    bedroomEquipment: {
      television: 'Télévision',
      jouet: 'Jouet',
      porte_avec_verrou: 'Porte avec verrou',
      climatisation: 'Climatisation',
      oreillers_supplementaires: 'Oreillers supplémentaires',
      plaids: 'Plaids',
      couverture_supplementaire: 'Couverture supplémentaire',
      rideau_opaque: 'Rideau opaque',
      ventilateur_plafond: 'Ventilateur plafond',
      moustiquaires: 'Moustiquaires',
    },
    bedroomFurniture: {
      table_de_chevet: 'Table de chevet',
      lampe_de_chevet: 'Lampe de chevet',
      bureau: 'Bureau',
      chaise: 'Chaise',
      radiateur: 'Radiateur',
      armoire: 'Armoire',
      placard: 'Placard',
      commodes_semainier: 'Commodes / Semainier',
      cintres: 'Cintres',
      miroir: 'Miroir',
      cadres: 'Cadres',
    },
    bedroomLayout: {
      chambre_communicante: 'Chambre communicante',
      chambre_separee: 'Chambre séparée',
    },
    diningroomEquipment: {
      radiateur: 'Radiateur',
      ventilateur: 'Ventilateur',
      television: 'Télévision',
      radio: 'Radio',
    },
    diningroomFurniture: {
      table_a_manger: 'Table à manger',
      rallonge: 'Rallonge',
      chaises: 'Chaises',
      chaise_haute: 'Chaise haute',
      rangement: 'Rangement',
    },
    espaceExterieur: {
      barbecue: 'Barbecue',
      plancha: 'Plancha',
      mobilier_de_jardin: 'Mobilier de jardin',
      transat: 'Transat',
      parasol: 'Parasol',
      jeu_pour_enfants: 'Jeu pour enfants',
      arrosage: 'Arrosage',
      squash: 'Squash',
      tennis: 'Tennis',
      paddle: 'Paddle',
      piscine: 'Piscine',
      sauna: 'Sauna',
      hammam: 'Hammam',
      jacuzzi: 'Jacuzzi',
    },
    saunaType: {
      indoor: 'Intérieur',
      outdoor: 'Extérieur',
    },
    kitchenEquipment: {
      television: 'Télévision',
      refrigerateur: 'Réfrigérateur',
      congelateur: 'Congélateur',
      lave_vaisselle: 'Lave-vaisselle',
      four: 'Four',
      friteuse: 'Friteuse',
      micro_ondes: 'Micro-ondes',
      appareil_raclette: 'Appareil à raclette',
      machine_a_cafe_a_filtre: 'Machine à café à filtre',
      machine_a_cafe_a_dosette_nespresso: 'Machine à café à dosette Nespresso',
      machine_a_cafe_a_dosette_tassimo: 'Machine à café à dosette Tassimo',
      machine_a_cafe_a_dosette_senseo: 'Machine à café à dosette Senseo',
      machine_a_cafe_a_dosette_dolce_gusto: 'Machine à café à dosette Dolce gusto',
      machine_a_cafe_a_grain: 'Machine à café à grain',
      cafetiere_piston: 'Cafetière à piston',
      machine_a_cafe_a_dosette_krups: 'Machine à café à dosette KRUPS',
      grille_pain: 'Grille pain',
      bouilloire: 'Bouilloire',
      presse_agrume: 'Presse agrume',
      couverts: 'Couverts',
      ustensiles_de_cuisine: 'Ustensiles de cuisine',
      lave_linge: 'Lave linge',
      seche_linge: 'Sèche linge',
    },
    systemeAutonome: {
      locker_box: 'Boîte à clé',
      nuki: 'Nuki',
      igloo_home: 'Igloohome',
      bnb_access: 'Bnb access',
      key_nest: 'Keynest',
      others: 'Autre',
    },
    kitchenFurniture: {
      tables: 'Tables',
      chaises: 'Chaises',
      placards_de_rangement: 'Placards de rangement',
    },
    officeFurnitures: {
      bureau: 'Bureau',
      chaise: 'Chaise',
      rangement: 'Rangement',
      radiateur: 'Radiateur',
      ventilateur: 'Ventilateur',
      cadre: 'Cadre',
      placard: 'Placard',
    },
    officeEquipments: {
      tv: 'Télévision',
      radio: 'Radio',
      lampe: 'Lampe',
      rallonge: 'Rallonge',
      livre: 'Livres',
    },
    kitchenHotplates: {
      plaque_a_induction: 'Plaque à induction',
      vitroceramique: 'Vitrocéramique',
      gaz: 'Gaz',
      electrique: 'Electrique',
    },
    kitchenStyle: {
      ouverte: 'Ouverte (Américaine)',
      fermee: 'Fermée',
      semi_ouverte: 'Semi-ouverte',
    },
    laundryroomEquipment: {
      lave_linge: 'Lave linge',
      seche_linge: 'Sèche linge',
      tancarville: 'Tancarville',
      table_a_repasser: 'Table à repasser',
      fer_a_repasser: 'Fer à repasser',
      fil_a_linge: 'Fil à linge',
    },
    laundryroomFurniture: {
      tables: 'Tables',
      chaises: 'Chaises',
      placards_de_rangement: 'Placards de rangement',
    },
    outsideEquipment: {
      barbecue: 'Barbecue',
      plancha: 'Plancha',
      mobilier_de_jardin: 'Mobilier de jardin',
      transat: 'Transat',
      parasol: 'Parasol',
      jeu_pour_enfants: 'Jeu pour enfants',
      arrosage: 'Arrosage',
      squash: 'Squash',
      tennis: 'Tennis',
      paddle: 'Paddle',
      piscine: 'Piscine',
      sauna: 'Sauna',
      hammam: 'Hammam',
      jacuzzi: 'Jacuzzi',
    },
    outsidePlace: {
      balcon: 'Balcon',
      jardin: 'Jardin',
      jardin_cloture: 'Jardin clôturé',
      terrasse: 'Terrasse',
      cabanon_de_jardin: 'Cabanon de jardin',
      salle_de_sport: 'Salle de sport',
      potager: 'Potager',
    },
    outsidePlaceAppartment: {
      balcon: 'Balcon',
      terrasse: 'Terrasse',
      mobilier_de_jardin: 'Mobilier de jardin',
      barbecue: 'Barbecue',
      plancha: 'Plancha',
      cour: 'Cour',
      table: 'Table',
      chause: 'Chause',
      transat: 'Transat',
      poufs: 'Poufs',
      parasol: 'Parasol',
      plantes: 'Plantes',
      jouets: 'Jouets',
    },
    outsidePlaceResidence: {
      squash_dans_la_residence: 'Squash dans la résidence',
      tennis_dans_la_residence: 'Tennis dans la résidence',
      paddle_dans_la_residence: 'Paddle dans la résidence',
      piscine_dans_la_residence: 'Piscine dans la résidence',
      salle_de_sport_dans_la_residence: 'Salle de sport dans la résidence',
    },
    salonEquipment: {
      television: 'Télévision',
      plateforme_de_streaming_netflix: 'Plateforme de streaming Netflix',
      plateforme_de_streaming_amazon_prime_video: 'Plateforme de streaming Amazon prime video',
      plateforme_de_streaming_canal: 'Plateforme de streaming Canal +',
      plateforme_de_streaming_disney_plus: 'Plateforme de streaming Disney plus',
      plateforme_de_streaming_salto: 'Plateforme de streaming Salto',
      plateforme_de_streaming_ocs: 'Plateforme de streaming OCS',
      plateforme_de_streaming_apple_tv: 'Plateforme de streaming Apple TV',
      lecteur_dvd: 'Lecteur dvd',
      console_de_jeu_ps2: 'Console de jeu PS2',
      console_de_jeu_ps3: 'Console de jeu PS3',
      console_de_jeu_ps4: 'Console de jeu PS4',
      console_de_jeu_ps5: 'Console de jeu PS5',
      console_de_jeu_xbox_360: 'Console de jeu XBOX 360',
      console_de_jeu_xbox_one: 'Console de jeu XBOX ONE',
      console_de_jeu_autre: 'Console de jeu autre',
      radio: 'Radio',
      lecteur_cd: 'Lecteur CD',
      enceinte_bluetooth: 'Enceinte bluetooth',
      jeux: 'Jeux',
      livres: 'Livres',
      cheminee: 'Cheminée',
      poele_a_bois: 'Poele à bois',
      moustiquaires: 'Moustiquaires',
      radiateur: 'Radiateur',
      thermostat: 'Thermostat',
    },
    salonFurniture: {
      canape: 'Canapé',
      canape_lit: 'Canapé lit',
      fauteuil: 'Fauteuil',
      fauteuil_lit: 'Fauteuil lit',
      chaise: 'Chaise',
      table_basse: 'Table basse',
      lampe: 'Lampe',
      cadres: 'Cadres',
      miroir: 'Miroir',
    },
    typeChauffage: {
      pompe_a_chaleur: 'Pompe à chaleur',
      chauffage_central: 'Chauffage central',
      chauffage_electrique: 'Chauffage électrique',
      chaudiere_a_gaz_individuel: 'Chaudière à gaz individuelle',
      chauffage_a_gaz_collectif: 'Chauffage à gaz collectif',
      chauffage_fioul: 'Chauffage au fioul',
      poele_granule: 'Poêle à granulés',
      empty: 'Pas de chauffage',
    },
    typeEauChaude: {
      chauffe_eau_gaz: 'Chauffe-eau au gaz',
      chauffe_eau_electrique: 'Chauffe-eau électrique',
      chaudiere_commune: 'Chaudière commune',
      chaudiere_fioul: 'Chaudière au fioul',
      chaudiere_a_gaz: 'Chaudière au gaz',
      pompe_chaleur: 'Pompe à chaleur',
      solaire: 'Solaire',
    },
    typeParking: {
      garage: 'Garage',
      stationnement_couvert_reserve: 'Stationnement couvert réservé',
      stationnement_exterieur_prive: 'Stationnement extérieur privé',
      stationnement_possible_dans_le_jardin: 'Stationnement possible dans le jardin',
    },
    wcEquipment: {
      balai_wc: 'Balai WC',
      support_papier_toilette: 'Support papier toilette',
    },
    wcFurniture: {
      lavabo: 'Lavabo',
      meuble_de_rangement: 'Meuble de rangement',
      bidet: 'Bidet',
    },
  },
  accommodationContact: {
    type: 'Type de contact',
    civility: 'Civilité',
    syndic: 'Responsable du syndicat de copropriétaires',
    gardien: 'Gardien de l’immeuble',
    voisin: 'Voisin',
    urgence: "Contact d'urgence",
    plombier: 'Plombier',
    electricien: 'Electricien',
    chauffagiste: 'Chauffagiste',
    pisciniste: 'Pisciniste',
    serrurier: 'Serrurier',
    jardinier: 'Jardinier',
    other: 'Autre',
    deleteContactWarning: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
    internal: 'Interne',
    external: 'Externe',
  },
  contactTypes: {
    empty: 'Aucun type de contact',
    type: 'Type',
    label: 'Libellé',
    add: 'Ajouter un type de contact',
    update: 'Modifier un type de contact',
    internal_added: 'Type de contact interne ajouté',
    internal_updated: 'Type de contact interne modifié',
    internal_confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce type de contact interne ?',
    external_added: 'Type de contact externe ajouté',
    external_updated: 'Type de contact externe modifié',
    external_confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce type de contact externe ?',
  },
  bedroom: {
    layout: 'Agencement',
    beds: 'Lits',
    equipment: 'Equipements',
    furniture: 'Meubles',
    comment: 'Commentaire',
  },
  bathroom: {
    equipment: 'Equipements',
    furniture: 'Meubles',
    comment: 'Commentaire',
  },
  diningroom: {
    seatNb: 'Nombre de sièges',
    equipment: 'Equipements',
    furniture: 'Meubles',
    comment: 'Commentaire',
  },
  laundryroom: {
    equipment: 'Equipements',
    furniture: 'Meubles',
    vacuumType: "Type d'aspirateur",
    vacuumLocation: "Emplacement de l'aspirateur",
    mopLocation: 'Emplacement de la serpilière',
    comment: 'Commentaire',
  },
  salon: {
    equipment: 'Equipements',
    furniture: 'Meubles',
    comment: 'Commentaire',
  },
  wc: {
    equipment: 'Equipements',
    furniture: 'Meubles',
    comment: 'Commentaire',
    independant: 'Indépendant ',
  },
  kitchen: {
    style: 'Style',
    type: 'Type',
    hotplates: 'Plaques de cuisson',
    equipment: 'Equipements',
    furniture: 'Meubles',
    comment: 'Commentaire',
  },
  ficType: {
    ESTIMATION_LOCATIVE: 'Estimation locative',
    MANDAT_GESTION_UNSIGNED: 'Mandat de gestion à signer',
    MANDAT_GESTION_SIGNED: 'Mandat de gestion signé',
    AVENANT_SIGNED: 'Avenant au mandat de gestion signé',
    AVENANT_UNSIGNED: 'Avenant au mandat de gestion à signer',
    avenant_signed_date: 'Avenant signé du {date}',
    RIB: 'RIB',
    identity_indivision: "Pièce d'identité de {firstname} {lastname} (recto)",
    identity_indivision2: "Pièce d'identité de {firstname} {lastname} (verso)",
    IDENTITY: "Pièce d'identité (recto)",
    IDENTITY2: "Pièce d'identité (verso)",
    JUSTIFPROPRI: 'Accord de copropriété',
    CONTRATASSU: "Contrat d'assurance",
    ACCORDLOCATION: 'Accord de sous-location',
    CERFA: 'Déclaration de meublé de tourisme',
    TDS: 'Tarifs de la taxe de séjour',
    REGCOPRO: 'Accord de copropriété',
    KBIS: 'KBIS de la société',
    PIECE_IDENTITY: "Pièce d'identité",
    MANDAT_LETTRE_RESILIATION: 'Lettre de résiliation',
    DPE: 'DPE',
    PICTURE_PARKING: 'Photo du parking',
    PICTURE_TABLEAU: 'Photo du tableau éléctrique',
    PICTURE_WATER: "Photo de l'arrivée d'eau",
    PICTURE_WIFI: 'Photo de la box',
    PICTURE: 'Photo',
  },
  requestModif: {
    message: 'Saisissez le texte de votre message de demande de modification',
    title: 'Demander une modification',
    msgSent: 'Demande de modification envoyée',
    messageRequired: 'Le message est requis',
  },
  activity: {
    activity: 'Activité',
    new: 'Nouvelle activité',
    empty: 'Aucune activité',
    details: "Fiche d'activité",
    interlocutorType: "Type d'interlocuteur",
    interlocutor: 'Interlocuteur',
    proprietaire: 'Hôte',
    prospect: 'Prospect',
    salarie: 'Salarié',
    candidat: 'Candidat',
    voyageur: 'Voyageur',
    prestataire: 'Prestataire',
    accommodation: 'Logement',
    reservation: 'Réservation',
    dateHour: 'Création',
    who: 'Qui',
    contactWay: 'Moyen de contact',
    motif: 'Motif',
    comment: 'Description',
    files: 'Fichiers associés',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette activité ?',
    add: 'Ajouter',
    added: 'Activité ajoutée',
    update: "Modifier l'activité",
    updated: 'Activité modifiée',
    delete: "Supprimer l'activité",
    deleted: 'Activité supprimée',
  },
  ticket: {
    list: 'Tickets',
    my_list: 'Mes tickets',
    empty: 'Aucun ticket',
    attribution: 'Attribution',
    pole: 'Attribution Pole',
    employee: 'Attribution Membre',
    team: 'Attribution Equipe',
    company: 'Attribution agence',
    activity: 'Activité',
    label: 'Libellé',
    ticketNumber: 'Ticket',
    status: 'Statut',
    priority: 'Priorité',
    description: 'Description',
    commentsNb: 'Nb de commentaires',
    ficsNb: 'Nb de fichiers',
    dueDate: "Date d'échéance",
    startDate: 'Date de démarrage',
    waitingValidationDate: 'Date de fermeture',
    validatedDate: 'Validation',
    dateCreated: 'Création',
    creator: 'Auteur',
    comments: 'Commentaires',
    files: 'Fichiers',
    historic: 'Historique',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce ticket ?',
    confirm_start: 'Êtes-vous sûr de vouloir démarrer ce ticket ?',
    confirm_renew: 'Êtes-vous sûr de vouloir ré-ouvrir ce ticket ?',
    confirm_close: 'Êtes-vous sûr de vouloir fermer ce ticket ?',
    add: 'Créer un ticket',
    added: 'Ticket ajouté',
    start: 'Démarrer',
    started: 'Ticket démarré',
    renew: 'Ré-ouvrir',
    renewed: 'Ticket ré-ouvert',
    close: 'Fermer le ticket',
    closed: 'Ticket en attente de validation',
    attribute: 'Attribuer',
    attributeTicket: 'Attribuer le ticket',
    changePriority: 'Changer la priorité',
    priorityChanged: 'Priorité changée',
    attributed: 'Ticket attribué',
    reattribute: 'Réattribuer',
    reattributed: 'Ticket réattribué',
    update: 'Modifier le ticket',
    updated: 'Ticket modifié',
    delete: 'Supprimer le ticket',
    deleted: 'Ticket supprimé',
    details: 'Fiche de ticket',
    status_new: 'Nouveau',
    status_in_progress: 'En cours',
    status_waiting_validation: 'En attente de validation',
    status_validated: 'Fermé',
    priority_low: 'Bas',
    priority_medium: 'Moyen',
    priority_high: 'Haut',
    priority_critical: 'Critique',
    prospect_display: 'Prospect',
    client_display: 'Client',
    owner_display: 'Hôte',
    accommodation: 'Logement',
    category: 'Catégorie de la demande',
    subCategory: 'Sous catégorie de la demande',
    reason: 'Raison',
    amount_ttc: 'Montant TTC',
    commission_ga: 'Frais de gestion Guestadom',
    attributed_to_me: 'Me sont attribués',
    validate_resolution: 'Valider la résolution',
    refuse_resolution: 'Refuser la résolution',
    resolution_refused: 'Résolution du ticket refusée',
    resolution_validated: 'Résolution validée',
    validate: 'Valider',
    refusal_comment: 'Commentaire de refus',
    confirm_validate_resolution: 'Êtes-vous sûr de vouloir valider la résolution de ce ticket ?',
    error: 'Une erreur est survenue',
    error_empty_files: 'Le champ Fichier est requis',
    error_no_owner_pole: "Une erreur est survenue lors de la création d'indisponibilité",
    error_empty_refusal_comment: 'Le commentaire de refus est requis',
    error_validate_not_closed: 'Impossible de valider un ticket non fermé',
  },
  ticketcomment: {
    message: 'Message',
    replyTitle: 'Répondre à un commentaire',
    comment: 'Commenter le ticket',
    added: 'Commentaire ajouté',
    replied: 'Réponse ajoutée',
    reply: 'Répondre',
    newComment: 'Ecrire un nouveau commentaire',
  },
  amenity: {
    antique: 'Antique',
    art_deco: 'Art Déco',
    atypique: 'Atypique',
    baroque: 'Baroque',
    troglodyte: 'Habitation troglodyte',
    bois: 'Bois',
    contemporain: 'Contemporain',
    ecologique: 'Ecologique',
    empire: 'Empire',
    historique: 'Historique',
    hi_tech: 'Hi-tech',
    minimaliste: 'Minimaliste',
    romantique: 'Romantique',
    victorien: 'Victorien',

    bouteille_eau: "Bouteilles d'eau",
    cave: 'Habitation troglodyte',
    cuisine_equipee: 'Cuisine équipée',
    cuisiniere: 'Cuisinière',
    eau_chaude: 'Eau chaude',
    eau_filtree: 'Eau filtrée',
    fontaine_a_eau: 'Fontaine à eau',
    kitchenette: 'Kitchenette',
    machine_a_glace: 'Machine à glace',
    mixeur: 'Mixeur',
    toaster: 'Toaster',
    verres_a_vin: 'Verres à vin',
    bouilloire: 'Bouilloire',
    congelateur: 'Congélateur',
    four: 'Four',
    four_micro_ondes: 'Four micro-ondes',
    lave_vaisselle: 'Lave-vaisselle',
    machine_cafe: 'Machine à café',
    refrigerateur: 'Réfrigérateur',
    ak_appareil_a_raclette: 'Appareil à raclette',
    ak_friteuse: 'Friteuse',
    ak_grille_pain: 'Grille-pain',
    ak_ustensiles_de_cuisine: 'Ustensiles de cuisine',
    ak_couverts: 'Couverts',
    ak_balance: 'Balance',
    ak_machine_a_cafe_filtre: 'Machine à café filtre',
    ak_machine_a_cafe_nespresso: 'Machine à café Nespresso',
    ak_machine_a_cafe_phillips: 'Machine à café Phillips',
    ak_machine_a_cafe_tassimo: 'Machine à café Tassimo',
    ak_machine_a_cafe_senseo: 'Machine à café Senseo',
    ak_machine_a_cafe_dolce_gusto: 'Machine à café Dolce gusto',
    ak_machine_a_cafe_krups: 'Machine à café Krups',
    ak_machine_a_cafe_a_grain: 'Machine à café à grain',
    ak_cafetiere_a_piston: 'Cafetière à piston',

    adaptee_aux_enfants: 'Adapté aux enfants',
    babyphone: 'Babyphone',
    baignoire_bebe: 'Baignoire bébé',
    balancoire: 'Balançoire',
    chaise_haute: 'Chaise haute',
    convient_aux_bebes: 'Convient aux bébés (moins de 2 ans)',
    convient_aux_enfants: 'Convient aux enfants (2 ans ou plus)',
    garde_robe: 'Garde-robe',
    jeux_pour_enfants: 'Jeux pour enfants',
    jeux_pour_tous_ages: 'Jeux pour tous âges',
    lit_bebe: 'Lit bébé',
    lit_parapluie: 'Lit parapluie',
    livres_pour_enfants: 'Livres pour enfants',
    mariage: 'Mariage',
    piscine_enfants: 'Piscine enfants',
    recommandation_de_babysitter: 'Recommandation de babysitter',
    salle_de_jeux: 'Salle de jeux',
    table_a_langer: 'Table à langer',
    vaiselle_pour_enfants: 'Vaisselle pour enfants',
    jouets: 'Jouets',
    console_jeux: 'Console de jeux',
    lecteur_dvd: 'Lecteur DVD',
    livres: 'Livres',
    service_streaming: 'Service de streaming',
    tv: 'TV',
    ak_lecteur_cd: 'Lecteur CD',
    ak_enceinte_bluetooth: 'Enceinte Bluetooth',
    ak_radio: 'Radio',

    espace_de_travail: 'Espace de travail pour ordinateur portable',
    bureau_de_travail: 'Bureau de travail',
    chargeur_ev: 'Chargeur EV',
    ordinateur_disponible: 'Ordinateur disponible',
    reveil: 'Réveil',
    satellite_ou_cable: 'Satellite ou câble',
    systeme_stereo: 'Système stéréo',
    telephone: 'Téléphone',
    wifi_portable: 'Wifi portable',

    air_conditionne: 'Air conditionné',
    bar_prive: 'Bar privé',
    bowling_prive: 'Bowling privé',
    chauffeur: 'Chauffeur',
    chef_cuisinier_particulier: 'Chef cuisinier particulier',
    cinema: 'Cinéma',
    concierge: 'Concierge partenaire',
    depot_de_bagage: 'Dépôt de bagages autorisé',
    draps_et_serviettes: 'Draps et serviettes',
    helipad: 'Helipad',
    linge_de_luxe: 'Le linge de luxe',
    location_longue_duree: 'Location longue durée possible',
    majordome: 'Majordome',
    menage_inclus: 'Ménage inclus',
    menage_professionnel: 'Ménage professionnel',
    personnel_avec_equipement: 'Personnel avec équipement de protection',
    petit_dejeuner_inclus: 'Petit-déjeuner inclus',
    service_de_menage_quotidien: 'Service de ménage quotidien',
    ventilateurs_de_plafond: 'Ventilateurs de plafond',
    voiture_incluse: 'Voiture incluse',
    bain_jacuzzi: 'Bain jacuzzi',
    jacuzzi: 'Jacuzzi',
    personnel: 'Personnel',
    dispositif_surveillance: 'Dispositif de surveillance',
    barriere_de_securite: 'Barrière de sécurité pour escalier',
    caches_prises: 'Cache-prise',
    consignes_de_securite: 'Consignes de sécurité',
    detecteur_de_monoxyde: 'Détecteur de monoxyde de carbone',
    distanciation_physique: 'Distanciation physique',
    extincteur: 'Extincteur',
    kit_de_premier_secours: 'Kit de premier secours',
    pare_feu: 'Pare-feu pour la cheminée',
    porte_chambre_avec_verrou: 'Porte de la chambre avec verrou',
    protections_coins_de_table: 'Protections sur les coins de tables',
    protections_fenetres: 'Protections sur les fenêtres',
    systeme_de_securite: 'Système de sécurité',
    coffre_fort: 'Coffre-fort',
    interdiction_fumer: 'Interdiction de fumer',
    detecteur_fumee: 'Détecteur de fumée',

    affichage_pratiques_eco_responsables: 'Affichage des pratiques éco-responsables',
    aliments_et_boissons_bio: 'Aliments et boissons bios',
    appareils_basse_consommation: 'Appareils à basse consommation',
    changement_serviettes_sur_demande: 'Changement de serviettes sur demande',
    collecte_des_eaux_pluviales: 'Collecte des eaux pluviales',
    eco_construction: 'Eco-construction',
    eco_tourisme: 'Eco-tourisme',
    pas_d_article_de_toilette_individuel: "Pas d'article de toilette individuel",
    pas_de_plastique_a_usage_unique: 'Pas de plastique à usage unique',
    reduction_du_papier: 'Réduction du papier/papier recyclé',
    soutien_a_des_projets_durables: 'Soutien à des projets durables',
    systeme_energie_renouvelable: "Système d'énergie renouvelable",
    tri_des_dechets: 'Tri des déchets',

    acces_entree_bien_eclaire: "Accès à l'entrée bien éclairé",
    acces_plain_pied_chambre: 'Accès de plain-pied à la chambre',
    acces_plain_pied_salle_de_bain: 'Accès de plain-pied à la salle de bain',
    acces_plain_pied_espaces_communs: 'Accès de plain-pied aux espaces communs',
    acces_large_douche_et_wc: 'Accès large à la douche et au WC',
    acces_large_lit: 'Accès large au lit',
    acces_plat_porte_entree: "Accès plat à la porte d'entrée",
    baie: 'Baie',
    baignoire_avec_siege_de_bain: 'Baignoire avec siège de bain',
    barres_appui_douche: "Barres d'appui pour douche",
    barres_appui_wc: "Barres d'appui pour WC",
    couloir_large: 'Couloir large',
    douche_plain_pied: 'Douche de plain-pied',
    entree_large_salle_de_bain: 'Entrée large à la salle de bain',
    entree_large_espaces_communs: 'Entrée large aux espaces communs',
    leve_personne_mobile: 'Lève-personne mobile',
    leve_personne_plafonnier: 'Lève-personne plafonnier',
    lit_a_hauteur_accessible: 'Lit à hauteur accessible',
    lit_ajustable_en_hauteur: 'Lit ajustable en hauteur',
    piscine_avec_leve_personne: 'Piscine avec lève-personne',
    place_de_parking_handicapee: 'Place de parking handicapée',
    pomme_de_douche_amovible: 'Pomme de douche amovible',
    porte_large: 'Porte large',
    porte_large_chambre: 'Porte large pour la chambre',
    siege_de_douche: 'Siège de douche',
    toilettes_ajustables_en_hauteur: 'Toilettes ajustables en hauteur',
    acces_handicapes: 'Accès handicapés',
    escaliers_a_monter: 'Escaliers à monter',

    gants_disponibles: 'Gants disponibles',
    gel_hydroalcoolique: 'Gel hydroalcoolique',
    laverie_automatique: 'Laverie automatique',
    menage_fait_avant_le_depart: 'Le ménage doit être fait avant le départ',
    masques_disponibles: 'Masques disponibles',
    materiel_de_repassage: 'Matériel de repassage',
    menage_et_desinfection: 'Ménage et désinfection',
    produits_de_base: 'Produits de base',
    produit_de_nettoyage: 'Produits de nettoyage',
    lave_linge: 'Lave-linge',
    seche_linge: 'Sèche-linge',
    aspirateur: 'Aspirateur',
    ak_tancarville: 'Tancarville',
    ak_seche_serviette: 'Sèche-serviette',

    lift: 'Ascenseur',
    chimney: 'Cheminée',
    hangers: 'Cintres',
    heater: 'Radiateur',
    hair_dryer: 'Sèche-cheveux',
    internet: 'Wifi',
    mosquito_net: 'Moustiquaire',
    extra_pillows_blankets: 'Oreillers et couvertures supplémentaires',
    fan: 'Ventilateur',
    central_heating: 'Chauffage central',
    ak_poele_a_bois: 'Poêle à bois',
    ak_thermostat: 'Thermostat',
    ak_climatisation: 'Climatisation',
    ak_plaids: 'Plaids',
    ak_rideau_opaques: 'Rideaux opaques',
    ak_douche: 'Douche',
    ak_baignoire: 'Baignoire',

    balcon: 'Balcon',
    cloture_entourant_piscine: 'Clôture entourant la piscine',
    couverture_de_piscine: 'Couverture de piscine',
    entree_privee: 'Entrée privée',
    patio: 'Patio',
    piscine_a_debordement: 'Piscine à débordement',
    piscine_chauffee: 'Piscine chauffée',
    piscine_commune: 'Piscine commune',
    piscine_en_eau_salée: 'Piscine en eau salée',
    piscine_exterieure_saisonnier: 'Piscine extérieure (saisonnier)',
    piscine_interieure_saisonnier: 'Piscine intérieure (saisonnier)',
    piscine_peu_profonde: 'Piscine peu profonde',
    piscine_privative: 'Piscine privative',
    propriete_cloturee: 'Propriété clôturée',
    quai_a_bateau: 'Quai à bateau',
    residence_fermee: 'Résidence fermée',
    terrasse: 'Terrasse',
    parking_inclus: 'Parking inclus',
    piscine_exterieure: 'Piscine extérieure',
    piscine_interieure: 'Piscine intérieure',
    jardin: 'Jardin',
    parking_accessible: 'Parking accessible',
    parking_commun: 'Parking commun',
    parking_payant_a_lexterieur: "Parking payant à l'extérieur",
    parking_payant_sur_place: 'Parking payant sur place',
    piscine_jacuzzi_non_protegee: 'Piscine / Jacuzzi non protégé',
    parking_prive: 'Parking privé',
    parking_securise: 'Parking sécurisé',
    stationnement_rue: 'Stationnement dans la rue',
    stationnement_interieur: 'Stationnement intérieur',
    garage: 'Garage',
    infos_stationnement: 'Infos stationnement',
    bbq: 'Barbecue',

    proximite_terrain_de_golf: 'A proximité du terrain de golf',
    bord_de_lac: 'Bord de lac',
    bord_de_mer: 'Bord de mer',
    bord_de_plage: 'Bord de plage',
    campagne: 'Campagne',
    centre_ville: 'Centre-ville',
    domaine_viticole: 'Domaine viticole',
    fleuve_riviere: 'Fleuve/rivière',
    lac: 'Lac',
    montagne: 'Montagne',
    plage: 'Plage',
    proche_mer: 'Proche de la mer',
    ski_in: 'Ski In',
    ski_out: 'Ski Out',
    village: 'Village',
    village_vacances_tout_compris: 'Village vacances tout compris',
    ville: 'Ville',
    vue_mer: 'Vue mer',
    vue_montagne: 'Vue sur la montagne',
    vue_plage: 'Vue sur la plage',
    vue_lac: 'Vue sur le lac',
    vue_terrain_de_golf: 'Vue sur le terrain de golf',
    bruit_potentiel: 'Bruit potentiel',
    corps_deau_a_proximite: "Corps d'eau à proximité",
    espaces_partages: 'Espaces partagés',

    baignade: 'Baignade',
    balades_en_bateau: 'Balades en bateau',
    bateau: 'Bateau',
    bouee_tractee: 'Bouée tractée',
    canoe: 'Canoë',
    jet_ski: 'Jet-ski',
    kayak: 'Kayak',
    marina: 'Marina',
    paddle: 'Paddle',
    planche_a_voile: 'Planche à voile',
    plongee: 'Plongée',
    plongee_avec_tuba: 'Plongée avec tuba',
    sports_aquatiques: 'Sports aquatiques',
    surf: 'Surf',
    voile: 'Voile',
    beach_essentials: 'Produits indispensables pour la plage',

    alpinisme: 'Alpinisme',
    casier_a_skis: 'Casier à skis',
    luge: 'Luge',
    motoneige: 'Motoneige',
    patinage_sur_glace: 'Patinage sur glace',
    ski: 'Ski',
    ski_de_fond: 'Ski de fond',
    ski_nautique: 'Ski nautique',
    snowboard: 'Snowboard',

    chasse: 'Chasse',
    cours_de_tennis: 'Court de tennis',
    equipement_fitness: 'Équipement fitness',
    salle_de_gym: 'Salle de gym',
    equitation: 'Equitation',
    escalade: 'Escalade',
    rock_climbing: 'Escalade',

    golf: 'Golf',
    peche: 'Pêche',
    ping_pong: 'Ping Pong',
    rafting: 'Rafting',
    randonnee: 'Randonnée',
    table_de_billard: 'Table de billard',
    terrain_de_basketball: 'Terrain de basketball',
    terrain_de_petanque: 'Terrain de pétanque',
    cyclisme: 'Cyclisme',
    velo: 'Vélo',
    vtt: 'VTT',

    hammam: 'Hammam',
    massage: 'Massage',
    massage_sur_demande: 'Massage sur demande',
    salle_de_massage: 'Salle de massage',
    sauna: 'Sauna',
    solarium: 'Solarium',
    spa_a_proximite: 'Spa à proximité',

    casino: 'Casino',
    magasins_antiquites: "Magasins d'antiquités",
    magasins_usine: "Magasins d'usine",
    magasins_duty_free: 'Magasins duty-free',
    musees: 'Musées',
    observation_faune_flore: 'Observation de la faune et de la flore',
    observation_des_baleines: 'Observation des baleines',
    observation_des_oiseaux: 'Observation des oiseaux',
    parachute_ascensionnel: 'Parachute ascensionnel',
    parc_aquatique: 'Parc aquatique',
    parc_attraction: "Parc d'attraction",
    shopping: 'Shopping',
    speleologie: 'Spéléologie',
    visites_de_vignobles: 'Visites de vignobles',
    structures_descalades_jeux: "Structures d'escalades / jeux",

    bibliotheque_musicale: 'Bibliothèque musicale',
    videotheque: 'Vidéothèque',

    animaux_acceptes: 'Animaux acceptés',
    animaux_dangereux: 'Animaux dangereux',
    animaux_sur_place: 'Animaux sur place',
    divulgation_armes: "Divulgation d'armes",
    hauteurs_non_protegees: 'Hauteurs non protégées',
    restrictions_equipements: 'Restrictions des équipements',

    added: 'Équipement ajouté',
    removed: 'Équipement supprimé',
  },
  notifications: {
    new_onboarding: "Création de l'onboarding de {0} {1} - {2}",
    new_accommodation: 'Nouveau logement',
    waiting_for_sign: 'Votre onboarding est en attente de signature',
    waiting_for_register: 'Inscrire le mandat de gestion {0} au registre papier',
    document_to_validate: "Valider les documents de l'onboarding de {0}",
    document_validated: 'Vos documents ont été approuvés',
    document_validated_for_gav: 'Les documents de {0} ont été approuvés par le support',
    document_refused: 'Vos documents ont été refusés',
    audit_validated_by_owner: '{0} a validé son audit',
    audit_validated_by_gav: 'Votre audit a été validé',
    audit_photo_for_gas: "L'agence {0} vient de terminer l'audit de {1}",
    audit_photo_for_hote: "L'annonce de votre onboarding est en cours de création",
    price_setted_for_pole_rm: "Fixer les prix de l'onboarding de {0}",
    homebook_to_create_for_pole_hote: "Créer le homebook de l'onboarding de {0}",
    homebook_created_for_gav: "Le homebook a été crée pour l'onboarding de {0}",
    homebook_created_for_hote: 'Le homebook de votre onboarding a été crée',
    ad_published_for_gav: "L'annonce a été publiée pour l'onboarding de {0}",
    ad_published_for_hote: "L'annonce de votre onboarding a été publiée",
    notif_ticket_created: 'Un nouveau ticket a été crée : {0}',
    notif_ticket_pole_change: 'Le ticket {0} a été affecté au pole {1}',
    notif_ticket_attribution: 'Le ticket {0} vous a été affecté',
    notif_ticket_priority_change: 'La priorité du ticket {0} est passée de {1} à {2}',
    notif_ticket_renewed: 'Le ticket {0} a été réouvert',
    notif_ticket_started: 'Le ticket {0} a été démarré',
    notif_ticket_closed: 'Le ticket {0} a été fermé',
    notif_ticket_to_be_validate: '{0} est en attente de validation de votre part pour le ticket {1}',
    notif_ticket_validated: 'Votre ticket {0} a été validé par {1}',
    notif_ticket_refused: 'Votre ticket {0} a été refusé par {1}',
    notif_litige_completed: 'Le dossier de litige de la réservation {0} est complet',
    notif_litige_complete_validated: 'Le dossier de litige de la réservation {0} a été validé',
    notif_litige_complete_refused: 'Le dossier de litige de la réservation {0} a été refusé',
    litige_completed: 'Le dossier de litige de la réservation {0} est complet',
    litige_complete_validated: 'Le dossier de litige de la réservation {0} a été validé',
    litige_complete_refused: 'Le dossier de litige de la réservation {0} a été refusé',
    ticket_created: 'Ticket ouvert',
    ticket_started: 'Ticket demarré',
    ticket_waiting_validation: 'Ticket en attente de validation',
    ticket_renewed: 'Ticket réouvert',
    ticket_priority_changed: 'Changement de priorité',
    ticket_comment_added: 'Nouveau commentaire',
    ticket_file_added: 'Nouveau fichier',
    ticket_file_removed: 'Fichier supprimé',
    ticket_validated: 'Ticket validé',
    ticket_refused: 'Ticket refusé',
    ticket_attribution: 'Ticket affecté',
    ticket_employee_attribution_changed: 'Ticket affecté',
  },
  onboardingsuivi: {
    title: 'Suivi des onboardings',
    completeBtn: "C'est fait !",
    completeTitle: 'Effectué par :',
    user: 'Utilisateur',
    dateDone: "Date d'accomplissement",
    done_by: 'Réalisé par {0}, le {1}',
    waiting_validation_guestadom: 'Etape en attente de validation par le support Guestadom',
    error_document_required: "Tout les documents sont requis pour passer à l'étape suivante",
    error_no_mandat: "L'onboarding n'a pas de mandat de gestion",
    error_no_mandat_num: "Le mandat de gestion relié n'a pas de numéro de mandat",
    error_mandat_num_duplicated: 'Ce numéro de mandat de gestion existe déjà',
    success_add_unavailability:
      'Votre indisponibilité à bien été prise en compte, le pôle hôte va traiter votre demande. Vous pourrez voir votre indisponibilité une fois la demande traitée dans votre calendrier',
  },
  onboardingsuivi_action: {
    ETP0_CREATE: "Création de l'onboarding",
    ETP1_WAITING_FOR_SIGN: "En attente de signature de l'hôte",
    ETP2_REGISTER_ENTRY: 'Inscription dans le registre papier',
    ETP3_WAITING_FOR_DOCUMENT: "En attente des documents de l'hôte",
    ETP4_DOCUMENT_TO_VALIDATE: 'Documents à valider',
    ETP5_AUDIT_IN_PROGRESS: 'Audit du logement',
    ETP6_CURRENTLY_CREATING: "Création de l'annonce",
    ETP7_AD_VALIDATED: 'Annonce en attente de validation',
    ETP8_AD_REFUSED: 'Annonce refusée',
    ETP9_PRICE_SETTING: 'Fixation des prix',
    ETP10_HOMEBOOK_CREATION: 'Création du Homebook',
    ETP11_TOURIST_TAX: 'Taxe de séjour',
    ETP12_PUBLICATION: 'Publication',
    ETP13_OPTIMISATION: 'Optimisation',
  },
  tasktype: {
    picture: 'Prise de photo',
    picture_text: 'Prise de photo avec commentaire',
    yesno: 'Oui/Non',
    done: 'Fait/Pas fait',
    done2: 'Contrôle ménage',
    free_text: 'Texte libre',
    date: 'Champ date',
    rating: 'Echelle de 1 à 5',
    simple_option: 'Choix unique',
    multi_option: 'Choix multiple',
  },
  search: {
    results: 'Résultats de la recherche',
    here: 'Rechercher ici',
    search: 'Rechercher',
    filter: 'Filtrer',
  },
  fee: {
    update: 'Modifier',
    period: 'Quinzaine',
    period_start: 'Début de quinzaine',
    period_end: 'Fin de quinzaine',
    reservationNb: 'Nb de réservations',
    empty: 'Aucune commission',
    stayTax: 'Taxe de séjour',
    plateformFee: 'Frais de plateforme',
    amountStay: 'Montant de séjour',
    gain: 'Gain',
    gainGa: 'Gain de Guestadom',
    gainGas: 'Gain de Guestadom Support',
    gainGav: 'Gain de Guestadom Ville',
    gainOwner: "Gain de l'hôte",
    feeStart: 'Frais de lancement',
    feeStartPartner: 'Frais de lancement concierge partenaire',
    feeStartGas: 'Frais de lancement (GAS)',
    feeStartGav: 'Frais de lancement (GAV)',
    feeWelcome: "Frais d'accueil",
    feeWelcome_dest: "Frais d'accueil - Destinataire",
    fee_operationel_owner: 'Frais opérationnel hôte',
    fee_housework_interlocatif: 'Frais de ménage interlocatif total',
    fee_housework_interlocatif_owner: 'Frais de ménage interlocatif hôte',
    fee_housework_interlocatif_voyageur: 'Frais de ménage interlocatif voyageur',
    feeHousework: 'Frais de ménage voyageurs',
    feeHouseworkOwner: 'Frais de ménage départ hôte',
    feeService: 'Frais de service',
    feeCancel: "Frais d'annulation GAS",
    feeHousework_dest: 'Frais de ménage - Destinataire',
    feeHousework_inter_dest: 'Frais de ménage hôte - Destinataire',
    feeLaundry: 'Frais de blanchisserie',
    feeLaundry_dest: 'Frais de blanchisserie - Destinataire',
    fee_assurance: "Frais d'assurance",
    fee_assurance_dest: "Frais d'assurance - Destinataire",

    fee_wintering_open: 'Frais ouverture hivernage',
    fee_wintering_close: 'Frais fermeture hivernage',
    clientToOwner: "A verser à l'hôte",
    clientToGav: 'A verser à GAV (voyageur)',
    clientToGas: 'A verser à GAS (voyageur)',
    ownerToGav: 'A verser à GAV (hôte)',
    ownerToGas: 'A verser à GAS (hôte)',
    startDate: 'Date de début',
    endDate: 'Date de fin',
  },
  mandat: {
    add: 'Créer un mandat de gestion',
    details: 'Mandat de gestion',
    avenant_details: 'Avenant',
    resiliation: 'Résiliation de mandat de gestion',
    fee_owner_cancel: "Frais d'annulation",
    update: 'Modifier un mandat de gestion',
    update_avenant: 'Modifier un avenant',
    update_bank_info: 'Modifier les infos bancaires',
    update_rm: 'Modifier les règles de Revenue Management',
    bank_info_updated: 'Les infos bancaires ont bien été modifiées',
    updated: 'Le mandat de gestion a bien été modifié',
    updated_avenant: "L'avenant a bien été modifié",
    updated_rm: 'Les règles de Revenue Management ont bien été modifiées',
    empty: 'Aucun mandat de gestion',
    avenant_empty: 'Aucun avenant',
    added: 'Mandat de gestion ajouté',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce mandat de gestion?',
    avenant_confirm_delete: 'Attention, vous allez supprimer un avenant, êtes vous sûr de vouloir le supprimer ?',
    documentModel: 'Modèle de document',
    num: 'Numéro de mandat',
    id: 'ID de mandat',
    type: 'Type de mandat',
    type_avenant: "Type de l'avenant",
    duration: 'Durée de mandat',
    renew: 'Tacite reconduction',
    houseworkFeeForOwner: "Frais de ménage pour l'hôte",
    dateStart: 'Début de mandat',
    datePeriodNew: 'Début de la nouvelle période',
    datePeriod: 'Période depuis le',
    dateEnd: 'Fin de mandat',
    dateReception: 'Réception de la lettre',
    dateResiliation: 'Date de résiliation',
    datePreavis: 'Date de début de préavis',
    signDate: 'Date de signature',
    companyName: 'Agence liée au mandat de gestion',
    type_courte_duree: 'Courte durée',
    type_moyenne_duree: 'Moyenne durée',
    type_longue_duree: 'Longue durée',
    type_gestion_en_ligne: 'Gestion en ligne',
    COURTE_DUREE: 'Courte durée',
    MOYENNE_DUREE: 'Moyenne durée',
    LONGUE_DUREE: 'Longue durée',
    GESTION_EN_LIGNE: 'Gestion en ligne',
    duration_year1: '1 an',
    duration_year3: '3 ans',
    duration_year5: '5 ans',
    amountThreshold: 'Minimum de facturation',
    amountThresholdPartner: 'Minimum de facturation concierge partenaire',
    comGa: 'Frais de gestion (%)',
    comGas: 'Frais de gestion Guestadom (%)',
    comGav: 'Frais de gestion GAV (%)',
    comPartner: 'Frais de gestion concierge partenaire (%)',
    file_signed: 'Fichier PDF signé',
    iban: 'IBAN',
    bic: 'BIC',
    rum: 'Numéro RUM',
    offer: 'Formule',
    offer_avenant: "Formule de l'avenant",
    gestionLinge: 'Fourniture du linge de lit',
    gestionLingeBain: 'Fourniture du linge de bain',
    reception_type_physical: 'Gestion des accueils physiques',
    resilation_action: 'Résilier',
    resilation_action2: 'Résilier le mandat de gestion',
    upload_signed: "Dépot d'avenant signé",
    upload_signed_action: 'Déposer',
    upload_signed_action2: "Déposer l'avenant signé",
    upload_signed_commercial: 'Le mandat de gestion signé a bien été déposé. Le support Guestadom prend le relais',
    lettreResiliation: 'Courrier de résiliation',
    resiliationReason: 'Raison de la résiliation',
    feeHouseworkOwnerForfait: 'Frais de ménage départ hôte ',
    cancelFee: "Frais d'annulation",
    new_mandat: 'Nouveau mandat de gestion',
    prixMinimumNuit: 'Prix minimum à la nuit',
    depotGarantie: 'Caution',
    caution: 'Caution',
    dureeSejourMinimum: 'Durée de séjour minimum',
    resiliationPlanningBlocked: 'Blocage complet du calendrier',
    status: 'Statut',
    num_avenant: 'Avenant',
    id_avenant: "ID de l'avenant",
    date_start_avenant: "Début de l'avenant",
    date_end_avenant: "Fin de l'avenant",
    duration_avenant: "Durée de l'avenant",
    add_avenant: 'Créer un avenant',
    avenant_added: 'Avenant ajouté',
    avenant_date_start: "Début d'avenant",
    avenant_date_end: "Fin d'avenant",
    avenant_duration: "Durée d'avenant",
    avenant_sign_title: 'Avenant du {dateStart} au mandat de gestion numéro {parentMandatNum}',
    avenant_dashboard_title: 'Avenant du {dateStart}',
    error_avenant_not_signed: "La signature de l'avenant est en cours de création, veuillez patienter puis réessayer",
    avenant_signed: "L'avenant a bien été signé.",
    mandat_list: 'Mandats de gestion',
    avenant_list: 'Avenants',
    RESILIE: 'Résilié',
    EN_LIGNE: 'En ligne',
    EN_COURS: 'En cours',
    EN_COURS_DE_SIGNATURE: 'En cours de signature',
    EN_COURS_DE_RESILIATION: 'En cours de résiliation',
    housework_person: 'Personne en charge du ménage',
    all_avenants: 'Tous les avenants',
    all: 'Tous les mandats de gestion',
    enabled_only: 'Uniquement les mandats de gestion actifs',
    disabled_only: 'Uniquement les mandats de gestion inactifs',
    enabled: 'Mandats de gestion actifs',
    disabled: 'Mandats de gestion inactifs',
    resiliation_pending: 'Mandats de gestion en cours de résiliation',
    en_cours_de_signature: 'Mandats de gestion en cours de signature',
    en_cours: 'Uniquement les mandats de gestion en cours',
    enabled_avenant: 'Avenants actifs',
    disabled_avenant: 'Avenants inactifs',
    resiliation_pending_avenant: 'Avenants en cours de résiliation',
    en_cours_de_signature_avenant: 'Avenants en cours de signature',
    last_crg_amount: 'Solde du dernier CRG',
    alert_last_crg_amount: 'Le solde du dernier crg est négatif',
    add_resiliation_bloc: 'Ajouter une période de blocage',
    dateStartPeriod: 'Début',
    dateEndPeriod: 'Fin',
    OFFER1: 'Premium',
    OFFER3: 'Essentielle',
    OFFER2: 'Confort',
    directDebit: 'Prélèvement autorisé',
    operating_costs: 'Frais de fonctionnement',
  },
  mandat_data: {
    empty: 'Aucune grille tarifaire antérieure',
    date_start: 'Date',
    warning_no_data_changed: 'Aucune différence dans les données de la grille tarifaire',
  },
  mandat_setting: {
    empty: 'Aucune information de mandat antérieure',
    date_updated: 'Date',
    warning_no_data_changed: 'Aucune différence dans les données des informations du mandat',
    feeCancel: 'Pénalité annulation hôte - forfait',
    feeCancelCom: 'Pénalité annulation hôte - commission',
    feeServiceVgaMinimum: 'Frais de service Guestadom - minimum',
    feeServiceVgaCom: 'Frais de service Guestadom - commission',
    operatingCostsMinNights: 'Frais de fonctionnement (nombre de nuits)',
    operatingCosts: 'Frais de fonctionnement (forfait)',
  },
  extra: {
    empty: 'Aucun extra',
    type: 'Type',
    price: 'Prix',
    tva: 'TVA',
    add: 'Ajouter un extra',
    update: 'Modifier un extra',
    added: 'Extra ajouté',
    updated: 'Extra modifié',
  },
  upsell: {
    list: 'Extras',
    empty: 'Aucun extra',
    type: 'Type',
    name: 'Extras',
    amount: 'Prix',
    ownerName: 'Hôte',
    accommodationName: 'Logement',
    companyName: 'Agence',
    checkinDate: 'Date de check-in',
    checkoutDate: 'Date de check-out',
    approbationDate: 'Traitement',
    buyDate: 'Commande',
    status: 'Statut',
    reservationLocalizer: 'Réservation',
    download: 'Télécharger',
    filter: 'Filtrer',
    refused: 'Refusée',
    to_plan: 'A planifier',
    planned: 'Planifié',
    closed: 'Terminé',
    paid: 'Payé',
    refunded: 'Remboursé',
    denied: 'Refusé',
    requested: 'Demandé',
    list_creation_in_progress: 'Export en cours...',
  },
  period: {
    days: 'Jours',
    weeks: 'Semaines',
    months: 'Mois',
    title: 'Période',
  },
  countries: {
    AF: 'Afghanistan',
    ZA: 'Afrique du Sud',
    AL: 'Albanie',
    DZ: 'Algérie',
    DE: 'Allemagne',
    AD: 'Andorre',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctique',
    AG: 'Antigua-et-Barbuda',
    SA: 'Arabie saoudite',
    AR: 'Argentine',
    AM: 'Arménie',
    AW: 'Aruba',
    AU: 'Australie',
    AT: 'Autriche',
    AZ: 'Azerbaïdjan',
    BS: 'Bahamas',
    BH: 'Bahreïn',
    BD: 'Bangladesh',
    BB: 'Barbade',
    BE: 'Belgique',
    BZ: 'Belize',
    BM: 'Bermudes',
    BT: 'Bhoutan',
    BY: 'Biélorussie',
    BO: 'Bolivie',
    BA: 'Bosnie-Herzégovine',
    BW: 'Botswana',
    BN: 'Brunéi Darussalam',
    BR: 'Brésil',
    BG: 'Bulgarie',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    BJ: 'Bénin',
    KH: 'Cambodge',
    CM: 'Cameroun',
    CA: 'Canada',
    CV: 'Cap-Vert',
    CL: 'Chili',
    CN: 'Chine',
    CY: 'Chypre',
    CO: 'Colombie',
    KM: 'Comores',
    CG: 'Congo-Brazzaville',
    CD: 'Congo-Kinshasa',
    KP: 'Corée du Nord',
    KR: 'Corée du Sud',
    CR: 'Costa Rica',
    HR: 'Croatie',
    CU: 'Cuba',
    CW: 'Curaçao',
    CI: 'Côte d’Ivoire',
    DK: 'Danemark',
    DJ: 'Djibouti',
    DM: 'Dominique',
    ES: 'Espagne',
    EE: 'Estonie',
    SZ: 'Eswatini',
    FJ: 'Fidji',
    FI: 'Finlande',
    FR: 'France',
    GA: 'Gabon',
    GM: 'Gambie',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GD: 'Grenade',
    GL: 'Groenland',
    GR: 'Grèce',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernesey',
    GN: 'Guinée',
    GQ: 'Guinée équatoriale',
    GW: 'Guinée-Bissau',
    GY: 'Guyana',
    GF: 'Guyane française',
    GE: 'Géorgie',
    GS: 'Géorgie du Sud et îles Sandwich du Sud',
    HT: 'Haïti',
    HN: 'Honduras',
    HU: 'Hongrie',
    IN: 'Inde',
    ID: 'Indonésie',
    IQ: 'Irak',
    IR: 'Iran',
    IE: 'Irlande',
    IS: 'Islande',
    IL: 'Israël',
    IT: 'Italie',
    JM: 'Jamaïque',
    JP: 'Japon',
    JE: 'Jersey',
    JO: 'Jordanie',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KG: 'Kirghizistan',
    KI: 'Kiribati',
    KW: 'Koweït',
    RE: 'La Réunion',
    LA: 'Laos',
    LS: 'Lesotho',
    LV: 'Lettonie',
    LB: 'Liban',
    LY: 'Libye',
    LR: 'Libéria',
    LI: 'Liechtenstein',
    LT: 'Lituanie',
    LU: 'Luxembourg',
    MK: 'Macédoine du Nord',
    MG: 'Madagascar',
    MY: 'Malaisie',
    MW: 'Malawi',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malte',
    MA: 'Maroc',
    MQ: 'Martinique',
    MU: 'Maurice',
    MR: 'Mauritanie',
    YT: 'Mayotte',
    MX: 'Mexique',
    MD: 'Moldavie',
    MC: 'Monaco',
    MN: 'Mongolie',
    MS: 'Montserrat',
    ME: 'Monténégro',
    MZ: 'Mozambique',
    MM: 'Myanmar (Birmanie)',
    NA: 'Namibie',
    NR: 'Nauru',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigéria',
    NU: 'Niue',
    NO: 'Norvège',
    NC: 'Nouvelle-Calédonie',
    NZ: 'Nouvelle-Zélande',
    NP: 'Népal',
    OM: 'Oman',
    UG: 'Ouganda',
    UZ: 'Ouzbékistan',
    PK: 'Pakistan',
    PW: 'Palaos',
    PA: 'Panama',
    PG: 'Papouasie-Nouvelle-Guinée',
    PY: 'Paraguay',
    NL: 'Pays-Bas',
    BQ: 'Pays-Bas caribéens',
    PH: 'Philippines',
    PL: 'Pologne',
    PF: 'Polynésie française',
    PR: 'Porto Rico',
    PT: 'Portugal',
    PE: 'Pérou',
    QA: 'Qatar',
    HK: 'R.A.S. chinoise de Hong Kong',
    MO: 'R.A.S. chinoise de Macao',
    RO: 'Roumanie',
    GB: 'Royaume-Uni',
    RU: 'Russie',
    RW: 'Rwanda',
    CF: 'République centrafricaine',
    DO: 'République dominicaine',
    EH: 'Sahara occidental',
    BL: 'Saint-Barthélemy',
    KN: 'Saint-Christophe-et-Niévès',
    SM: 'Saint-Marin',
    MF: 'Saint-Martin',
    SX: 'Saint-Martin (partie néerlandaise)',
    PM: 'Saint-Pierre-et-Miquelon',
    VC: 'Saint-Vincent-et-les-Grenadines',
    SH: 'Sainte-Hélène',
    LC: 'Sainte-Lucie',
    SV: 'Salvador',
    WS: 'Samoa',
    AS: 'Samoa américaines',
    ST: 'Sao Tomé-et-Principe',
    RS: 'Serbie',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapour',
    SK: 'Slovaquie',
    SI: 'Slovénie',
    SO: 'Somalie',
    SD: 'Soudan',
    SS: 'Soudan du Sud',
    LK: 'Sri Lanka',
    CH: 'Suisse',
    SR: 'Suriname',
    SE: 'Suède',
    SJ: 'Svalbard et Jan Mayen',
    SY: 'Syrie',
    SN: 'Sénégal',
    TJ: 'Tadjikistan',
    TZ: 'Tanzanie',
    TW: 'Taïwan',
    TD: 'Tchad',
    CZ: 'Tchéquie',
    TF: 'Terres australes françaises',
    IO: 'Territoire britannique de l’océan Indien',
    PS: 'Territoires palestiniens',
    TH: 'Thaïlande',
    TL: 'Timor oriental',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinité-et-Tobago',
    TN: 'Tunisie',
    TM: 'Turkménistan',
    TR: 'Turquie',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    WF: 'Wallis-et-Futuna',
    YE: 'Yémen',
    ZM: 'Zambie',
    ZW: 'Zimbabwe',
    EG: 'Égypte',
    AE: 'Émirats arabes unis',
    EC: 'Équateur',
    ER: 'Érythrée',
    VA: 'État de la Cité du Vatican',
    FM: 'États fédérés de Micronésie',
    US: 'États-Unis',
    ET: 'Éthiopie',
    BV: 'Île Bouvet',
    CX: 'Île Christmas',
    NF: 'Île Norfolk',
    IM: 'Île de Man',
    KY: 'Îles Caïmans',
    CC: 'Îles Cocos',
    CK: 'Îles Cook',
    FO: 'Îles Féroé',
    HM: 'Îles Heard et McDonald',
    FK: 'Îles Malouines',
    MP: 'Îles Mariannes du Nord',
    MH: 'Îles Marshall',
    PN: 'Îles Pitcairn',
    SB: 'Îles Salomon',
    TC: 'Îles Turques-et-Caïques',
    VG: 'Îles Vierges britanniques',
    VI: 'Îles Vierges des États-Unis',
    UM: 'Îles mineures éloignées des États-Unis',
    AX: 'Îles Åland',
  },
  languages: {
    ab: 'Abkhaze',
    aa: 'Afar',
    af: 'Afrikaans',
    ak: 'Akan',
    sq: 'Albanais',
    de: 'Allemand',
    am: 'Amharique',
    en: 'Anglais',
    ar: 'Arabe',
    an: 'Aragonais',
    hy: 'Arménien',
    as: 'Assamais',
    av: 'Avar',
    ae: 'Avestique',
    ay: 'Aymara',
    az: 'Azéri',
    ba: 'Bachkir',
    bm: 'Bambara',
    eu: 'Basque',
    bn: 'Bengali',
    bi: 'Bichelamar',
    bh: 'Bihari',
    my: 'Birman',
    be: 'Biélorusse',
    bs: 'Bosniaque',
    br: 'Breton',
    bg: 'Bulgare',
    ks: 'Cachemiri',
    ca: 'Catalan',
    ch: 'Chamorro',
    ny: 'Chewa',
    zh: 'Chinois',
    si: 'Cingalais',
    kw: 'Cornique',
    co: 'Corse',
    ko: 'Coréen',
    cr: 'Cree',
    hr: 'Croate',
    ht: 'Créole haïtien',
    da: 'Danois',
    dz: 'Dzongkha',
    es: 'Espagnol',
    eo: 'Espéranto',
    et: 'Estonien',
    fj: 'Fidjien',
    fi: 'Finnois',
    fr: 'Français',
    fy: 'Frison occidental',
    fo: 'Féroïen',
    gl: 'Galicien',
    cy: 'Gallois',
    lg: 'Ganda',
    gd: 'Gaélique écossais',
    gu: 'Goudjerati',
    el: 'Grec',
    kl: 'Groenlandais',
    gn: 'Guarani',
    ka: 'Géorgien',
    ha: 'Haoussa',
    hi: 'Hindi',
    ho: 'Hiri motu',
    hu: 'Hongrois',
    iw: 'Hébreu',
    he: 'Hébreu',
    hz: 'Héréro',
    io: 'Ido',
    ig: 'Igbo',
    id: 'Indonésien',
    in: 'Indonésien',
    ia: 'Interlingua',
    ie: 'Interlingue',
    iu: 'Inuktitut',
    ik: 'Inupiaq',
    ga: 'Irlandais',
    is: 'Islandais',
    it: 'Italien',
    ja: 'Japonais',
    jv: 'Javanais',
    kn: 'Kannada',
    kr: 'Kanouri',
    kk: 'Kazakh',
    km: 'Khmer',
    kg: 'Kikongo',
    ki: 'Kikuyu',
    rw: 'Kinyarwanda',
    ky: 'Kirghize',
    kv: 'Komi',
    kj: 'Kuanyama',
    ku: 'Kurde',
    lo: 'Lao',
    la: 'Latin',
    lv: 'Letton',
    li: 'Limbourgeois',
    ln: 'Lingala',
    lt: 'Lituanien',
    lu: 'Luba-katanga (kiluba)',
    lb: 'Luxembourgeois',
    mk: 'Macédonien',
    ms: 'Malais',
    ml: 'Malayalam',
    dv: 'Maldivien',
    mg: 'Malgache',
    mt: 'Maltais',
    gv: 'Mannois',
    mi: 'Maori',
    mr: 'Marathi',
    mh: 'Marshallais',
    mo: 'Moldave',
    mn: 'Mongol',
    na: 'Nauruan',
    nv: 'Navajo',
    ng: 'Ndonga',
    nd: 'Ndébélé du Nord',
    nr: 'Ndébélé du Sud',
    no: 'Norvégien',
    nb: 'Norvégien bokmål',
    nn: 'Norvégien nynorsk',
    nl: 'Néerlandais',
    ne: 'Népalais',
    oc: 'Occitan',
    or: 'Odia',
    oj: 'Ojibwa',
    om: 'Oromo',
    os: 'Ossète',
    ur: 'Ourdou',
    uz: 'Ouzbek',
    ug: 'Ouïghour',
    ps: 'Pachto',
    pi: 'Pali',
    pa: 'Pendjabi',
    fa: 'Persan',
    ff: 'Peul',
    pl: 'Polonais',
    pt: 'Portugais',
    qu: 'Quechua',
    rm: 'Romanche',
    ro: 'Roumain',
    rn: 'Roundi',
    ru: 'Russe',
    se: 'Same du Nord',
    sm: 'Samoan',
    sg: 'Sango',
    sa: 'Sanskrit',
    sc: 'Sarde',
    sr: 'Serbe',
    sn: 'Shona',
    sd: 'Sindhi',
    cu: 'Slavon d’église',
    sk: 'Slovaque',
    sl: 'Slovène',
    so: 'Somali',
    st: 'Sotho du Sud',
    su: 'Soundanais',
    sv: 'Suédois',
    sw: 'Swahili',
    ss: 'Swati',
    tg: 'Tadjik',
    tl: 'Tagalog',
    ty: 'Tahitien',
    ta: 'Tamoul',
    tt: 'Tatar',
    cv: 'Tchouvache',
    cs: 'Tchèque',
    ce: 'Tchétchène',
    th: 'Thaï',
    bo: 'Tibétain',
    ti: 'Tigrigna',
    to: 'Tongien',
    ts: 'Tsonga',
    tn: 'Tswana',
    tr: 'Turc',
    tk: 'Turkmène',
    tw: 'Twi',
    te: 'Télougou',
    uk: 'Ukrainien',
    ve: 'Venda',
    vi: 'Vietnamien',
    vo: 'Volapük',
    wa: 'Wallon',
    wo: 'Wolof',
    xh: 'Xhosa',
    ii: 'Yi du Sichuan',
    yi: 'Yiddish',
    ji: 'Yiddish',
    yo: 'Yoruba',
    za: 'Zhuang',
    zu: 'Zoulou',
    ee: 'Éwé',
  },
  idProofs: {
    idproof1: "Carte Nationale d'Identité",
    idproof2: 'Carte de séjour',
    idproof3: 'Carte de résident',
    idproof4: 'Récépissé',
    idproof5: 'Permis de conduire',
    idproof6: 'Passeport',
    idproof7: 'Visa',
    idproof8: "Carte de séjour 'vie privée et familiale'",
    idproof9: "Carte de séjour 'salarié'",
    idproof10: "Carte de séjour 'étudiant'",
    idproof11: "Carte de séjour 'travailleur temporaire'",
    idproof12: "Carte de séjour 'travailleur saisonnier'",
    idproof13: "Autorisation provisoire de séjour portant la mention 'autorise son titulaire à travailler'",
    idproof14: 'Certificat de résidence Algérien',
  },
  societe: {
    formeJuridiqueDeLaSociete: 'Forme juridique de la société',
    formeJuridique: 'Forme juridique',
    raisonSocialeDeLaSociete: 'Raison sociale de la société',
    raisonSociale: 'Raison sociale',
    capital: 'Capital',
    adresseDuSiegeSocial: 'Adresse du siège social',
    complementDAdresseSiegeSocial: "Complément d'adresse du siège social",
    cpDuSiegeSocial: 'CP du siège social',
    villeDuSiegeSocial: 'Ville du siège social',
    lieuDuRcs: 'Lieu du rcs',
    numeroDuRcs: 'Numéro du rcs',
    nomDuGerant: 'Nom du gérant',
    prenomDuGerant: 'Prénom du gérant',
    fonctionDuRepresentantDeLaSociete: 'Fonction du représentant de la société',
    fonctionDuRepresentant: 'Fonction du représentant',
    numeroCarteProfessionnelImmobiliere: 'Numéro de la carte professionnelle immobilière',
    dateDeDelivranceCarteProfessionnelImmobiliere: 'Date de délivrance de la carte professionnelle immobilière',
    dateDeValiditeCarteProfessionnelImmobiliere: 'Date de validité de la carte professionnelle immobilière',
    organismeDelivranceCarteProfessionnelImmobiliere: 'Organisme délivrance carte professionnelle immobilière',
    nomCaisseDeGarantie: 'Nom de la caisse de garantie',
    adresseCaisseDeGarantie: 'Adresse de la caisse de garantie',
    complementDAdresseCaisseDeGarantie: "Complément d'adresse caisse de garantie",
    cpCaisseDeGarantie: 'CP de la caisse de garantie',
    villeCaisseDeGarantie: 'Ville de la caisse de garantie',
    montantCaisseDeGarantie: 'Montant de la caisse de garantie',
    zoneGeographiqueCouvertureCaisseDeGarantie: 'Zone géographique couverture de la caisse de garantie',
    nomAssuranceRc: "Nom de l'assurance rc",
    adresseAssuranceRc: "Adresse de l'assurance rc",
    complementDAdresseAssuranceRc: "Complément d'adresse de l'assurance rc",
    cpAssuranceRc: "CP de l'assurance rc",
    villeAssuranceRc: "Ville de l'assurance rc",
    numeroDePoliceAssuranceRc: "Numéro de police de l'assurance rc",
    zoneDeGeographieCouvertureAssuranceRc: "Zone de geographie couverture de l'assurance rc",
    numeroTvaIntracommunautaire: 'Numéro TVA intracommunautaire',
    civiliteResponsableRgpd: 'Civilité du responsable RGPD',
    prenomResponsableRgpd: 'Prénom du responsable RGPD',
    nomResponsableRgpd: 'Nom du responsable RGPD',
    comGas: 'Frais de gestion GAS',
    comGa: 'Frais de gestion',
    amountMaxRenovation: 'Montant maximum de travaux',
    amountMaxEquipPurchase: "Montant maximum d'achat d'équipement",
    feeCancel: 'Pénalité annulation hôte - forfait',
    feeCancelCom: 'Pénalité annulation hôte - commission',
    feeLitigation: 'Frais de dossier litige',
    feeServiceVgaMinimum: 'Frais de service Guestadom - minimum',
    feeServiceVgaCom: 'Frais de service Guestadom - commission',
    feeVrboCom: 'Abritel - Commission',
    feePapCom: 'PAP - Commission',
    feeHoliduCom: 'Holidu - Commision',
    siret: 'SIRET',
    siren: 'SIREN',
    ape: 'Code APE',
    numero_garantie: 'Numéro de garantie',
    numero_compte_sequestre: 'Numéro de compte séquestre',
    nom_banque_compte_sequestre: 'Nom de la banque du compte séquestre',
  },
  stayrate: {
    stayrate: 'Groupe de taxe de séjour',
    label: 'Libellé',
    codes: 'Codes INSEE',
    codesChip: 'Codes INSEE (terminer la saisie par une virgule)',
    account: 'Compte comptable',
    iban: 'IBAN',
    bic: 'BIC',
    empty: 'Aucun groupe de taxe de séjour',
    add: 'Ajouter un groupe de taxe de séjour',
    added: 'Le groupe de taxe de séjour a bien été ajouté',
    update: 'Modifier un groupe de taxe de séjour',
    updated: 'Le groupe de taxe de séjour a bien été modifié',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce groupe de taxe de séjour ?',
    frequency: 'Périodicité de versement',
    frequency_month_6: '6 mois',
    frequency_year_1: '1 an',
    type: 'Type de taxe de séjour',
    regional: 'Additionnelle',
    city: 'Ville',
    avantio_label: 'Libellé Avantio',
  },
  dashboard: {
    accommodation_status: 'Statuts de vos logements',
    avenants_to_sign: 'Avenant au contrat à signer',
    estimation_failed: "Une erreur est survenue lors de l'estimation de votre logement, merci de réessayer",
    logement_tile: 'Logements actifs',
    request: 'Demande en attente',
    maintenance_waiting: 'Maintenance en attente',
    accommodation_reviews: 'Avis de vos logements',
  },
  attribution: {
    business_developer: 'Business developer',
    city_manager: 'City manager',
    account_manager: 'Account manager',
    distribution_manager: 'Distribution manager',
  },
  crg: {
    crg: 'CRG',
    details: 'Détails du CRG',
    consultation: 'Consultation',
    generation: 'Génération',
    closing: 'Clôture en cours',
    regenerating: 'Régénération en cours',
    payment: 'Virement hôte',
    payment_housekeeper: 'Virement concierge',
    prelevement: 'Prélèvement',
    payment_details: 'Détails du virement',
    payment_housekeeper_details: 'Détails du virement concierge',
    prelevement_details: 'Détails du prélèvement',
    historique: 'Historique',
    payment_crg: 'Virement de CRG',
    payment_housekeeper_crg: 'Virement de CRG Concierge',
    prelevement_crg: 'Prélèvement de CRG',
    date: 'Date',
    date_resa_end: 'Date du crg',
    date_required: 'La période est requise',
    date_generated: 'Génération',
    date_closed: 'Date de clôture',
    number: 'Nombre de bénéficiaires',
    mandatNums: 'Numéros des mandats concernés',
    label: 'Libellé',
    success_update_num_virement: 'Numéro de virement renseigné',
    success_update_num_prelevement: 'Numéro de prélèvement renseigné',

    generate_one: 'Générer',
    regenerate_one: 'Regénérer',
    close_one: 'Clôturer',

    generate_many: 'Générer les CRGs',
    regenerate_many: 'Regénérer les CRGs',
    close_many: 'Clôturer les CRGs',

    confirm_generate_one: 'Êtes-vous sûr de vouloir générer un nouveau CRG ?',
    confirm_regenerate_one: 'Êtes-vous sûr de vouloir regénérer ce CRG ?',
    confirm_close_one: 'Êtes-vous sûr de vouloir clôturer ce CRG ?',

    confirm_generate_many: 'Êtes-vous sûr de vouloir générer de nouveaux CRGs ?',
    confirm_regenerate_many: 'Êtes-vous sûr de vouloir regénérer ces CRGs ?',
    confirm_close_many: 'Êtes-vous sûr de vouloir clôturer ces CRGs ?',

    generated_one: 'CRG généré',
    regenerated_one: 'CRG regénéré',
    closed_one: 'CRG clôturé',

    generated_many: 'CRGs générés',
    regenerated_many: 'CRGs regénérés',
    closed_many: 'CRGs clôturés',

    error_missing_iban: "Clôture impossible. L'IBAN est manquant sur le mandat de gestion",
  },
  amountThreshold: {
    add: 'Ajouter un seuil de facturation',
    added: 'Seuil de facturation ajouté',
    update: 'Modifier un seuil de facturation',
    updated: 'Seuil de facturation modifié',
    delete: 'Supprimer un seuil de facturation',
    confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce seuil de facturation ?',
    label: 'Libellé',
    amountGa: 'Seuil minimal de facturation',
    amountGav: 'Montant reversé à GAV',
  },
  litige: {
    list: 'Litiges',
    my_list: 'Mes litiges',
    empty: 'Aucun litige',
    add: 'Ajouter un litige',
    update: 'Modifier un litige',
    delete: 'Supprimer un litige',
    details: 'Détails du litige',
    status: 'Statut',
    date: 'Déclaration',
    comment: 'Commentaire',
    added: 'Votre litige a bien été créé',
    updated: 'Le litige a bien été modifié',
    accommodation: 'Logement',
    reservation: 'Réservation',
    error_empty_files: 'Le champ Fichier est requis',
    error_missing_fields: 'Le lien ou la facture sont requis',
    error_missing_amount: 'Le montant estimé TTC est requis',
    date_decision: 'Décision',
    resolution: 'Résolution',
    reason: 'Raison',
    description: 'Description',
    amount_estimated_ttc: 'Estimé TTC',
    total_amount_estimated_ttc: 'Total estimé TTC',
    amount_ttc: 'Réellement encaissé TTC',
    amount_gas: 'Part pour GAS',
    amount_gav: 'Part pour GAV',
    amount_owner: "Part pour l'hôte",
    link: 'Lien',
    process_litige: 'Traiter le litige',
    processed: 'Le litige a bien été traité',
    file: 'Facture',
    resolve_title: 'Résoudre le litige',
    resolve: 'Résoudre',
    resolved: 'Le litige a bien été résolu',
    gagne: 'Gagné',
    perdu: 'Perdu',
    a_traiter: 'À traiter',
    en_cours: 'En cours',
    resolu: 'Résolu',
    process: 'Traiter',
    complete: 'Dossier complet',
    completed: 'Le dossier a été correctement complété',
    validate: 'Valider',
    validate_confirm_title: 'Validation du dossier litige',
    validate_confirm_message: 'Êtes-vous sûr de vouloir valider le dossier litige ?',
    validated: 'Dossier validé',
    refuse: 'Incomplet',
    refuse_title: 'Marquer le dossier litige comme incomplet',
    refused: 'Dossier incomplet',
    complete_date: 'Revue du dossier',
    complete_validated: 'Le dossier a été validé',
    complete_refused: 'Le dossier a été marqué comme incomplet',
    refused_comment: 'Commentaire de refus',
    step_validated: 'Etape validée',
    waiting_gav_completion: 'Dossier en attente de complétion par la ville',
    waiting_gas_validation: 'Dossier en attente de validation par le support Guestadom',
    error_total_amount: 'La somme des montants saisis ne correspond pas au montant total encaissé',
  },
  interlocutor: {
    interlocutor: 'Interlocuteur',
    interlocutorType: "Type d'interlocuteur",
    proprietaire: 'Hôte',
    prospect: 'Prospect|Prospect|Prospects',
    salarie: 'Salarié',
    candidat: 'Candidat',
    voyageur: 'Voyageur',
    prestataire: 'Prestataire',
    partenaire: 'Conciergerie partenaire',
    housekeeper: 'Concierge partenaire',
    commercial: 'Agent commercial',
    accommodation: 'Logement',
    reservation: 'Réservation',
  },
  planning_accommodation: {
    title: 'Planning des tâches',
    last_week: 'Semaine dernière',
    next_week: 'Semaine prochaine',
    search: 'Rechercher un logement',
    filter: 'Filtrer',
    assigned_staff: 'Personne affectée',
    status: 'Statut',
    company: 'Agence',
    mission_type: 'Type de mission',
    accommodation_name: 'Nom du logement',
  },
  planning_intervenant: {
    title: 'Planning des intervenants',
    title_one: "Planning de l'intervenant",
    title_of: 'Planning de',
    last_week: 'Semaine dernière',
    next_week: 'Semaine prochaine',
    current_week: 'Semaine actuelle',
    search: 'Rechercher un intervenant',
    filter: 'Filtrer',
    assigned_staff: "Type d'intervenants",
    status: 'Statut',
    company: 'Agence',
    mission_type: 'Type de mission',
    participant: 'Intervenant',
    reservation: 'Numéro de réservation',
    accommodation: 'Logement',
    planned_start_date: 'Date de début prévue',
    duration: 'Durée prévue',
    duration_minutes: 'Durée prévue (en minutes)',
    nb_participants_needed: 'Nombre de personnes requises',
    schedule: 'Planifier',
    schedule_mission: 'Planifier une mission',
    start_date: 'Date de début de la mission',
    end_date: 'Date de fin de la mission',
    start_hour: 'Heure de début',
    end_hour: 'Heure de fin',
    participant_name: "Nom de l'intervenant",
    comment: "Commentaire pour l'intervenant",
    success: 'La mission a bien été affectée aux intervenants',
    success_one: "La mission a bien été affectée à l'intervenant",
    hour_end_error: "L'heure de fin ne peut pas être inférieure à celle de début",
    duration_error: "La durée ne peut pas être inférieure à celle prévue par l'ordre de mission",
  },
  mission_monitoring: {
    title: 'Suivi de missions',
    time_start_low_margin: 'Heure de début (marge basse)',
    time_start_high_margin: 'Heure de début (marge haute)',
    time_end_low_margin: 'Heure de fin (marge basse)',
    time_end_high_margin: 'Heure de fin (marge haute)',
    filter: 'Filtrer',
    todo: 'Nouveau',
    doing: 'En cours',
    done: 'Terminé',
    finish: 'Terminée',
    canceled: 'Annulée',
    status: 'Statut',
    empty: 'Aucune mission',
    prestation_date: 'Prestation',
    prestation_period: 'Période de la prestation',
    prestation_type: 'Type de mission',
    accommodation_name: 'Logement',
    reservation_num: 'Réservation',
    date_checkin: 'Check-in',
    date_checkout: 'Check-out',
    finish_mission: 'Terminer la mission',
    confirm_finish: 'Êtes-vous sûr de vouloir marquer cette mission comme "Terminée" ?',
    cancel_mission: 'Annulation de la mission',
    cancel_comment: "Raison de l'annulation",
    success_complete: 'La mission a bien été marquée comme "Terminée"',
    success_cancel: 'La mission a bien été marquée comme "Annulée"',
  },
  undetermined_date: 'Date indéterminée',
  menu: {
    my_reservations: 'Mes réservations',
    my_planning: 'Mon planning',
  },
  plurals: {
    accommodation: 'logement | 1 logement | {count} logements',
  },
  messaging: 'Messagerie voyageur',
  revenueManagement: 'Revenue Management',
  review: {
    title: 'Avis',
    my_list: 'Mes avis',
    filter: 'Filtrer',
    export: 'Exporter',
    list_creation_in_progress: 'Export en cours...',
    empty: 'Aucun avis',
    reservation_num: 'Réservation',
    rating: 'Note',
    rating_ten: 'Note',
    review_title: 'Titre',
    reservation_site: 'Plateforme',
    company_name: 'Agence',
    accommodation_name: 'Logement',
    owner_name: 'Hôte',
    submitted_at: 'Dépôt',
    name: 'Voyageur',
    companies: 'Agences',
    reservation_sites: 'Plateformes',
    accommodations: 'Logements',
    details: "Détails de l'avis",
    data: "Données de l'avis",
    comment: 'Commentaire',
    public_comment: 'Commentaire public',
    private_comment: 'Commentaire privé',
    criterias: 'Critères',
    criteria: {
      cleanliness: 'Propreté',
      checkin: 'Arrivée',
      communication: 'Communication',
      location: 'Emplacement',
      facilities: 'Équipements',
      comfort: 'Confort',
      staff: 'Personnel',
      value: 'Qualité-prix',
      accuracy: 'Précision',
      property_condition: 'État de la propriété',
      eco_friendliness: "Respect de l'environnement",
    },
    fetching: 'Récupération en cours...',
  },
  threads: {
    title: 'Messagerie',
    unarchived: 'Conversation désarchivée',
    unarchive_error: 'Impossible de désarchiver la conversation',
    stay_status: {
      arrival_today: "Arrivée aujourd'hui",
      departure_today: "Départ aujourd'hui",
      ongoing: 'En cours',
      upcoming: 'À venir',
      finished: 'Terminé',
    },
    menu: {
      archive: 'Archiver',
      unarchive: 'Désarchiver',
      assign: 'Assigner',
      assign_search_placeholder: 'Rechercher un employé',
      unassign: "Retirer l'assignation",
      favorite: 'Mettre en favoris',
      unfavorite: 'Retirer des favoris',
      template: 'Modèle',
      template_search_placeholder: 'Rechercher un modèle',
    },
    reactions: {
      title: 'Réactions',
      add: 'Réagir',
      remove: 'Supprimer',
      close: 'Fermer',
      set_error: "Impossible d'ajouter la réaction.",
      remove_error: 'Impossible de supprimer la réaction.',
    },
  },
  help: {
    address_unknown:
      'Si votre adresse n\'apparait pas dans une liste déroulante, cliquez sur "adresse inconnue" et tapez votre adresse postale exacte dans chaque champs.',
    owner_type:
      'Personne physique :\n' +
      '- Une personne physique est un être humain, agissant en son nom propre, en soit chaque individu est une personne physique.\n' +
      'Personne morale :\n' +
      "- Une personne morale est une entité juridique (une entreprise, une association, etc.). C'est un groupement de personnes ou de biens qui est considéré comme un sujet de droit à part entière.\n" +
      'Indivision :\n' +
      "- L'indivision est une situation juridique où plusieurs personnes possèdent des droits identiques sur un même bien. Cela signifie qu'aucune de ces personnes ne peut disposer seule de ce bien, car elles en sont toutes copropriétaires.\n",
    address: "Ici, il s'agit de votre adresse principale de résidence (votre résidence principale).",
    modify_location:
      'Vous pouvez déplacer le curseur sur la carte afin que la localisation soit au plus proche de votre logement.',
    habitat_type:
      'Maison en copropriété : Une maison en copropriété est une forme particulière de propriété immobilière où plusieurs maisons individuelles sont construites sur un même terrain. Bien que chaque maison appartienne à un propriétaire distinct, elles sont soumises à un régime juridique commun : celui de la copropriété.',
    regime_juridique:
      "- Un immeuble soumis au régime de la copropriété est un bâtiment ou un ensemble de bâtiments dont la propriété est divisée en plusieurs lots. Chaque lot appartient à un propriétaire distinct, appelé copropriétaire. Ce régime juridique, instauré par la loi du 10 juillet 1965, encadre les relations entre les différents copropriétaires et régit l'utilisation des parties communes.\n" +
      '\n' +
      "- Une maison soumise au régime de la copropriété est une maison individuelle qui fait partie d'un ensemble immobilier plus grand, où plusieurs propriétaires possèdent chacun une partie du bien.\n" +
      '\n' +
      '- Un bien non soumis au régime de la copropriété est un bien immobilier dont la propriété appartient entièrement à une seule personne ou à un groupe de personnes qui en sont indivisaires.',
    disponibilite:
      'Le logement doit être disponible à la location minimum 60 nuits par an. Sinon, Guestadom facture un forfait annuel de 199 € TTC pour couvrir les frais de fonctionnement.\n' +
      'Attention, une résidence principale ne doit pas être louée plus de 120 nuits par an.',
    typologie:
      '"T" signifie "type" et le chiffre qui le suit indique le nombre de pièces à vivre, c\'est-à-dire les pièces principales (salon, chambres) et non les pièces d\'eau (cuisine, salle de bain, WC). Par exemple, un T2 possède une chambre en plus du salon.',
    surface:
      "La surface d'un logement est une mesure de l'espace habitable à l'intérieur d'un bien immobilier. Ici indiquez la surface habitable en m², c'est-à-dire que seule la surface dont la hauteur sous plafond est supérieure ou égale à 1,80 mètre est prise en compte.",
    capacity:
      "La capacité d'accueil désigne le nombre maximal de personnes que vous souhaitez accueillir simultanément durant un séjour, tout en respectant des normes de sécurité et de confort.",
    assurance:
      "Ici, fournir votre contrat d'assurance habitation de l'année en cours. Ce contrat a pour but de garantir une indemnisation financière en cas de dommages matériels ou immatériels subis dans votre logement et ses occupants. Ce document est à mettre à jour et nous le fournir chaque année.",
    declaration_mairie:
      'La déclaration de mise en location est une formalité administrative obligatoire que vous devez effectuer auprès de votre mairie, afin de déclarer la mise en location de votre logement.',
    acte_propriete:
      "Si vous êtes propriétaire, un acte de propriété est un document officiel et authentique qui atteste de manière irréfutable que vous êtes le propriétaire du bien immobilier. Il s'agit d'un acte notarié, ce qui signifie qu'il a été rédigé et signé par un notaire, un officier public habilité à constater et à authentifier des actes juridiques.",
    kbis: "Si vous représentez une personne morale, fournir votre Kbis, document officiel qui atteste de l'existence légale et juridique de votre entreprise commerciale ou société en France. C'est en quelque sorte la \"carte d'identité\" de votre entreprise.",
    checkin_step:
      "Il est important d'être le plus précis possible pour expliquer les instructions d'arrivée dans votre logement. Détaillez l'accès au logement, les portes à franchir, l'étage du logement etc. Cela servira pour la réalisation du livret d'accueil fournit à vos futurs voyageurs !",
    num_enregistrement:
      "Il s'agit d'une déclaration auprès de votre mairie afin de louer votre logement en location de courte durée. Le numéro d'enregistrement doit figurer sur votre annonce en ligne. Il est obligatoire selon les villes, se renseigner auprès de votre mairie.",
    buanderie:
      "Une buanderie est une pièce indépendante, spécifiquement dédiée pour effectuer les tâches liées au lavage du linge, disposant au minimum d'un lave-linge.",
    surface_jardin: 'Ici, indiquez la surface en m² de votre jardin',
    jardin_fonctionnement:
      'Détaillez les consignes et le fonctionnement des équipements de votre jardin (ex : fonctionnement du barbecue)',
    exterieur_comment:
      "Indiquez les consignes et autres indications que vous souhaitez transmettre à vos voyageurs (ex : rentrer le mobilier l'hiver ou lorsqu'il pleut). Vous pouvez indiquer toutes les spécificités que vous n'avez pas pu saisir au-dessus.",
    consigne_menage:
      'Les consignes de ménage sont les instructions spécifiques qui définissent les actions à accomplir lors du ménage de votre logement. (ex : faire attention à la lampe jaune dans le salon)',
    consigne_accueil:
      "Les consignes d'accueil sont l'ensemble des informations et des instructions que vous souhaitez donner à vos voyageurs dès leur arrivée Ces consignes peuvent être : la sécurité, en les informant des règles de sécurité, des numéros d'urgence, des procédures en cas d'incident, etc, le confort du voyageur, en lui indiquant les services disponibles (petit-déjeuner, etc.), en lui donnant des informations pratiques sur les lieux (accès aux transports en commun, commerces de proximité, etc.) ou encore le respect des règles de vie en communauté, en rappelant les horaires de silence, les règles de tri sélectif, etc.",
    consigne_hote:
      'Les consignes pour votre retour chez vous. Décrivez les instructions qui visent à maintenir votre logement propre et ce que vous souhaitez (ex: faire les lits) surtout après une période de location.',
    piece_interdite:
      "Ici, indiquez si une ou plusieurs pièces ne seront pas accessibles à vos voyageurs. PS : Pensez à mettre un écriteau sur la porte de la pièce en question pour prévenir vos voyageurs qu'il s'agit d'un espace privé et fermé.",
    equipement_interdit: 'Ici, indiquez si un ou plusieurs équipements ne seront pas accessibles à vos voyageurs.',
    contact:
      "Complétez vos contacts utiles (ex : votre plombier, électricien). Cela nous permettra de savoir qui appeler en cas d'incident.",
    publish:
      'Vous êtes presque à la fin ! Votre onboarding ne peut être envoyé que si tous vos documents obligatoires sont déposés et que tous les champs obligatoires sont complétés (champs indiqués par un *)',
  },
  help_amount: {
    montant_total:
      'Montant total payé par le voyageur sur la plateforme partenaire, incluant les frais de ménage ainsi que la taxe de séjour.',
    commission:
      "Commission prélevée par la plateforme partenaire. Chez Guestadom, afin de rendre cette commission transparente pour vous, nous appliquons une augmentation de tarif sur le prix de la nuit afin de prendre en charge cette commission.\n\nExemple : Quand nous voulons louer votre logement à 100 € la nuit, nous allons le mettre en location à 118 € sur Airbnb. C'est ce qu'on appelle un markup.",
    tds: 'Cette taxe, payée par les voyageurs, est collectée par Guestadom et reversée à votre collectivité.',
    cleaning:
      "Ce montant forfaitaire, payé par les voyageurs, vous est reversé, selon votre mandat de gestion, afin de vous permettre d'entretenir votre logement après chaque réservation.",
    caution: 'Cela vous indique si une caution a été collectée auprès des voyageurs.',
    night_price:
      "Il s'agit du montant total payé par les voyageurs hors frais de ménage et taxe de séjour. Cela correspond exclusivement au loyer payé par les voyageurs.",
    night_price_brut:
      "Il s'agit du montant total payé par les voyageurs hors commission de la plateforme, frais de ménage et taxe de séjour. Cela correspond au montant de référence sur lequel les frais de gestion sont calculés.",
    price_by_night: 'Montant des nuits divisé par le nombre de nuits louées.',
    price_by_night_brut: 'Montant des nuits (brut) divisé par le nombre de nuits louées',
    owner:
      "Il s'agit du montant qui vous est versé au titre de la location. C'est à dire, le montant total payé par les voyageurs, déduction faite de la taxe de séjour, la commission plateforme, les frais de gestion de la plateforme Guestadom, ainsi que les frais de gestion et les frais d’intendance de votre concierge selon votre formule.",
    price_by_night_hote:
      "Il s'agit du montant qui vous est versé au titre de la location par nuit hors frais d’intendance. C'est à dire, le montant total payé par les voyageurs, déduction faite de la taxe de séjour, la commission plateforme, les frais de ménage ainsi que les frais de gestion de la plateforme Guestadom et les frais de gestion de votre concierge selon votre formule.",
    guestadom:
      'Ces frais de gestion sont les frais que nous vous facturons pour gérer cette réservation et délivrer le meilleur service possible à vous et vos voyageurs.',
    gestion_partenaire:
      'Ces frais de gestion sont les frais que votre concierge vous facture pour gérer cette réservation et délivrer le meilleur service possible à vous et vos voyageurs.',
    intendance_partenaire:
      "Ces frais d'intendance sont les frais que votre concierge vous facture pour gérer l'intendance de votre logement. (ménage entre deux séjours, gestion du linge et des consommables, accueil...)",
  },
  anomaly: 'Anomalie',
  housekeeper_invoice: {
    total_comm: 'Total frais de gestion',
    total_ope: 'Total forfait opérationnel',
    total_ope_selected: 'Total forfait opérationnel sélectionné',
    total_intendance: 'Total Intendance',
    type: {
      commission_concierge: 'Frais de gestion concierge',
      forfait_operationnel: 'Forfait opérationnel',
    },
    operationnel: 'Opérationnel',
    intendance: 'Intendance',
  },
  select_accommodation: 'Veuillez sélectionner un logement',
  accommodation_details: {
    Address: 'Adresse',
    Profil: 'Profil',
    Typology: 'Typologie et superficie',
    Features: 'Caractéristiques',
    Parking: 'Stationnement',
    Availability: 'Disponibilité et objectif',
    Connection: 'Connexion et certification',
    Checkin: 'Check-in',
    Accessibilite: 'Accessibilité',
    Checkout: 'Check-out',
    Interior_Composition: "Composition de l'intérieur",
    Exterior_Composition: "Composition de l'extérieur",
    Intendance: 'Intendance',
    Equipments: 'Équipements',
    Services: 'Services et activités',
    Electrical_Installation: 'Installation électrique',
    Water_Installation: 'Installation hydraulique',
    Thermal_Installation: 'Installation thermique',
    Trash: 'Poubelles',
    House_Rules: 'Règlement intérieur',
    Restrictions: 'Restrictions',
    Contacts: 'Vos contacts utiles',
    Advert: 'Annonces',
    Price_Rules: 'Conditions et tarifs',
    Photos: 'Photos',
    colored_text: {
      Address: 'Adresse',
      Profil: 'Profil',
      Typology_Area: 'Typologie et superficie',
      Typology: 'Typologie et superficie',
      Features: 'Caractéristiques',
      Parking: 'Stationnement',
      Availability: 'Disponibilité et objectif',
      Connection: 'Connexion et certification',
      Checkin: 'Check-in',
      Checkout: 'Check-out',
      Interior_Composition: "Composition de l'intérieur",
      Exterior_Composition: "Composition de l'extérieur",
      Intendance: 'Intendance',
      Equipments: 'Équipements',
      Services: 'Services et activités',
      Electrical_Installation: 'Installation électrique',
      Water_Installation: 'Installation hydraulique',
      Thermal_Installation: 'Installation thermique',
      Trash: 'Poubelles',
      House_Rules: 'Règlement intérieur',
      Restrictions: 'Restrictions',
      Contacts: 'Vos contacts utiles',
      Annonces: 'Mes annonces',
      Pictures: 'Mes photos',
      Synchronisation: 'Synchronisation OTA',
      Reservations: 'Mes réservations',
      Reviews: 'Mes avis',
      Maintenances: 'Mes maintenances',
      OwnerCharge: 'Mes factures',
      Cdc: 'Mes cahiers des charges',
      Files: 'Mes pièces jointes',
      ThirdAccount: 'Mon compte de tiers',
      Mandats: 'Mon mandat de gestion',
      Avenants: 'Mes avenants',
      TDS: 'Les taxes de séjour',
      Tickets: 'Mes tickets',
      Activity: 'Mes activités',
      ContactInterne: 'Gestionnaire',
      ContactExterne: 'Contacts divers',
      PriceRules: 'Mes conditions et tarifs',
      Calendar: 'Mon calendrier tarifaire',
    },
  },

  onboarding_v3: {
    Step_1_1_1: 'Adresse du logement à louer',
    Step_1_1_2: 'Profil du logement',
    Step_1_1_3: 'Typologie et superficie du logement',
    Step_1_1_3_1: 'Typologie du logement',
    Step_1_1_3_2: 'Superficie du logement',
    Step_1_1_4: 'Caractéristiques du logement',
    Step_1_1_5: 'Disponibilité et objectif du logement',
    Step_1_1_6: 'Stationnement',
    Step_1_1_7: 'Connexion et certification du logement',
    Step_1_1_8: "Composition de l'intérieur du logement",
    Step_1_1_9: "Composition de l'extérieur du logement",
    Step_1_1_10: 'Équipements du logement',
    Step_1_1_11: 'Services et activités du logement',
    Step_1_1_15: 'Maintenance',
    Step_1_1_15_1: 'Installation électrique du logement',
    Step_1_1_15_2: 'Installation hydraulique du logement',
    Step_1_1_15_3: 'Installation thermique du logement',
    Step_1_1_15_4: 'Poubelles du logement',
    Step_1_1_16: 'Règlement',
    Step_1_1_16_1: 'Règlement intérieur du logement',
    Step_1_1_16_3: 'Restrictions du logement',
    Step_1_1_17: 'Contacts utiles du logement',
    Step_1_1: 'Votre logement',
    Step_1_1_Sequence: 'Votre logement',
    Step_1_2: 'Votre formule',
    Step_1_2_Sequence: 'Votre formule',
    Step_1_2_1: 'Choisissez votre formule',
    Step_1_2_2: 'Récapitulatif de votre choix',
    Step_1_3: 'Vos réglages',
    Step_1_3_Sequence: 'Vos réglages',
    Step_1_3_1: "L'intendance du logement",
    Step_1_3_2: 'Check-in du logement',
    Step_1_3_2_1: 'Check-in du logement',
    Step_1_3_2_2: 'Accessibilité du logement',
    Step_1_3_3: 'Check-out du logement',
    Step_1_3_4: "L'annonce du logement",
    Step_1_3_5: 'Les photos du logement',
    Step_1_3_6: 'Stratégie de location',
    Step_1_3_6_1: 'La stratégie de location',
    Step_1_3_6_2: 'La stratégie de location',
    Step_1_3_6_3: 'Règle : Le prix',
    Step_1_3_6_4: 'Règle : La durée du séjour',
    Step_1_3_6_5: "Règle : Jours d'arrivée et de départ",
    Step_1_3_6_6: 'Règle : Augmentation ou promotion ',
    Step_1_3_6_9: 'Règle : Séjour de courte durée ',
    Step_1_3_6_7: 'Règle : Majoration par personnes supplémentaires',
    Step_1_3_6_8: 'Règle : Augmentation ou promotion pour les réservations de dernière minute',
    Step_1_3_6_10: 'Règle : Augmentation ou promotion pour les réservations anticipée',
    Step_1_3_7: "Politique d'annulation voyageur",
    Step_1_3_8: 'Votre calendrier',
    Step_1_3_9: 'La multi diffusion',
    Step_1_4: 'Vos informations personnelles',
    Step_1_4_Sequence: 'Vos informations personnelles',
    Step_1_4_1: 'Votre statut',
    Step_1_4_2: 'Votre statut',
    Step_1_4_3: 'Vos informations personnelles',
    Step_1_4_3_1: 'Vos informations personnelles',
    Step_1_4_4: 'Vos informations de contact',
    Step_1_4_5: 'Votre adresse personnelle',
    Step_1_4_6: 'Votre source de connaissance',
    Step_1_4_7: 'Vos informations bancaires',
    Step_1_4_8: 'Vos documents obligatoires',
    Step_1_5: 'Votre mandat de gestion',
    Step_1_5_Sequence: 'Votre mandat de gestion',
    Step_1_5_1: 'Signature et publication',
    Step_1_6_Sequence: 'Publication',
    Step_1_6: 'Publication',
    Step_1_6_1: "L'annonce du logement",
    Step_1_6_2: 'Les photos du logement',
    Step_1_6_3: 'Les informations du mandat',
    Step_1_6_4: 'Publication du logement',
    Step1_completed:
      'Il vous reste __5 étapes__ avant de publier votre logement et recevoir __vos premières réservations.__',
    Step2_completed:
      'Il vous reste __4 étapes__ avant de publier votre logement et recevoir __vos premières réservations.__',
    Step3_completed:
      'Il vous reste __3 étapes__ avant de publier votre logement et recevoir __vos premières réservations.__',
    Step4_completed:
      'Il vous reste __2 étapes__ avant de publier votre logement et recevoir __vos premières réservations.__',
    Step5_completed:
      'Il vous reste __1 étape__ avant de publier votre logement et recevoir __vos premières réservations.__',
  },
  onboarding_v4: {
    download_mandat: 'Télécharger',
    back_home: "Retour à l'accueil",
    resume_title: '__Générez__ vos premiers __revenus locatifs__ rapidement',
    resume_subtitle: 'Complétez notre formulaire en __5 étapes__ pour :',
    resume_1_1_launched_title: '__Vous y êtes__ presque {0} !',
    step1_final: '__Bravo__ {0} !',
    step1_final_10min: 'Plus que __10 minutes__ pour publier votre logement.',
    resume_1_1_launched_subtitle:
      '__Finalisez la création__ de votre logement en quelques minutes et __générez +20%__ de revenus locatifs.',
    resume_1_2_pending_title: '__Quelle formule__ Guestadom est faite pour vous ?',
    resume_1_2_pending_subtitle:
      'Répondez à __2 questions rapides__ pour découvrir la formule parfaite pour votre logement.',
    resume_1_2_launched_title: "Vous êtes à __moins d'une minute__ de découvrir votre formule",
    resume_1_2_launched_subtitle:
      '__Plus que quelques questions__ pour trouver la formule qui va booster vos revenus locatifs et simplifier votre gestion.',
    resume_1_3_pending_title: 'Définissez __vos préférences__ pour une location à __votre rythme__',
    resume_1_3_pending_subtitle: 'Fixez vos propres conditions pour votre logement',
    resume_1_3_launched_title: 'Plus que __quelques réglages__ pour commencer à louer en toute sérénité',
    resume_1_3_launched_subtitle: 'Reprenez votre configuration et définissez vos conditions de location.',
    resume_1_4_pending_title: '__Bravo__ ! Vos règles sont maintenant configurées',
    resume_1_4_pending_subtitle:
      'Avant de signer votre mandat et publier votre annonce : complétez vos informations personnelles pour encaisser vos paiements en toute sécurité.',
    resume_1_4_launched_title: 'Complétez vos informations pour recevoir vos __premiers paiements__',
    resume_1_4_launched_subtitle:
      'Finalisez cette étape pour pouvoir encaisser vos revenus locatifs en toute sécurité.',
    resume_1_5_pending_title: "Signez votre __contrat__, on s'occupe du reste",
    resume_1_5_pending_subtitle:
      "Vous n'êtes plus qu'à une signature de finaliser votre inscription. Une fois votre contrat signé, votre chargé de compte optimise votre annonce et la publie sur les plateformes de réservation.",
    resume_1_5_launched_title: "Signez votre __contrat__, on s'occupe du reste",
    resume_1_5_launched_subtitle:
      "Vous n'êtes plus qu'à une signature de finaliser votre inscription. Une fois votre contrat signé, votre chargé de compte optimise votre annonce et la publie sur les plateformes de réservation.",
    resume: {
      Step_1_1_1: 'Adresse du logement',
      Step_1_1_2: 'Profil du logement',
      Step_1_1_3: 'Typologie et superficie du logement',
      Step_1_1_3_1: 'Typologie du logement',
      Step_1_1_3_2: 'Superficie du logement',
      Step_1_1_4: 'Caractéristiques du logement',
      Step_1_1_5: 'Disponibilité et objectif du logement',
      Step_1_1_6: 'Stationnement',
      Step_1_1_7: 'Connexion et certification du logement',
      Step_1_1_8: "Composition de l'intérieur du logement",
      Step_1_1_9: "Composition de l'extérieur du logement",
      Step_1_1_10: 'Équipements du logement',
      Step_1_1_11: 'Services et activités du logement',
      Step_1_1_15: 'Maintenance',
      Step_1_1_15_1: 'Installation électrique du logement',
      Step_1_1_15_2: 'Installation hydraulique du logement',
      Step_1_1_15_3: 'Installation thermique du logement',
      Step_1_1_15_4: 'Poubelles du logement',
      Step_1_1_16: 'Règlement',
      Step_1_1_16_1: 'Règlement intérieur du logement',
      Step_1_1_16_3: 'Restrictions du logement',
      Step_1_1_17: 'Contacts utiles du logement',
    },
  },
  informations: {
    intendance:
      "<ul class='list-inside list-disc'>" +
      '<li>Gestion des ménages entre chaque location</li>' +
      '<li>Entretien du linge et mise à disposition des consommables</li>' +
      '<li>Gestion des accueils et des départs</li>' +
      '<li>Gestion de la petite maintenance</li></ul>',
    residence_type:
      "La location courte durée peut être réglementée localement. Conseil : vérifiez auprès de votre mairie le changement d'usage et la déclaration requise.",
    accommodation_type2:
      'La typologie de votre logement dépend du nombre de pièces principales que vous avez (salon, salle à manger et chambres). La cuisine, salle de bain et WC ne comptent pas. Exemple : T2 = 1 chambre + 1 salon.',
    area: 'Comptez seulement les zones avec au moins 1,80 m de hauteur sous plafond.',
    capacity:
      "La capacité d’accueil est le nombre maximum de personnes que votre logement peut héberger. Vous devez prévoir assez de couchages et d'équipements (lits, chaises, vaisselle) pour tous. ",
    pmr: 'Logement aménagé pour personnes en fauteuil roulant ou à mobilité réduite (rampes, escaliers faciles, etc.)',
    certifications: 'Un label ou certificat prouvant que votre logement respecte certains critères de qualité.',
    registrationNumber:
      "Ce numéro vous sera envoyé après votre déclaration en mairie. Vous ne l'avez pas encore ? Pas de problème, vous pouvez continuer et le renseigner plus tard.",
    identite_contact: "Locataire ? Obtenez l'accord écrit de votre propriétaire avant de sous-louer.",
    owner_type:
      '•\tPersonne physique : Vous, en tant que particulier.<br/>' +
      '•\tPersonne morale : Entreprise, association, EIRL, etc.<br/>' +
      '•\tIndivision : Bien détenu par plusieurs co-propriétaires<br/>' +
      '⚠️Dans le cas d’une indivision, tous les propriétaires doivent signer le mandat.',
    forbiddenRoom:
      "Déterminez quelles pièces ou espaces vous souhaitez rendre inaccessibles aux voyageurs. Il peut s'agir de chambres personnelles, de bureaux, de placards contenant des objets précieux, ou de toute autre zone où vous stockez des affaires sensibles. Dressez une liste claire de ces pièces et réfléchissez aux mesures nécessaires pour les sécuriser.",
    disponibilite:
      'Si votre logement est disponible moins de 60 nuits par an, un forfait annuel de 199 € TTC sera appliqué pour couvrir les frais liés au maintien de votre visibilité sur les plateformes.',
    annualProfitTarget:
      'Revenus nets annuels souhaités après déduction des frais de plateforme et de gestion Guestadom.',
    cerfa:
      'Déclarez votre logement en location auprès de votre mairie (obligatoire). Vous pouvez le faire en ligne ou contacter votre mairie directement.',
    cni: 'Documents acceptés : Passeport, CNI, Permis. Assurez-vous qu’ils soient bien lisibles et à jour.',
    cniVerso: "Prenez une photo claire du verso de votre document d'identité",
    justifPropri:
      'Afin de garantir que le logement est bien la propriété de la personne qui le met en location, nous demandons un accord de propriété.<br/><br/>' +
      'Cela peut être :<br/>' +
      ' • Accord de copropriété<br/>' +
      ' • Règlement de copropriété<br/><br/>' +
      'Pourquoi ? Pour sécuriser notre plateforme, éviter les fraudes et nous assurer que seuls les véritables propriétaires (ou leurs mandataires) peuvent mettre un logement en ligne.',
    accordLocation:
      'Il s’agit d’une <span class="font-semibold text-sm">lettre ou d’un e-mail formel</span>, signé par votre propriétaire, vous <span class="font-semibold text-sm">autorisant à sous-louer votre logement</span> en location de courte durée via la plateforme Guestadom.',
    fee_housework:
      'Frais facturés aux voyageurs en plus du prix de la nuitée qui vous sont 100% reversés. Ils couvrent le ménage et la gestion du linge après chaque séjour.',
    floor: "Étage d'accès (0 = RDC, 1 = 1er étage, etc.)",
    nombreEtage: 'Nombre de niveaux intérieurs (1 = plain-pied, 2 = duplex, etc.)',
    elevator:
      "Le logement ou le bâtiment est équipé d'un ascenseur d'au moins 132 cm de profondeur avec une porte d'au moins 81 cm de largeur.",
    night_price:
      'Prix minimum par nuit (avant frais plateforme). Guestadom applique une augmentation automatique pour couvrir les frais des plateformes de réservation. ',
    night_stay:
      'Prix minimum par nuit (avant frais plateforme). Guestadom applique une augmentation automatique pour couvrir les frais des plateformes de réservation.',
    minimum_night_stay:
      "Durée minimale d'un séjour. Exemple : 2 nuits = aucune réservation d'une seule nuit acceptée. Cette règle s'applique toute l'année sauf exceptions.",
    last_minute:
      "Délai minimum avant l'arrivée pour qu'une réservation soit acceptée. Exemple : 7 nuits = le voyageur doit réserver au moins 7 nuits à l'avance. (Minimum obligatoire : 2 nuits)",
    nights_price:
      'Le prix minimum à la nuit est uniforme sur l’année, selon le montant que vous avez défini précédemment. Vous pouvez toutefois l’ajuster sur une période. Ce tarif s’appliquera alors sur tous les jours de la période.',
  },
  rooms: {
    add_room_living: 'Ajouter un salon',
    add_room_diner: 'Ajouter une salle à manger',
    add_room_bedroom: 'Ajouter une chambre',
    add_room_wc: 'Ajouter un WC',
    add_room_laundry: 'Ajouter une buanderie',
    add_room_kitchen: 'Ajouter une cuisine',
    add_room_office: 'Ajouter un bureau',
    add_room_bathroom: 'Ajouter une salle de bain',
    zone: {
      living: 'Emplacement du salon',
      diner: 'Emplacement de la salle à manger',
      bedroom: 'Emplacement de la chambre',
      wc: 'Emplacement des WC',
      laundry: 'Emplacement de la buanderie',
      kitchen: 'Emplacement de la cuisine',
      office: 'Emplacement du bureau',
      bathroom: 'Emplacement de la salle de bain',
    },
    name: {
      living: 'Nom du salon',
      diner: 'Nom de la salle à manger',
      bedroom: 'Nom de la chambre',
      wc: 'Nom des WC',
      laundry: 'Nom de la buanderie',
      kitchen: 'Nom de la cuisine',
      office: 'Nom du bureau',
      bathroom: 'Nom de la salle de bain',
    },
    title: {
      living: 'Salon',
      diner: 'Salle à manger',
      bedroom: 'Chambre',
      wc: 'WC',
      laundry: 'Buanderie',
      kitchen: 'Cuisine',
      office: 'Bureau',
      bathroom: 'Salle de bain',
    },
    none: {
      living: 'Aucun salon',
      diner: 'Aucune salle à manger',
      bedroom: 'Aucune chambre',
      wc: 'Aucun WC',
      laundry: 'Aucune buanderie',
      kitchen: 'Aucune cuisine',
      office: 'Aucun bureau',
      bathroom: 'Aucune salle de bain',
    },
    equipments: 'Équipements',
    furnitures: 'Meubles',
    beds: 'Lits',
  },
  accommodation_price: {
    error_period:
      "La date de début de votre nouvelle période commence dans une période déjà existante {0}. Il n'est pas possible de créer cette nouvelle période avant la fin de la période actuelle. Veuillez d'abord modifier la période précédente puis en créer une nouvelle.",
  },
  cancel_rule: {
    flexible: 'Flexible',
    flexible_desc: 'Les voyageurs peuvent annuler le jour même sans pénalités.',
    moderate: 'Modérée',
    moderate_desc: "Les voyageurs peuvent annuler 6 jours avant l'arrivée sans pénalités.",
    firm: 'Ferme',
    firm_desc: "Les voyageurs peuvent annuler 15 jours avant l'arrivée sans pénalités.",
    strict: 'Strict',
    strict_desc: "Les voyageurs peuvent annuler 31 jours avant l'arrivée sans pénalités.",
    none: "Pas d'annulation",
    none_desc: 'Les voyageurs ne peuvent pas annuler leur séjour sans pénalités.',
  },
  trace: {
    empty: 'Aucune activité',
    LOGIN: 'Connexion',
    RESET_PASSWORD: 'Réinitialisation du mot de passe',
    CREATE_AUTONOMOUS_ACCESS: 'Création du compte',
    ONBOARDING_CREATE: 'Onboarding crée',
    ONBOARDING_STEP1: 'Votre logement - Remplie',
    ONBOARDING_STEP2: 'Formule choisie {0}',
    ONBOARDING_STEP3: 'Vos réglages - Remplie',
    ONBOARDING_STEP4: 'Vos informations personnelles - Remplie',
    ONBOARDING_STEP5_INIT: 'Mandat de gestion - Généré',
    ONBOARDING_STEP5: 'Mandat de gestion - Signé',
    ONBOARDING_STEP6: 'CGS acceptées',
    ONBOARDING_DOCUMENT_RESUBMITTED: 'Documents rédéposés',
    ONBOARDING_DOCUMENT_VALIDATED: 'Documents validés',
    ONBOARDING_DOCUMENT_REFUSED: 'Documents refusés',
    ONBOARDING_FINISHED: 'Onboarding terminé',
    ONBOARDING_SYNC: 'Logement synchronisé',
    ANNUAL_REVENUE_OBJECTIVE: 'Objectif de revenu annuel modifié',
  },
  taxation: {
    title: 'Fiscalité',
  },
  developer: {
    update_history: 'Mettre à jour',
    airbnb_confirmation_code: 'Code de confirmation Airbnb',
    confirm_sync_dialog: 'Confirmer la synchronisation',
    confirm_sync_message: 'Êtes-vous sûr de vouloir synchroniser la réservation n°{0} ?',
    create_review: "Créer l'avis",
    confirm_create_review_dialog: 'Confirmer la synchronisation',
    confirm_create_review_message: 'Êtes-vous sûr de vouloir créer un avis pour la réservation n°{0} ?',
    smily_rule_ignored: 'Logement {0} : règle « {1} » ignorée ({2} {3})',
  },
  stats: {
    title: 'Statistiques',
  },
  ota_items_debug: {
    title: 'Ota items (debug)',
  },
  ota_message: {
    empty: 'Aucun modèle de message automatique.',
    type: {
      after_create: 'Après la création',
      before_arrival: "Avant l'arrivée",
      before_departure: 'Avant le départ',
      after_departure: 'Après le départ',
      query_received: 'Demande reçue',
      out_of_hours: "Hors horaires d'ouverture",
    },
  },
  guest_contact: {
    title: 'Vos coordonnées de contact',
    step: 'Étape {0} sur 2',
    find_title: 'Retrouver ma __réservation__',
    letters_instruction:
      "Saisissez les 3 premières lettres de votre nom de famille tel qu'il est indiqué sur votre réservation.",
    letters_example: 'BERTY Jean saisit « BER » et LI Wang saisit « LIW ».',
    error_invalid:
      'Attention, les informations saisies ne correspondent pas. Merci de vérifier les informations de votre réservation.',
    attempts_left: 'Il vous reste {0} essais.',
    last_attempt: 'Dernier essai : sinon le formulaire sera bloqué pendant 1 heure.',
    secure_share: 'Vos coordonnées sont partagées de manière sécurisée.',
    form_title: 'Vos __coordonnées__',
    form_intro: "Veuillez saisir le numéro de téléphone et l'adresse email de votre choix pour organiser votre séjour.",
    already_saved: 'Vos coordonnées ont été enregistrées le {0}. Vous pouvez les remplacer ci-\u2060dessous.',
    phone: 'Téléphone',
    phone_placeholder: '6 12 34 56 78',
    email: 'Email',
    email_placeholder: "nom{'@'}exemple.com",
    field_empty: 'Veuillez remplir ce champ.',
    phone_invalid: 'Le format du numéro de téléphone est incorrect.',
    email_invalid: "Le format de l'adresse email est incorrect.",
    submit: 'Envoyer mes coordonnées',
    update: 'Modifier mes coordonnées',
    submit_waiting: 'Envoi en cours',
    time_left: 'Il vous reste {0} pour envoyer vos coordonnées.',
    send_error:
      'Une erreur technique est survenue. Merci de rafraîchir votre page et de ressaisir vos informations. Notre service client se tient à votre disposition en cas de besoin.',
    privacy:
      "Vos coordonnées sont collectées par Guestadom, gestionnaire de ce logement pour le compte de votre hôte, afin de vous contacter pendant votre séjour. Elles sont transmises au concierge partenaire en charge du logement et conservées 12 mois après votre départ. Vous pouvez exercer vos droits d'accès, de rectification, d'effacement et d'opposition à {email}, et saisir la CNIL. ({policy})",
    offers:
      "J'accepte de recevoir par email les offres et bons plans de Guestadom. (Désinscription possible à tout moment)",
    privacy_policy: 'Politique de confidentialité - Gestion locative Guest Adom',
    success_title: 'Merci !',
    success_description:
      'Vos informations de contact ont bien été enregistrées. Nous allons vous contacter pour organiser votre arrivée. À bientôt !',
    close: 'Fermer la page',
    close_hint: 'Vous pouvez fermer cette page.',
    blocked_title: '5 tentatives de saisie incorrectes',
    blocked_description: "Merci de prendre contact avec notre service client pour débloquer l'accès.",
    expired_title: 'Votre session a expiré',
    expired_description: 'Merci de rafraîchir votre page et de ressaisir vos informations.',
    restart: 'Recommencer',
    inactive_title: 'Lien inactif',
    inactive_description: "Attention, le lien que vous utilisez n'est plus valide.",
    customer_service: 'Service client Guestadom',
    by_phone: 'Par téléphone : {0}',
    by_email: 'Par email : {0}',
    panel: {
      unlock: {
        title: 'Retrouver ma\n__réservation__',
        point1: 'Ce lien vous a été envoyé par Guestadom, dans la messagerie de votre réservation.',
        point2: 'Les 3 premières lettres de votre nom de famille suffisent à retrouver votre séjour.',
        point3: 'Nous ne vous demanderons jamais de paiement, de mot de passe ni de coordonnées bancaires.',
      },
      form: {
        title: 'Réservation\n__retrouvée__',
        point1: 'Votre séjour est retrouvé : vérifiez le logement et les dates.',
        point2: "Indiquez le téléphone et l'email où vous joindre pendant votre séjour.",
        point3: 'Vos coordonnées sont transmises uniquement à Guestadom.',
      },
      success: {
        title: 'À très\n__bientôt__',
        point1: 'Vos coordonnées sont bien enregistrées.',
        point2: 'Nous vous contacterons pour organiser votre arrivée.',
        point3: 'Vous pouvez rouvrir ce lien pour modifier vos coordonnées.',
      },
      expired: {
        title: 'Retrouver ma\n__réservation__',
        point1: 'Par sécurité, la saisie est limitée à 15 minutes.',
        point2: "Aucune coordonnée n'a été enregistrée.",
        point3: 'Recommencez : les 3 premières lettres de votre nom de famille suffisent.',
      },
      blocked: {
        title: "Besoin\n__d'aide__ ?",
        point1: 'Par sécurité, le formulaire est bloqué pendant 1 heure après 5 essais.',
        point2: 'Vérifiez le nom de famille indiqué sur votre réservation.',
        point3: 'Notre service client peut vous aider dès maintenant.',
      },
      inactive: {
        title: "Besoin\n__d'aide__ ?",
        point1: "Ce lien n'est plus valide.",
        point2: 'Pour toute question sur votre séjour, contactez notre service client.',
        point3: 'Gardez votre numéro de réservation à portée de main.',
      },
    },
  },
};
